import { defineMessages } from 'react-intl';
import enDefaults from '../translations/en.json';

export default defineMessages({
  hideForm: {
    id: 'app.boatDetails.hideForm',
    defaultMessage: enDefaults['app.boatDetails.hideForm']
  },
  AVAILABLE_SOON: {
    id: 'app.components.Listing.AVAILABLE_SOON.text',
    defaultMessage: 'Available Soon'
  },
  IN_STOCK: {
    id: 'app.components.Listing.IN_STOCK.text',
    defaultMessage: 'In-Stock'
  },
  SALE_PENDING: {
    id: 'app.components.Listing.SALE_PENDING.text',
    defaultMessage: 'Sale Pending'
  },
  NEW_ARRIVAL: {
    id: 'app.components.Listing.NEW_ARRIVAL.text',
    defaultMessage: 'New Arrival'
  },
  to: {
    id: 'app.general.to',
    defaultMessage: enDefaults['app.general.to']
  },
  more: {
    id: 'app.general.more',
    defaultMessage: enDefaults['app.general.more']
  },
  new: {
    id: 'app.general.new',
    defaultMessage: enDefaults['app.general.new']
  },
  dealer: {
    id: 'app.general.dealer',
    defaultMessage: enDefaults['app.general.dealer']
  },
  owner: {
    id: 'app.general.owner',
    defaultMessage: enDefaults['app.general.owner']
  },
  rep: {
    id: 'app.general.rep',
    defaultMessage: enDefaults['app.general.rep']
  },
  fsbo: {
    id: 'app.general.fsbo',
    defaultMessage: enDefaults['app.general.fsbo']
  },
  used: {
    id: 'app.general.used',
    defaultMessage: enDefaults['app.general.used']
  },
  address: {
    id: 'app.general.address',
    defaultMessage: enDefaults['app.general.address']
  },
  all: {
    id: 'app.general.all',
    defaultMessage: enDefaults['app.general.all']
  },
  length: {
    id: 'app.general.length',
    defaultMessage: enDefaults['app.general.length']
  },
  exact: {
    id: 'app.general.exact',
    defaultMessage: enDefaults['app.general.exact']
  },
  uom: {
    ft: {
      id: 'app.general.uom.ft',
      defaultMessage: enDefaults['app.general.uom.ft']
    },
    hp: {
      id: 'app.general.uom.hp',
      defaultMessage: enDefaults['app.general.uom.hp']
    },
    kW: {
      id: 'app.general.uom.kW',
      defaultMessage: enDefaults['app.general.uom.kW']
    },
    m: {
      id: 'app.general.uom.m',
      defaultMessage: enDefaults['app.general.uom.m']
    },
    radius: {
      name: {
        id: 'app.general.uom.radius.name',
        defaultMessage: enDefaults['app.general.uom.radius.name']
      },
      abbr: {
        id: 'app.general.uom.radius.abbr',
        defaultMessage: enDefaults['app.general.uom.radius.abbr']
      }
    }
  },
  cancel: {
    id: 'app.general.cancel',
    defaultMessage: enDefaults['app.general.cancel']
  },
  listings: {
    id: 'app.general.listings',
    defaultMessage: enDefaults['app.general.listings']
  },
  details: {
    id: 'app.components.details',
    defaultMessage: enDefaults['app.components.details']
  },
  contactSalesRep: {
    id: 'app.components.contactSalesRep',
    defaultMessage: enDefaults['app.components.contactSalesRep']
  },
  description: {
    id: 'app.components.description',
    defaultMessage: enDefaults['app.components.description']
  },
  measurements: {
    id: 'app.components.measurements',
    defaultMessage: enDefaults['app.components.measurements']
  },
  propulsion: {
    id: 'app.components.propulsion',
    defaultMessage: enDefaults['app.components.propulsion']
  },
  features: {
    id: 'app.components.features',
    defaultMessage: enDefaults['app.components.features']
  },
  moreDetails: {
    id: 'app.components.moreDetails',
    defaultMessage: enDefaults['app.components.moreDetails']
  },
  servicesDetails: {
    id: 'app.components.servicesDetails',
    defaultMessage: enDefaults['app.components.servicesDetails']
  },
  nearbyListings: {
    paragraph1: {
      id: 'app.components.similarListings.city.paragraph1',
      defaultMessage:
        enDefaults['app.components.similarListings.city.paragraph1']
    },
    paragraph2: {
      id: 'app.components.similarListings.city.paragraph2',
      defaultMessage:
        enDefaults['app.components.similarListings.city.paragraph2']
    }
  },
  similarModelBoats: {
    paragraph1: {
      id: 'app.components.similarListings.model.paragraph1',
      defaultMessage:
        enDefaults['app.components.similarListings.model.paragraph1']
    },
    paragraph2: {
      id: 'app.components.similarListings.city.paragraph2',
      defaultMessage:
        enDefaults['app.components.similarListings.model.paragraph2']
    }
  },
  services: {
    insurance: {
      id: 'app.components.services.insurance',
      defaultMessage: enDefaults['app.components.services.insurance']
    },
    finance: {
      id: 'app.components.services.finance',
      defaultMessage: enDefaults['app.components.services.finance']
    },
    financeYourBoat: {
      id: 'app.components.services.financeYourBoat',
      defaultMessage: enDefaults['app.components.services.financeYourBoat']
    },
    financeYourEngine: {
      id: 'app.components.services.financeYourEngine',
      defaultMessage: enDefaults['app.components.services.financeYourEngine']
    },
    transport: {
      id: 'app.components.services.transport',
      defaultMessage: enDefaults['app.components.services.transport']
    },
    warranty: {
      id: 'app.components.services.warranty',
      defaultMessage: enDefaults['app.components.services.warranty']
    }
  },
  technicalSpecificationsOEMs: {
    title: {
      id: 'app.components.technicalSpecificationsOEMs.title',
      defineMessage:
        enDefaults['app.components.technicalSpecificationsOEMs.title']
    }
  },
  videoDetails: {
    id: 'app.components.videoDetails',
    defaultMessage: enDefaults['app.components.videoDetails']
  },
  moreFromDealer: {
    id: 'app.components.moreFromDealer',
    defaultMessage: enDefaults['app.components.moreFromDealer']
  },
  moreFromManufacturer: {
    id: 'app.components.moreFromManufacturer',
    defaultMessage: enDefaults['app.components.moreFromManufacturer']
  },
  brokerInformation: {
    id: 'app.components.brokerInformation',
    defaultMessage: enDefaults['app.components.brokerInformation']
  },
  brokerListings: {
    id: 'app.components.brokerListings',
    defaultMessage: enDefaults['app.components.brokerListings']
  },
  immersiveTour: {
    id: 'app.components.immersiveTour',
    defaultMessage: enDefaults['app.components.immersiveTour']
  },
  viewDealerWebsite: {
    id: 'app.components.viewDealerWebsite',
    defaultMessage: enDefaults['app.components.viewDealerWebsite']
  },
  viewManufacturerWebsite: {
    id: 'app.components.viewManufacturerWebsite',
    defaultMessage: enDefaults['app.components.viewManufacturerWebsite']
  },
  showMore: {
    id: 'app.descriptionBox.showMore',
    defaultMessage: enDefaults['app.descriptionBox.showMore']
  },
  showLess: {
    id: 'app.descriptionBox.showLess',
    defaultMessage: enDefaults['app.descriptionBox.showLess']
  },
  power: {
    id: 'app.types.power',
    defaultMessage: enDefaults['app.types.power']
  },
  sail: {
    id: 'app.types.sail',
    defaultMessage: enDefaults['app.types.sail']
  },
  unpowered: {
    id: 'app.types.unpowered',
    defaultMessage: enDefaults['app.types.unpowered']
  },
  home: {
    id: 'app.home',
    defaultMessage: enDefaults['app.home'],
    connect: {
      id: 'app.home.social.connect',
      defaultMessage: enDefaults['app.home.social.connect']
    },
    download: {
      id: 'app.home.social.download',
      defaultMessage: enDefaults['app.home.social.download']
    }
  },
  hero: {
    heroImage: {
      id: 'app.home.hero.image',
      defaultMessage: enDefaults['app.home.hero.image']
    },
    heroLearnMore: {
      id: 'app.home.hero.learnMore',
      defaultMessage: enDefaults['app.home.hero.learnMore']
    },
    heroPresentedBy: {
      id: 'app.home.hero.presentedBy',
      defaultMessage: enDefaults['app.home.hero.presentedBy']
    }
  },
  defaultNotFoundImage: {
    id: 'app.default.not.found.image',
    defaultMessage: enDefaults['app.default.not.found.image']
  },
  fsboAd: {
    fsboTitle: {
      id: 'app.fsbo.ad.title',
      defaultMessage: enDefaults['app.fsbo.ad.title']
    },
    fsboMessage: {
      id: 'app.fsbo.ad.message',
      defaultMessage: enDefaults['app.fsbo.ad.message']
    },
    alt: {
      id: 'app.fsbo.ad.alt',
      defaultMessage: enDefaults['app.fsbo.ad.alt']
    },
    button: {
      id: 'app.fsbo.ad.button',
      defaultMessage: enDefaults['app.fsbo.ad.button']
    },
    fsboTitleShort: {
      id: 'app.fsbo.ad.title.short',
      defaultMessage: enDefaults['app.fsbo.ad.title.short']
    },
    buttonShort: {
      id: 'app.fsbo.ad.button.short',
      defaultMessage: enDefaults['app.fsbo.ad.button.short']
    }
  },
  quickLinks: {
    popular: {
      id: 'app.home.quickLinks.popular',
      defaultMessage: enDefaults['app.home.quickLinks.popular']
    }
  },
  quickSearch: {
    title: {
      id: 'app.home.quickSearch.title',
      defaultMessage: enDefaults['app.home.quickSearch.title']
    },
    powerBoats: {
      id: 'app.home.quickSearch.powerBoats',
      defaultMessage: enDefaults['app.home.quickSearch.powerBoats']
    },
    sailBoats: {
      id: 'app.home.quickSearch.sailBoats',
      defaultMessage: enDefaults['app.home.quickSearch.sailBoats']
    },
    makeModelDropdown: {
      id: 'app.home.quickSearch.makeModel.dropdown',
      defaultMessage: enDefaults['app.home.quickSearch.makeModel.dropdown']
    },
    makeModelErrorMessage: {
      id: 'app.home.quickSearch.makeModel.error',
      defaultMessage: enDefaults['app.home.quickSearch.makeModel.error']
    },
    uoms: {
      ft: {
        id: 'app.search.uoms.ft',
        defaultMessage: enDefaults['app.search.uoms.ft']
      },
      m: {
        id: 'app.search.uoms.m',
        defaultMessage: enDefaults['app.search.uoms.m']
      }
    },
    showLess: {
      id: 'app.search.show.less',
      defaultMessage: enDefaults['app.search.show.less']
    },
    showMore: {
      id: 'app.search.show.more',
      defaultMessage: enDefaults['app.search.show.more']
    },
    powerAll: {
      id: 'app.home.quickSearch.power-all',
      defaultMessage: enDefaults['app.home.quickSearch.power-all']
    },
    sailAll: {
      id: 'app.home.quickSearch.sail-all',
      defaultMessage: enDefaults['app.home.quickSearch.sail-all']
    },
    max: {
      id: 'app.home.quickSearch.max',
      defaultMessage: enDefaults['app.home.quickSearch.max']
    },
    min: {
      id: 'app.home.quickSearch.min',
      defaultMessage: enDefaults['app.home.quickSearch.min']
    }
  },
  homeBlogSection: {
    title: {
      id: 'app.home.blog.title',
      defaultMessage: enDefaults['app.home.blog.title']
    },
    readMore: {
      id: 'app.home.blog.readMore',
      defaultMessage: enDefaults['app.home.blog.readMore']
    }
  },
  homeBuyingSection: {
    title: {
      id: 'app.home.buyingExperience.title',
      defaultMessage: enDefaults['app.home.buyingExperience.title']
    },
    buying: {
      excerpt: {
        id: 'app.home.buyingExperience.buying.excerpt',
        defaultMessage: enDefaults['app.home.buyingExperience.buying.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.buying.title',
        defaultMessage: enDefaults['app.home.buyingExperience.buying.title']
      },
      url: {
        id: 'app.home.buyingExperience.buying.url',
        defaultMessage: enDefaults['app.home.buyingExperience.buying.url']
      }
    },
    directory: {
      excerpt: {
        id: 'app.home.buyingExperience.directory.excerpt',
        defaultMessage:
          enDefaults['app.home.buyingExperience.directory.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.directory.title',
        defaultMessage: enDefaults['app.home.buyingExperience.directory.title']
      },
      url: {
        id: 'app.home.buyingExperience.directory.url',
        defaultMessage: enDefaults['app.home.buyingExperience.directory.url']
      }
    },
    more: {
      id: 'app.home.buyingExperience.more',
      defaultMessage: enDefaults['app.home.buyingExperience.more']
    },
    research: {
      excerpt: {
        id: 'app.home.buyingExperience.research.excerpt',
        defaultMessage: enDefaults['app.home.buyingExperience.research.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.research.title',
        defaultMessage: enDefaults['app.home.buyingExperience.research.title']
      },
      url: {
        id: 'app.home.buyingExperience.research.url',
        defaultMessage: enDefaults['app.home.buyingExperience.research.url']
      }
    },
    searchAlerts: {
      excerpt: {
        id: 'app.home.buyingExperience.searchAlerts.excerpt',
        defaultMessage:
          enDefaults['app.home.buyingExperience.searchAlerts.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.searchAlerts.title',
        defaultMessage:
          enDefaults['app.home.buyingExperience.searchAlerts.title']
      },
      url: {
        id: 'app.home.buyingExperience.searchAlerts.url',
        defaultMessage: enDefaults['app.home.buyingExperience.searchAlerts.url']
      }
    },
    selling: {
      excerpt: {
        id: 'app.home.buyingExperience.selling.excerpt',
        defaultMessage: enDefaults['app.home.buyingExperience.selling.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.selling.title',
        defaultMessage: enDefaults['app.home.buyingExperience.selling.title']
      },
      url: {
        id: 'app.home.buyingExperience.selling.url',
        defaultMessage: enDefaults['app.home.buyingExperience.selling.url']
      }
    },
    services: {
      excerpt: {
        id: 'app.home.buyingExperience.services.excerpt',
        defaultMessage: enDefaults['app.home.buyingExperience.services.excerpt']
      },
      title: {
        id: 'app.home.buyingExperience.services.title',
        defaultMessage: enDefaults['app.home.buyingExperience.services.title']
      },
      url: {
        id: 'app.home.buyingExperience.services.url',
        defaultMessage: enDefaults['app.home.buyingExperience.services.url']
      }
    }
  },
  homeForumSection: {
    title: {
      id: 'app.home.forum.title',
      defaultMessage: enDefaults['app.home.forum.title']
    },
    button: {
      id: 'app.home.forum.button',
      defaultMessage: enDefaults['app.home.forum.button']
    },
    link: {
      id: 'app.home.forum.link',
      defaultMessage: enDefaults['app.home.forum.link']
    }
  },
  featured: {
    id: 'app.home.featured',
    defaultMessage: enDefaults['app.home.featured']
  },
  featuredBoats: {
    id: 'app.home.featuredBoats',
    defaultMessage: enDefaults['app.home.featuredBoats']
  },
  featuredPrivateListings: {
    id: 'app.home.featuredPrivateListings',
    defaultMessage: enDefaults['app.home.featuredPrivateListings']
  },
  latestBoats: {
    id: 'app.home.latestBoats',
    defaultMessage: enDefaults['app.home.latestBoats']
  },
  viewAllBoats: {
    id: 'app.home.viewAllBoats',
    defaultMessage: enDefaults['app.home.viewAllBoats']
  },
  healthcheckTitle: {
    id: 'app.healthcheck.title',
    defaultMessage: enDefaults['app.healthcheck.title']
  },
  healthcheckMessage: {
    id: 'app.healthcheck.message',
    defaultMessage: enDefaults['app.healthcheck.message']
  },
  header: {
    home: {
      id: 'app.header.nav.home',
      defaultMessage: enDefaults['app.header.nav.home']
    },
    buy: {
      id: 'app.header.nav.buy',
      defaultMessage: enDefaults['app.header.nav.buy']
    },
    all: {
      id: 'app.header.nav.all',
      defaultMessage: enDefaults['app.header.nav.all']
    },
    powerBoats: {
      id: 'app.header.nav.power-all',
      defaultMessage: enDefaults['app.header.nav.power-all']
    },
    powerUsed: {
      id: 'app.header.nav.power-used',
      defaultMessage: enDefaults['app.header.nav.power-used']
    },
    unpoweredBoats: {
      id: 'app.header.nav.unpowered-all',
      defaultMessage: enDefaults['app.header.nav.unpowered-all']
    },
    unpoweredUsed: {
      id: 'app.header.nav.unpowered-used',
      defaultMessage: enDefaults['app.header.nav.unpowered-used']
    },
    powerRib: {
      id: 'app.header.nav.power-rib',
      defaultMessage: enDefaults['app.header.nav.power-rib']
    },
    powerCruiser: {
      id: 'app.header.nav.power-cruiser',
      defaultMessage: enDefaults['app.header.nav.power-cruiser']
    },
    powerMotor: {
      id: 'app.header.nav.power-motor',
      defaultMessage: enDefaults['app.header.nav.power-motor']
    },
    powerSaltfish: {
      id: 'app.header.nav.power-saltfish',
      defaultMessage: enDefaults['app.header.nav.power-saltfish']
    },
    powerNarrow: {
      id: 'app.header.nav.power-narrow',
      defaultMessage: enDefaults['app.header.nav.power-narrow']
    },
    powerAntique: {
      id: 'app.header.nav.power-antique',
      defaultMessage: enDefaults['app.header.nav.power-antique']
    },
    sailCruiser: {
      id: 'app.header.nav.sail-cruiser',
      defaultMessage: enDefaults['app.header.nav.sail-cruiser']
    },
    sailRacer: {
      id: 'app.header.nav.sail-racer',
      defaultMessage: enDefaults['app.header.nav.sail-racer']
    },
    sailCatamaran: {
      id: 'app.header.nav.sail-catamaran',
      defaultMessage: enDefaults['app.header.nav.sail-catamaran']
    },
    sailMotor: {
      id: 'app.header.nav.sail-motor',
      defaultMessage: enDefaults['app.header.nav.sail-motor']
    },
    sailDay: {
      id: 'app.header.nav.sail-day',
      defaultMessage: enDefaults['app.header.nav.sail-day']
    },
    powerInflatable: {
      id: 'app.header.nav.power-inflatable',
      defaultMessage: enDefaults['app.header.nav.power-inflatable']
    },
    unpoweredDinghy: {
      id: 'app.header.nav.power-dinghy',
      defaultMessage: enDefaults['app.header.nav.power-dinghy']
    },
    powerAluminum: {
      id: 'app.header.nav.power-aluminum',
      defaultMessage: enDefaults['app.header.nav.power-aluminum']
    },
    powerPwc: {
      id: 'app.header.nav.power-pwc',
      defaultMessage: enDefaults['app.header.nav.power-pwc']
    },
    unpoweredKayak: {
      id: 'app.header.nav.unpowered-kayak',
      defaultMessage: enDefaults['app.header.nav.unpowered-kayak']
    },
    powerCuddy: {
      id: 'app.header.nav.power-cuddy',
      defaultMessage: enDefaults['app.header.nav.power-cuddy']
    },
    powerRunabout: {
      id: 'app.header.nav.power-runabout',
      defaultMessage: enDefaults['app.header.nav.power-runabout']
    },
    powerTender: {
      id: 'app.header.nav.power-tender',
      defaultMessage: enDefaults['app.header.nav.power-tender']
    },
    motorYachts: {
      id: 'app.header.nav.motorYachts',
      defaultMessage: enDefaults['app.header.nav.motorYachts']
    },
    houseBoats: {
      id: 'app.header.nav.power-house',
      defaultMessage: enDefaults['app.header.nav.power-house']
    },
    highPerformanceBoats: {
      id: 'app.header.nav.highPerformanceBoats',
      defaultMessage: enDefaults['app.header.nav.highPerformanceBoats']
    },
    freshwaterFishing: {
      id: 'app.header.nav.freshwaterFishing',
      defaultMessage: enDefaults['app.header.nav.freshwaterFishing']
    },
    inflatableBoats: {
      id: 'app.header.nav.inflatableBoats',
      defaultMessage: enDefaults['app.header.nav.inflatableBoats']
    },
    powerLlaut: {
      id: 'app.header.nav.power-llaut',
      defaultMessage: enDefaults['app.header.nav.power-llaut']
    },
    keywordSearch: {
      id: 'app.header.nav.keywordSearch',
      defaultMessage: enDefaults['app.header.nav.keywordSearch']
    },
    powerSloop: {
      id: 'app.header.nav.power-sloop',
      defaultMessage: enDefaults['app.header.nav.power-sloop']
    },
    sailboats: {
      id: 'app.header.nav.sail-all',
      defaultMessage: enDefaults['app.header.nav.sail-all']
    },
    sailUsed: {
      id: 'app.header.nav.sail-used',
      defaultMessage: enDefaults['app.header.nav.sail-used']
    },
    sailingYachts: {
      id: 'app.header.nav.sailingYachts',
      defaultMessage: enDefaults['app.header.nav.sailingYachts']
    },
    multihull: {
      id: 'app.header.nav.sail-multihull',
      defaultMessage: enDefaults['app.header.nav.sail-multihull']
    },
    sailSloop: {
      id: 'app.header.nav.sail-sloop',
      defaultMessage: enDefaults['app.header.nav.sail-sloop']
    },
    sailDinghy: {
      id: 'app.header.nav.sail-dinghy',
      defaultMessage: enDefaults['app.header.nav.sail-dinghy']
    },
    classicSailboats: {
      id: 'app.header.nav.sail-antique',
      defaultMessage: enDefaults['app.header.nav.sail-antique']
    },
    boatsForSale: {
      id: 'app.header.nav.boatsForSale',
      defaultMessage: enDefaults['app.header.nav.boatsForSale']
    },
    boats: {
      id: 'app.header.nav.boats',
      defaultMessage: enDefaults['app.header.nav.boats']
    },
    newBoatsForSale: {
      id: 'app.header.nav.newBoatsForSale',
      defaultMessage: enDefaults['app.header.nav.newBoatsForSale']
    },
    usedBoatsForSale: {
      id: 'app.header.nav.usedBoatsForSale',
      defaultMessage: enDefaults['app.header.nav.usedBoatsForSale']
    },
    powerBoatsForSale: {
      id: 'app.header.nav.powerBoatsForSale',
      defaultMessage: enDefaults['app.header.nav.powerBoatsForSale']
    },
    sailBoatsForSale: {
      id: 'app.header.nav.sailBoatsForSale',
      defaultMessage: enDefaults['app.header.nav.sailBoatsForSale']
    },
    enginesForSale: {
      id: 'app.header.nav.enginesForSale',
      defaultMessage: enDefaults['app.header.nav.enginesForSale']
    },
    newEnginesForSale: {
      id: 'app.header.nav.newEnginesForSale',
      defaultMessage: enDefaults['app.header.nav.newEnginesForSale']
    },
    usedEnginesForSale: {
      id: 'app.header.nav.usedEnginesForSale',
      defaultMessage: enDefaults['app.header.nav.usedEnginesForSale']
    },
    services: {
      id: 'app.header.nav.services',
      defaultMessage: enDefaults['app.header.nav.services']
    },
    techSheet: {
      id: 'app.header.nav.techSheet',
      defaultMessage: enDefaults['app.header.nav.techSheet']
    },
    portPlace: {
      id: 'app.header.nav.portPlace',
      defaultMessage: enDefaults['app.header.nav.portPlace']
    },
    boatRental: {
      id: 'app.header.nav.boatRental',
      defaultMessage: enDefaults['app.header.nav.boatRental']
    },
    resources: {
      id: 'app.header.nav.resources',
      defaultMessage: enDefaults['app.header.nav.resources']
    },
    blog: {
      id: 'app.header.nav.blog',
      defaultMessage: enDefaults['app.header.nav.blog']
    },
    boating: {
      id: 'app.header.nav.boating',
      defaultMessage: enDefaults['app.header.nav.boating']
    },
    reviews: {
      id: 'app.header.nav.reviews',
      defaultMessage: enDefaults['app.header.nav.reviews']
    },
    buying: {
      id: 'app.header.nav.buying',
      defaultMessage: enDefaults['app.header.nav.buying']
    },
    selling: {
      id: 'app.header.nav.selling',
      defaultMessage: enDefaults['app.header.nav.selling']
    },
    boatEngine: {
      id: 'app.header.nav.boatEngine',
      defaultMessage: enDefaults['app.header.nav.boatEngine']
    },
    boatTrailer: {
      id: 'app.header.nav.boatTrailer',
      defaultMessage: enDefaults['app.header.nav.boatTrailer']
    },
    boatAccessory: {
      id: 'app.header.nav.boatAccessory',
      defaultMessage: enDefaults['app.header.nav.boatAccessory']
    },
    boatTransport: {
      id: 'app.header.nav.boatTransport',
      defaultMessage: enDefaults['app.header.nav.boatTransport']
    },
    sell: {
      id: 'app.header.nav.sell',
      defaultMessage: enDefaults['app.header.nav.sell']
    },
    sellBoats: {
      id: 'app.header.nav.sell-boats',
      defaultMessage: enDefaults['app.header.nav.sell-boats']
    },
    sellEngines: {
      id: 'app.header.nav.sell-engines',
      defaultMessage: enDefaults['app.header.nav.sell-engines']
    },
    toggle: {
      id: 'app.header.nav.toggle',
      defaultMessage: enDefaults['app.header.nav.toggle']
    },
    partySearch: {
      id: 'app.header.nav.partySearch',
      defaultMessage: enDefaults['app.header.nav.partySearch']
    },
    callToAction: {
      id: 'app.header.nav.callToAction',
      defaultMessage: enDefaults['app.header.nav.callToAction']
    },
    personalBoatShopper: {
      id: 'app.header.nav.personalBoatShopper',
      defaultMessage: enDefaults['app.header.nav.personalBoatShopper']
    },
    boatDealers: {
      id: 'app.header.nav.boatDealers',
      defaultMessage: enDefaults['app.header.nav.boatDealers']
    },
    yachtBrokers: {
      id: 'app.header.nav.yachtBrokers',
      defaultMessage: enDefaults['app.header.nav.yachtBrokers']
    },
    yachtBrokersAlt: {
      id: 'app.header.nav.yachtBrokersAlt',
      defaultMessage: enDefaults['app.header.nav.yachtBrokersAlt']
    },
    surveyors: {
      id: 'app.header.nav.surveyors',
      defaultMessage: enDefaults['app.header.nav.surveyors']
    },
    boatLoans: {
      id: 'app.header.nav.boatLoans',
      defaultMessage: enDefaults['app.header.nav.boatLoans']
    },
    yachtLoansCalculator: {
      id: 'app.header.nav.yachtLoansCalculator',
      defaultMessage: enDefaults['app.header.nav.yachtLoansCalculator']
    },
    insurance: {
      id: 'app.header.nav.insurance',
      defaultMessage: enDefaults['app.header.nav.insurance']
    },
    directory: {
      id: 'app.header.nav.directory',
      defaultMessage: enDefaults['app.header.nav.directory']
    },
    search: {
      id: 'app.header.nav.search',
      defaultMessage: enDefaults['app.header.nav.search']
    },
    boatEngines: {
      id: 'app.header.nav.boatEngine',
      defaultMessage: enDefaults['app.header.nav.boatEngine']
    },
    outboardEngine: {
      id: 'app.header.nav.outboard',
      defaultMessage: enDefaults['app.header.nav.outboard']
    },
    inboardEngine: {
      id: 'app.header.nav.inboard',
      defaultMessage: enDefaults['app.header.nav.inboard']
    },
    sternDriveEngine: {
      id: 'app.header.nav.stern-drive',
      defaultMessage: enDefaults['app.header.nav.stern-drive']
    },
    jetEngine: {
      id: 'app.header.nav.jet',
      defaultMessage: enDefaults['app.header.nav.jet']
    },
    electricEngines: {
      id: 'app.header.nav.electric-engine',
      defaultMessage: enDefaults['app.header.nav.electric-engine']
    },
    powerFlats: {
      id: 'app.header.nav.power-flats',
      defaultMessage: enDefaults['app.header.nav.power-flats']
    },
    sailYawl: {
      id: 'app.header.nav.sail-yawl',
      defaultMessage: enDefaults['app.header.nav.sail-yawl']
    },
    powerPilot: {
      id: 'app.header.nav.power-pilot',
      defaultMessage: enDefaults['app.header.nav.power-pilot']
    },
    powerBowrider: {
      id: 'app.header.nav.power-bowrider',
      defaultMessage: enDefaults['app.header.nav.power-bowrider']
    },
    powerFresh: {
      id: 'app.header.nav.power-fresh',
      defaultMessage: enDefaults['app.header.nav.power-fresh']
    },
    popularBoats: {
      id: 'app.header.nav.popularBoats',
      defaultMessage: enDefaults['app.header.nav.popularBoats']
    },
    yachts: {
      id: 'app.header.nav.yachts',
      defaultMessage: enDefaults['app.header.nav.yachts']
    },
    launches: {
      id: 'app.header.nav.launches',
      defaultMessage: enDefaults['app.header.nav.launches']
    },
    sloopSailBoats: {
      id: 'app.header.nav.sloopSailBoats',
      defaultMessage: enDefaults['app.header.nav.sloopSailBoats']
    },
    sportsBoats: {
      id: 'app.header.nav.power-highperf',
      defaultMessage: enDefaults['app.header.nav.power-highperf']
    },
    electricBoats: {
      id: 'app.header.nav.fuel-electric',
      defaultMessage: enDefaults['app.header.nav.fuel-electric']
    },
    motorSailers: {
      id: 'app.header.nav.power-motorsailer',
      defaultMessage: enDefaults['app.header.nav.power-motorsailer']
    },
    classicYachts: {
      id: 'app.header.nav.power-antique',
      defaultMessage: enDefaults['app.header.nav.power-antique']
    },
    powerCommercial: {
      id: 'app.header.nav.power-commercial',
      defaultMessage: enDefaults['app.header.nav.power-commercial']
    }
  },
  banner: {
    download: {
      close: {
        id: 'app.banner.download.close',
        defaultMessage: enDefaults['app.banner.download.close']
      },
      description: {
        id: 'app.banner.download.description',
        defaultMessage: enDefaults['app.banner.download.description']
      },
      open: {
        id: 'app.banner.download.open',
        defaultMessage: enDefaults['app.banner.download.open']
      },
      title: {
        id: 'app.banner.download.title',
        defaultMessage: enDefaults['app.banner.download.title']
      }
    }
  },
  searchTitle: {
    id: 'app.search.title',
    defaultMessage: enDefaults['app.search.title']
  },
  homePageSEO: {
    h1: {
      id: 'app.homePageSEO.h1',
      defaultMessage: enDefaults['app.homePageSEO.h1']
    },
    metaElements: {
      title: {
        id: 'app.homePageSEO.metaElements.title',
        defaultMessage: enDefaults['app.homePageSEO.metaElements.title']
      },
      description: {
        id: 'app.homePageSEO.metaElements.description',
        defaultMessage: enDefaults['app.homePageSEO.metaElements.description']
      }
    }
  },
  searchPageSEO: {
    indexableFacets: {
      condition: {
        new: {
          id: 'app.searchPageSEO.indexableFacets.condition.new',
          defaultMessage:
            enDefaults['app.searchPageSEO.indexableFacets.condition.new']
        },
        used: {
          id: 'app.searchPageSEO.indexableFacets.condition.used',
          defaultMessage:
            enDefaults['app.searchPageSEO.indexableFacets.condition.used']
        }
      }
    },
    interestingInformation: {
      link: {
        id: 'app.searchPageSEO.interestingInformation.link',
        defaultMessage:
          enDefaults['app.searchPageSEO.interestingInformation.link']
      }
    },
    metaElements: {
      title: {
        id: 'app.searchPageSEO.metaElements.title',
        defaultMessage: enDefaults['app.searchPageSEO.metaElements.title']
      },
      description: {
        id: 'app.searchPageSEO.metaElements.description',
        defaultMessage: enDefaults['app.searchPageSEO.metaElements.description']
      },
      dynamicDescription: {
        id: 'app.searchPageSEO.metaElements.dynamicDescription',
        defaultMessage:
          enDefaults['app.searchPageSEO.metaElements.dynamicDescription'],
        intro: {
          id: 'app.searchPageSEO.metaElements.dynamicDescription.intro',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.dynamicDescription.intro'
            ]
        },
        outro: {
          id: 'app.searchPageSEO.metaElements.dynamicDescription.outro',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.dynamicDescription.outro'
            ]
        },
        location: {
          id: 'app.searchPageSEO.metaElements.dynamicDescription.location',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.dynamicDescription.location'
            ]
        },
        generalLocation: {
          id: 'app.searchPageSEO.metaElements.dynamicDescription.generalLocation',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.dynamicDescription.generalLocation'
            ]
        }
      },
      dynamicTitle: {
        id: 'app.searchPageSEO.metaElements.dynamicTitle',
        defaultMessage:
          enDefaults['app.searchPageSEO.metaElements.dynamicTitle'],
        intro: {
          id: 'app.searchPageSEO.metaElements.dynamicTitle.intro',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.dynamicTitle.intro']
        },
        location: {
          id: 'app.searchPageSEO.metaElements.dynamicTitle.location',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.dynamicTitle.location']
        }
      },
      condition: {
        title: {
          id: 'app.searchPageSEO.metaElements.condition.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.condition.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.condition.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.condition.description']
        },
        type: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.type.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.condition.type.title']
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.city.title'
                ]
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.country.title'
                ]
            }
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.type.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.type.description'
              ]
          },
          class: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.class.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.class.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.type.class.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.class.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.city.title'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.country.title'
                  ]
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.hullMaterial.description'
                  ]
              }
            },
            make: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.make.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.make.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.make.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.make.description'
                  ]
              },
              model: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.model.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.model.description'
                    ]
                },
                sellerType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.description'
                      ]
                  },
                  region: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.description'
                        ]
                    },
                    fuelType: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.fuelType.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.fuelType.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.fuelType.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.fuelType.description'
                          ]
                      }
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.region.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  subdivision: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.description'
                        ]
                    },
                    fuelType: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.fuelType.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.fuelType.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.fuelType.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.fuelType.description'
                          ]
                      }
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.subdivision.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  country: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.description'
                        ]
                    },
                    fuelType: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.fuelType.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.fuelType.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.fuelType.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.fuelType.description'
                          ]
                      }
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.country.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  city: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.description'
                        ]
                    },
                    fuelType: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.fuelType.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.fuelType.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.fuelType.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.fuelType.description'
                          ]
                      }
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.city.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.sellerType.hullMaterial.description'
                        ]
                    }
                  }
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.region.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.region.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.region.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.country.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.country.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.country.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.city.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.city.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.city.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.model.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.model.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.model.hullMaterial.description'
                      ]
                  }
                }
              },
              modelRange: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.description'
                    ]
                },
                sellerType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.description'
                      ]
                  },
                  region: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.description'
                        ]
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.region.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  subdivision: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.description'
                        ]
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.subdivision.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  country: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.description'
                        ]
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.country.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  city: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.description'
                        ]
                    },
                    hullMaterial: {
                      title: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.hullMaterial.title',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.hullMaterial.title'
                          ]
                      },
                      description: {
                        id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.hullMaterial.description',
                        defaultMessage:
                          enDefaults[
                            'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.city.hullMaterial.description'
                          ]
                      }
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.sellerType.hullMaterial.description'
                        ]
                    }
                  }
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.modelRange.hullMaterial.description'
                      ]
                  }
                }
              },
              sellerType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.class.make.sellerType.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.make.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.make.hullMaterial.description'
                    ]
                }
              }
            },
            sellerType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.sellerType.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.sellerType.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.sellerType.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.sellerType.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.class.sellerType.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.class.sellerType.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.subdivision.title'
                  ]
              }
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.class.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.class.region.title'
                  ]
              }
            }
          },
          make: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.make.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.make.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.type.make.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.make.description'
                ]
            },
            model: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.model.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.model.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.model.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.model.description'
                  ]
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.model.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.model.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.model.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.model.hullMaterial.description'
                    ]
                }
              }
            },
            modelRange: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.modelRange.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.modelRange.description'
                  ]
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.type.make.modelRange.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.type.make.modelRange.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.type.make.modelRange.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.make.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.make.hullMaterial.description'
                  ]
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.type.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.sellerType.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.sellerType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.sellerType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.sellerType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.sellerType.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.type.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.type.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.type.sellerType.hullMaterial.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.type.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.type.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.hullMaterial.description'
                ]
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.type.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.type.subdivision.title'
                ]
            }
          }
        },
        group: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.group.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.condition.group.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.group.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.group.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.group.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.group.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.group.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.group.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.hullMaterial.description'
                ]
            }
          },
          make: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.group.make.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.make.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.group.make.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.make.description'
                ]
            },
            model: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.model.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.model.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.model.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.model.description'
                  ]
              },
              sellerType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.description'
                    ]
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.sellerType.hullMaterial.description'
                      ]
                  }
                }
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.model.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.model.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.model.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.model.hullMaterial.description'
                    ]
                }
              }
            },
            modelRange: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.modelRange.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.modelRange.description'
                  ]
              },
              sellerType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.description'
                    ]
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.description'
                      ]
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.sellerType.hullMaterial.description'
                      ]
                  }
                }
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.description'
                    ]
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.condition.group.make.modelRange.city.hullMaterial.description'
                      ]
                  }
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.modelRange.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.modelRange.hullMaterial.description'
                    ]
                }
              }
            },
            sellerType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.sellerType.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.sellerType.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.sellerType.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.sellerType.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.group.make.sellerType.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.group.make.sellerType.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.make.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.make.hullMaterial.description'
                  ]
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.group.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.group.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.group.sellerType.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.sellerType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.sellerType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.sellerType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.sellerType.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.group.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.group.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.group.sellerType.hullMaterial.description'
                  ]
              }
            }
          }
        },
        make: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.make.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.condition.make.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.make.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.make.description'
              ]
          },
          model: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.make.model.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.model.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.make.model.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.model.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.model.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.model.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.model.hullMaterial.description'
                  ]
              }
            }
          },
          modelRange: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.make.modelRange.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.modelRange.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.make.modelRange.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.modelRange.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.model.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.condition.make.modelRange.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.condition.make.modelRange.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.condition.make.modelRange.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.condition.make.modelRange.hullMaterial.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.make.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.make.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.make.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.make.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.make.hullMaterial.description'
                ]
            }
          }
        },
        region: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.region.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.region.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.region.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.region.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.region.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.region.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.region.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.region.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.region.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.region.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.region.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.region.hullMaterial.description'
                ]
            }
          }
        },
        subdivision: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.subdivision.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.subdivision.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.subdivision.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.subdivision.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.subdivision.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.subdivision.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.subdivision.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.subdivision.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.subdivision.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.subdivision.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.subdivision.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.subdivision.hullMaterial.description'
                ]
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.sellerType.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.sellerType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.sellerType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.sellerType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.sellerType.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.sellerType.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.sellerType.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.sellerType.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.sellerType.hullMaterial.description'
                ]
            }
          }
        },
        country: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.country.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.country.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.country.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.country.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.country.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.country.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.country.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.country.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.country.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.country.hullMaterial.description'
                ]
            }
          }
        },
        city: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.city.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.condition.city.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.city.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.city.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.city.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.city.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.city.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.condition.city.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.city.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.condition.city.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.condition.city.hullMaterial.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.condition.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.condition.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.condition.hullMaterial.description'
              ]
          }
        }
      },
      type: {
        title: {
          id: 'app.searchPageSEO.metaElements.type.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.type.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.type.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.type.description']
        },
        class: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.class.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.class.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.class.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.class.description'
              ]
          },
          make: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.make.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.make.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.make.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.make.description'
                ]
            },
            model: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.model.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.model.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.model.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.model.description'
                  ]
              },
              sellerType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.sellerType.description'
                    ]
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.model.sellerType.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.sellerType.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.sellerType.hullMaterial.description'
                      ]
                  }
                }
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.model.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.model.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.model.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.model.hullMaterial.description'
                    ]
                }
              }
            },
            modelRange: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.modelRange.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.modelRange.description'
                  ]
              },
              sellerType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.description'
                    ]
                },
                region: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.region.hullMaterial.description'
                        ]
                    }
                  }
                },
                subdivision: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.subdivision.hullMaterial.description'
                        ]
                    }
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.country.hullMaterial.description'
                        ]
                    }
                  }
                },
                city: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.description'
                      ]
                  },
                  fuelType: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.fuelType.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.fuelType.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.fuelType.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.fuelType.description'
                        ]
                    }
                  },
                  hullMaterial: {
                    title: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.hullMaterial.title',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.hullMaterial.title'
                        ]
                    },
                    description: {
                      id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.hullMaterial.description',
                      defaultMessage:
                        enDefaults[
                          'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.city.hullMaterial.description'
                        ]
                    }
                  }
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.sellerType.hullMaterial.description'
                      ]
                  }
                }
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.type.class.make.modelRange.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.modelRange.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.modelRange.hullMaterial.description'
                    ]
                }
              }
            },
            sellerType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.sellerType.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.sellerType.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.sellerType.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.sellerType.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.sellerType.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.sellerType.hullMaterial.description'
                    ]
                }
              }
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.class.make.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.class.make.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.make.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.make.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.make.hullMaterial.description'
                  ]
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.sellerType.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.sellerType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.sellerType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.sellerType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.sellerType.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.sellerType.hullMaterial.description'
                  ]
              }
            }
          },
          region: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.region.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.region.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.region.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.region.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.region.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.region.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.region.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.region.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.region.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.region.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.region.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.region.hullMaterial.description'
                  ]
              }
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.subdivision.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.subdivision.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.subdivision.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.subdivision.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.subdivision.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.subdivision.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.subdivision.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.subdivision.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.subdivision.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.subdivision.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.subdivision.hullMaterial.description'
                  ]
              }
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.country.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.country.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.country.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.country.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.country.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.country.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.country.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.country.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.country.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.country.hullMaterial.description'
                  ]
              }
            }
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.city.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.city.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.city.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.city.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.city.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.city.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.class.city.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.city.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.class.city.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.class.city.hullMaterial.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.class.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.class.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.class.hullMaterial.description'
                ]
            }
          }
        },
        make: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.make.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.make.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.make.description',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.make.description']
          },
          model: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.model.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.model.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.model.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.model.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.model.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.model.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.model.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.model.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.model.hullMaterial.description'
                  ]
              }
            }
          },
          modelRange: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.modelRange.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.modelRange.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.modelRange.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.modelRange.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.type.make.modelRange.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.type.make.modelRange.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.modelRange.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.modelRange.hullMaterial.description'
                  ]
              }
            }
          },
          region: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.region.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.region.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.region.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.region.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.region.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.region.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.region.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.region.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.region.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.region.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.region.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.region.hullMaterial.description'
                  ]
              }
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.subdivision.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.subdivision.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.subdivision.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.subdivision.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.subdivision.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.subdivision.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.subdivision.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.subdivision.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.subdivision.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.subdivision.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.subdivision.hullMaterial.description'
                  ]
              }
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.country.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.country.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.country.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.country.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.country.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.country.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.country.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.country.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.country.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.country.hullMaterial.description'
                  ]
              }
            }
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.city.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.city.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.city.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.city.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.city.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.city.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.type.make.city.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.city.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.type.make.city.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.type.make.city.hullMaterial.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.make.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.make.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.make.hullMaterial.description'
                ]
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.sellerType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.sellerType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.sellerType.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.sellerType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.sellerType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.sellerType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.sellerType.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.sellerType.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.sellerType.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.sellerType.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.sellerType.hullMaterial.description'
                ]
            }
          }
        },
        region: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.region.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.region.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.region.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.region.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.region.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.region.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.region.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.region.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.region.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.region.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.region.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.region.hullMaterial.description'
                ]
            }
          }
        },
        subdivision: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.subdivision.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.subdivision.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.subdivision.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.subdivision.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.subdivision.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.subdivision.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.subdivision.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.subdivision.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.subdivision.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.subdivision.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.subdivision.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.subdivision.hullMaterial.description'
                ]
            }
          }
        },
        country: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.country.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.country.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.country.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.country.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.country.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.country.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.country.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.country.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.country.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.country.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.country.hullMaterial.description'
                ]
            }
          }
        },
        city: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.city.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.city.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.city.description',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.city.description']
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.city.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.city.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.city.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.city.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.type.city.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.city.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.type.city.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.type.city.hullMaterial.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.fuelType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.type.fuelType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.type.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.type.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.type.hullMaterial.description'
              ]
          }
        }
      },
      group: {
        title: {
          id: 'app.searchPageSEO.metaElements.group.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.group.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.group.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.group.description']
        },
        make: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.make.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.group.make.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.make.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.make.description'
              ]
          },
          model: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.model.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.model.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.model.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.model.description'
                ]
            },
            sellerType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.sellerType.description'
                  ]
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.model.sellerType.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.sellerType.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.sellerType.hullMaterial.description'
                    ]
                }
              }
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.model.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.model.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.model.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.model.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.model.hullMaterial.description'
                  ]
              }
            }
          },
          modelRange: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.modelRange.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.modelRange.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.modelRange.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.modelRange.description'
                ]
            },
            sellerType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.description'
                  ]
              },
              region: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.region.hullMaterial.description'
                      ]
                  }
                }
              },
              subdivision: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.subdivision.hullMaterial.description'
                      ]
                  }
                }
              },
              country: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.country.hullMaterial.description'
                      ]
                  }
                }
              },
              city: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.description'
                    ]
                },
                fuelType: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.fuelType.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.fuelType.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.fuelType.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.fuelType.description'
                      ]
                  }
                },
                hullMaterial: {
                  title: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.hullMaterial.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.hullMaterial.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.hullMaterial.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.city.hullMaterial.description'
                      ]
                  }
                }
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.sellerType.hullMaterial.description'
                    ]
                }
              }
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.region.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.region.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.region.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.country.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.country.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.country.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.city.description'
                  ]
              },
              fuelType: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.fuelType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.city.fuelType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.fuelType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.city.fuelType.description'
                    ]
                }
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.group.make.modelRange.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.group.make.modelRange.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.modelRange.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.modelRange.hullMaterial.description'
                  ]
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.sellerType.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.sellerType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.sellerType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.sellerType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.sellerType.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.sellerType.hullMaterial.description'
                  ]
              }
            }
          },
          region: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.region.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.region.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.region.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.region.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.region.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.region.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.region.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.region.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.region.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.region.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.region.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.region.hullMaterial.description'
                  ]
              }
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.subdivision.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.subdivision.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.subdivision.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.subdivision.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.subdivision.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.subdivision.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.subdivision.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.subdivision.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.subdivision.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.subdivision.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.subdivision.hullMaterial.description'
                  ]
              }
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.country.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.country.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.country.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.country.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.country.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.country.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.country.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.country.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.country.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.country.hullMaterial.description'
                  ]
              }
            }
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.city.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.city.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.city.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.city.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.city.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.city.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.group.make.city.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.city.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.group.make.city.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.group.make.city.hullMaterial.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.make.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.make.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.make.hullMaterial.description'
                ]
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.sellerType.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.sellerType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.sellerType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.sellerType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.sellerType.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.sellerType.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.sellerType.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.sellerType.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.sellerType.hullMaterial.description'
                ]
            }
          }
        },
        region: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.region.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.group.region.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.region.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.region.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.region.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.region.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.region.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.region.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.region.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.region.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.region.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.region.hullMaterial.description'
                ]
            }
          }
        },
        subdivision: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.subdivision.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.subdivision.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.subdivision.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.subdivision.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.subdivision.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.subdivision.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.subdivision.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.subdivision.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.subdivision.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.subdivision.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.subdivision.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.subdivision.hullMaterial.description'
                ]
            }
          }
        },
        country: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.country.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.group.country.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.country.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.country.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.country.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.country.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.country.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.country.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.country.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.country.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.country.hullMaterial.description'
                ]
            }
          }
        },
        city: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.city.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.group.city.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.city.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.city.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.city.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.city.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.city.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.group.city.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.city.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.group.city.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.group.city.hullMaterial.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.fuelType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.group.fuelType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.group.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.group.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.group.hullMaterial.description'
              ]
          }
        }
      },
      make: {
        title: {
          id: 'app.searchPageSEO.metaElements.make.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.make.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.make.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.make.description']
        },
        model: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.model.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.model.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.model.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.model.description'
              ]
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.sellerType.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.region.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.country.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.city.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.model.sellerType.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.model.sellerType.city.hullMaterial.description'
                    ]
                }
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.hullMaterial.description'
                  ]
              }
            }
          },
          region: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.region.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.region.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.region.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.region.description'
                ]
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.region.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.region.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.region.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.region.hullMaterial.description'
                  ]
              }
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.subdivision.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.subdivision.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.subdivision.description'
                ]
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.subdivision.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.subdivision.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.subdivision.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.subdivision.hullMaterial.description'
                  ]
              }
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.country.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.country.description'
                ]
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.country.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.country.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.country.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.country.hullMaterial.description'
                  ]
              }
            }
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.city.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.city.description'
                ]
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.city.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.city.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.city.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.city.hullMaterial.description'
                  ]
              }
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.hullMaterial.description'
                ]
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.model.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.model.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.model.fuelType.description'
                ]
            }
          }
        },
        modelRange: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.modelRange.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.modelRange.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.modelRange.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.modelRange.description'
              ]
          },
          sellerType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.sellerType.description'
                ]
            },
            region: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.region.hullMaterial.description'
                    ]
                }
              }
            },
            subdivision: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.subdivision.hullMaterial.description'
                    ]
                }
              }
            },
            country: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.country.hullMaterial.description'
                    ]
                }
              }
            },
            city: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.description'
                  ]
              },
              hullMaterial: {
                title: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.hullMaterial.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.hullMaterial.title'
                    ]
                },
                description: {
                  id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.hullMaterial.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageSEO.metaElements.make.modelRange.sellerType.city.hullMaterial.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.sellerType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.sellerType.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.sellerType.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.sellerType.hullMaterial.description'
                  ]
              }
            }
          },
          region: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.region.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.region.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.region.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.region.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.region.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.region.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.region.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.region.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.region.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.region.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.region.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.region.hullMaterial.description'
                  ]
              }
            }
          },
          subdivision: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.subdivision.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.subdivision.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.subdivision.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.subdivision.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.subdivision.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.subdivision.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.subdivision.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.subdivision.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.subdivision.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.subdivision.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.subdivision.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.subdivision.hullMaterial.description'
                  ]
              }
            }
          },
          country: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.country.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.country.description'
                ]
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.country.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.country.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.country.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.country.hullMaterial.description'
                  ]
              }
            }
          },
          city: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.city.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.city.description'
                ]
            },
            fuelType: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.model.city.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.city.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.model.city.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.model.city.fuelType.description'
                  ]
              }
            },
            hullMaterial: {
              title: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.city.hullMaterial.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.city.hullMaterial.title'
                  ]
              },
              description: {
                id: 'app.searchPageSEO.metaElements.make.modelRange.city.hullMaterial.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageSEO.metaElements.make.modelRange.city.hullMaterial.description'
                  ]
              }
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.modelRange.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.modelRange.hullMaterial.description'
                ]
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.sellerType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.sellerType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.sellerType.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.sellerType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.sellerType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.sellerType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.sellerType.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.sellerType.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.sellerType.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.sellerType.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.sellerType.hullMaterial.description'
                ]
            }
          }
        },
        region: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.region.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.region.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.region.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.region.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.region.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.region.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.region.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.region.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.region.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.region.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.region.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.region.hullMaterial.description'
                ]
            }
          }
        },
        subdivision: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.subdivision.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.subdivision.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.subdivision.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.subdivision.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.subdivision.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.subdivision.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.subdivision.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.subdivision.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.subdivision.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.subdivision.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.subdivision.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.subdivision.hullMaterial.description'
                ]
            }
          }
        },
        country: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.country.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.country.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.country.description'
              ]
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.country.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.country.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.country.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.country.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.country.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.country.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.country.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.country.hullMaterial.description'
                ]
            }
          }
        },
        city: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.city.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.city.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.city.description',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.city.description']
          },
          fuelType: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.city.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.city.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.city.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.city.fuelType.description'
                ]
            }
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.city.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.city.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.city.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.city.hullMaterial.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.fuelType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.make.fuelType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.fuelType.description'
              ]
          },
          hullMaterial: {
            title: {
              id: 'app.searchPageSEO.metaElements.make.fuelType.hullMaterial.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.fuelType.hullMaterial.title'
                ]
            },
            description: {
              id: 'app.searchPageSEO.metaElements.make.fuelType.hullMaterial.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageSEO.metaElements.make.fuelType.hullMaterial.description'
                ]
            }
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.make.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.make.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.make.hullMaterial.description'
              ]
          }
        }
      },
      country: {
        title: {
          id: 'app.searchPageSEO.metaElements.country.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.country.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.country.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.country.description']
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.country.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.country.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.country.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.country.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.country.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.country.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.country.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.country.hullMaterial.description'
              ]
          }
        }
      },
      region: {
        title: {
          id: 'app.searchPageSEO.metaElements.region.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.region.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.region.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.region.description']
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.region.fuelType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.region.fuelType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.region.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.region.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.region.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.region.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.region.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.region.hullMaterial.description'
              ]
          }
        }
      },
      subdivision: {
        title: {
          id: 'app.searchPageSEO.metaElements.subdivision.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.subdivision.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.subdivision.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.subdivision.description']
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.subdivision.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.subdivision.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.subdivision.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.subdivision.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.subdivision.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.subdivision.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.subdivision.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.subdivision.hullMaterial.description'
              ]
          }
        }
      },
      city: {
        title: {
          id: 'app.searchPageSEO.metaElements.city.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.city.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.city.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.city.description']
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.city.fuelType.title',
            defaultMessage:
              enDefaults['app.searchPageSEO.metaElements.city.fuelType.title']
          },
          description: {
            id: 'app.searchPageSEO.metaElements.city.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.city.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.city.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.city.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.city.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.city.hullMaterial.description'
              ]
          }
        }
      },
      fuelType: {
        title: {
          id: 'app.searchPageSEO.metaElements.fuelType.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.fuelType.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.fuelType.description',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.fuelType.description']
        }
      },
      hullMaterial: {
        title: {
          id: 'app.searchPageSEO.metaElements.hullMaterial.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.hullMaterial.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.hullMaterial.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.hullMaterial.description'
            ]
        }
      }
    },
    sellerType: {
      title: {
        id: 'app.searchPageSEO.metaElements.sellerType.title',
        defaultMessage:
          enDefaults['app.searchPageSEO.metaElements.sellerType.title']
      },
      description: {
        id: 'app.searchPageSEO.metaElements.sellerType.description',
        defaultMessage:
          enDefaults['app.searchPageSEO.metaElements.sellerType.description']
      },
      region: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.region.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.sellerType.region.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.region.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.region.description'
            ]
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.region.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.region.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.region.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.region.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.region.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.region.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.region.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.region.hullMaterial.description'
              ]
          }
        }
      },
      subdivision: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.subdivision.title',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.subdivision.title'
            ]
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.subdivision.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.subdivision.description'
            ]
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.subdivision.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.subdivision.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.subdivision.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.subdivision.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.subdivision.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.subdivision.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.subdivision.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.subdivision.hullMaterial.description'
              ]
          }
        }
      },
      country: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.country.title',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.country.title'
            ]
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.country.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.country.description'
            ]
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.country.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.country.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.country.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.country.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.country.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.country.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.country.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.country.hullMaterial.description'
              ]
          }
        }
      },
      city: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.city.title',
          defaultMessage:
            enDefaults['app.searchPageSEO.metaElements.sellerType.city.title']
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.city.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.city.description'
            ]
        },
        fuelType: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.city.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.city.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.city.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.city.fuelType.description'
              ]
          }
        },
        hullMaterial: {
          title: {
            id: 'app.searchPageSEO.metaElements.sellerType.city.hullMaterial.title',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.city.hullMaterial.title'
              ]
          },
          description: {
            id: 'app.searchPageSEO.metaElements.sellerType.city.hullMaterial.description',
            defaultMessage:
              enDefaults[
                'app.searchPageSEO.metaElements.sellerType.city.hullMaterial.description'
              ]
          }
        }
      },
      fuelType: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.fuelType.title',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.fuelType.title'
            ]
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.fuelType.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.fuelType.description'
            ]
        }
      },
      hullMaterial: {
        title: {
          id: 'app.searchPageSEO.metaElements.sellerType.hullMaterial.title',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.hullMaterial.title'
            ]
        },
        description: {
          id: 'app.searchPageSEO.metaElements.sellerType.hullMaterial.description',
          defaultMessage:
            enDefaults[
              'app.searchPageSEO.metaElements.sellerType.hullMaterial.description'
            ]
        }
      }
    },
    pagination: {
      title: {
        id: 'app.searchPageSEO.pagination.title',
        defaultMessage: enDefaults['app.searchPageSEO.pagination.title']
      },
      h1: {
        id: 'app.searchPageSEO.pagination.h1',
        defaultMessage: enDefaults['app.searchPageSEO.pagination.h1']
      },
      description: {
        id: 'app.searchPageSEO.pagination.description',
        defaultMessage: enDefaults['app.searchPageSEO.pagination.description']
      }
    },
    page: {
      expertsReviews: {
        heading: {
          id: 'app.searchPageSEO.page.expertsReviews.heading',
          defaultMessage:
            enDefaults['app.searchPageSEO.page.expertsReviews.heading']
        }
      },
      seoContent: {
        heading: {
          id: 'app.searchPageSEO.page.seoContent.heading',
          defaultMessage:
            enDefaults['app.searchPageSEO.page.seoContent.heading']
        }
      }
    }
  },
  searchPageEnginesSEO: {
    indexableFacets: {
      condition: {
        new: {
          id: 'app.searchPageEnginesSEO.indexableFacets.condition.new',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.condition.new']
        },
        used: {
          id: 'app.searchPageEnginesSEO.indexableFacets.condition.used',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.condition.used'
            ]
        }
      },
      fuel: {
        diesel: {
          id: 'app.searchPageEnginesSEO.indexableFacets.fuel.diesel',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.fuel.diesel']
        },
        electric: {
          id: 'app.searchPageEnginesSEO.indexableFacets.fuel.electric',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.fuel.electric']
        },
        gasoline: {
          id: 'app.searchPageEnginesSEO.indexableFacets.fuel.gasoline',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.fuel.gasoline']
        },
        lpg: {
          id: 'app.searchPageEnginesSEO.indexableFacets.fuel.lpg',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.fuel.lpg']
        },
        other: {
          id: 'app.searchPageEnginesSEO.indexableFacets.fuel.other',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.indexableFacets.fuel.other']
        }
      },
      engineType: {
        inboard: {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.inboard',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.inboard'
            ]
        },
        jet: {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.jet',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.jet'
            ]
        },
        outboard: {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.outboard',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.outboard'
            ]
        },
        'outboard-2s': {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.outboard-2s',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.outboard-2s'
            ]
        },
        'outboard-4s': {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.outboard-4s',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.outboard-4s'
            ]
        },
        'stern-drive': {
          id: 'app.searchPageEnginesSEO.indexableFacets.engineType.stern-drive',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.indexableFacets.engineType.stern-drive'
            ]
        }
      }
    },
    metaElements: {
      title: {
        id: 'app.searchPageEnginesSEO.metaElements.title',
        defaultMessage:
          enDefaults['app.searchPageEnginesSEO.metaElements.title']
      },
      description: {
        id: 'app.searchPageEnginesSEO.metaElements.description',
        defaultMessage:
          enDefaults['app.searchPageEnginesSEO.metaElements.description']
      },
      city: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.city.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.city.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.city.description',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.city.description']
        }
      },
      condition: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.condition.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.condition.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.condition.description',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.metaElements.condition.description'
            ]
        },
        city: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.city.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.city.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.city.description'
              ]
          }
        },
        country: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.country.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.country.description'
              ]
          }
        },
        engineType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.engineType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.engineType.description'
              ]
          },
          sellerType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.engineType.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.engineType.sellerType.description'
                ]
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.engineType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.engineType.fuelType.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.engineType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.engineType.description'
              ]
          },
          sellerType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.fuelType.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.fuelType.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.fuelType.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.fuelType.sellerType.description'
                ]
            }
          }
        },
        make: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.make.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.make.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.make.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.make.description'
              ]
          },
          engineType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.engineType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.engineType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.engineType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.engineType.description'
                ]
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.description'
                ]
            },
            sellerType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.fuelType.sellerType.description'
                  ]
              }
            }
          },
          model: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.model.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.model.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.country.description'
                  ]
              }
            },
            engineType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.engineType.country.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.country.description'
                    ]
                }
              },
              sellerType: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.description'
                    ]
                },
                city: {
                  title: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.city.description'
                      ]
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.model.fuelType.sellerType.country.description'
                      ]
                  }
                }
              }
            }
          },
          modelRange: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.country.description'
                  ]
              }
            },
            engineType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.engineType.country.description'
                    ]
                }
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.country.description'
                    ]
                }
              },
              sellerType: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.description'
                    ]
                },
                city: {
                  title: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.city.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.city.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.city.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.city.description'
                      ]
                  }
                },
                country: {
                  title: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.country.title',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.country.title'
                      ]
                  },
                  description: {
                    id: 'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.country.description',
                    defaultMessage:
                      enDefaults[
                        'app.searchPageEnginesSEO.metaElements.condition.make.modelRange.fuelType.sellerType.country.description'
                      ]
                  }
                }
              }
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.condition.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.condition.sellerType.description'
              ]
          }
        }
      },
      country: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.country.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.country.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.country.description',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.metaElements.country.description'
            ]
        }
      },
      engineType: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.engineType.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.engineType.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.engineType.description',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.metaElements.engineType.description'
            ]
        },
        city: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.city.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.city.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.city.description'
              ]
          }
        },
        country: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.country.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.country.description'
              ]
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.sellerType.description'
              ]
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.engineType.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.engineType.fuelType.description'
              ]
          }
        }
      },
      fuelType: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.fuelType.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.fuelType.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.fuelType.description',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.metaElements.fuelType.description'
            ]
        },
        city: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.city.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.city.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.city.description'
              ]
          }
        },
        country: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.country.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.country.description'
              ]
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.fuelType.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.fuelType.sellerType.description'
              ]
          }
        }
      },
      make: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.make.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.make.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.make.description',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.make.description']
        },
        city: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.city.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.city.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.city.description'
              ]
          }
        },
        country: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.country.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.country.description'
              ]
          }
        },
        engineType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.engineType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.engineType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.engineType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.engineType.description'
              ]
          },
          city: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.city.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.city.description'
                ]
            }
          },
          country: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.country.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.country.description'
                ]
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.engineType.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.engineType.fuelType.description'
                ]
            }
          }
        },
        fuelType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.fuelType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.fuelType.description'
              ]
          },
          city: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.city.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.city.description'
                ]
            }
          },
          country: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.country.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.country.description'
                ]
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.fuelType.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.fuelType.sellerType.description'
                ]
            }
          }
        },
        model: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.model.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.model.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.model.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.model.description'
              ]
          },
          city: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.city.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.city.description'
                ]
            }
          },
          country: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.country.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.country.description'
                ]
            }
          },
          engineType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.engineType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.engineType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.country.description'
                  ]
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.engineType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.engineType.fuelType.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.fuelType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.country.description'
                  ]
              }
            },
            sellerType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.model.fuelType.sellerType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.description'
                    ]
                }
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.model.sellerType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.sellerType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.sellerType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.model.sellerType.country.description'
                  ]
              }
            }
          }
        },
        modelRange: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.modelRange.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.modelRange.description'
              ]
          },
          city: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.city.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.city.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.city.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.city.description'
                ]
            }
          },
          country: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.country.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.country.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.country.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.country.description'
                ]
            }
          },
          engineType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.country.description'
                  ]
              }
            },
            fuelType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.fuelType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.fuelType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.fuelType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.engineType.fuelType.description'
                  ]
              }
            }
          },
          fuelType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.country.description'
                  ]
              }
            },
            sellerType: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.description'
                  ]
              },
              city: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.city.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.city.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.city.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.modelRange.fuelType.sellerType.city.description'
                    ]
                }
              },
              country: {
                title: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.title',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.title'
                    ]
                },
                description: {
                  id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.description',
                  defaultMessage:
                    enDefaults[
                      'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.description'
                    ]
                }
              }
            }
          },
          sellerType: {
            title: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.title',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.title'
                ]
            },
            description: {
              id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.description',
              defaultMessage:
                enDefaults[
                  'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.description'
                ]
            },
            city: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.city.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.city.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.city.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.city.description'
                  ]
              }
            },
            country: {
              title: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.title',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.title'
                  ]
              },
              description: {
                id: 'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.description',
                defaultMessage:
                  enDefaults[
                    'app.searchPageEnginesSEO.metaElements.make.modelRange.sellerType.country.description'
                  ]
              }
            }
          }
        },
        sellerType: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.make.sellerType.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.sellerType.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.make.sellerType.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.make.sellerType.description'
              ]
          }
        }
      },
      sellerType: {
        title: {
          id: 'app.searchPageEnginesSEO.metaElements.sellerType.title',
          defaultMessage:
            enDefaults['app.searchPageEnginesSEO.metaElements.sellerType.title']
        },
        description: {
          id: 'app.searchPageEnginesSEO.metaElements.sellerType.description',
          defaultMessage:
            enDefaults[
              'app.searchPageEnginesSEO.metaElements.sellerType.description'
            ]
        },
        city: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.sellerType.city.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.sellerType.city.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.sellerType.city.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.sellerType.city.description'
              ]
          }
        },
        country: {
          title: {
            id: 'app.searchPageEnginesSEO.metaElements.sellerType.country.title',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.sellerType.country.title'
              ]
          },
          description: {
            id: 'app.searchPageEnginesSEO.metaElements.sellerType.country.description',
            defaultMessage:
              enDefaults[
                'app.searchPageEnginesSEO.metaElements.sellerType.country.description'
              ]
          }
        }
      }
    }
  },
  searchCategory: {
    advancedSearch: {
      id: 'app.search.category.advancedSearch',
      defaultMessage: enDefaults['app.search.category.advancedSearch']
    },
    allMotors: {
      id: 'app.search.category.allMotors',
      defaultMessage: enDefaults['app.search.category.allMotors']
    },
    engines: {
      id: 'app.search.category.engines',
      defaultMessage: enDefaults['app.search.category.engines']
    },
    motorBoats: {
      id: 'app.search.category.motorBoats',
      defaultMessage: enDefaults['app.search.category.motorBoats']
    },
    sailboats: {
      id: 'app.search.category.sailboats',
      defaultMessage: enDefaults['app.search.category.sailboats']
    },
    unpowered: {
      id: 'app.search.category.unpowered',
      defaultMessage: enDefaults['app.search.category.unpowered']
    }
  },
  category: {
    id: 'app.search.category',
    defaultMessage: enDefaults['app.search.category']
  },
  searchHeader: {
    sort: {
      sortBy: {
        id: 'app.search.sort.by',
        defaultMessage: enDefaults['app.search.sort.by']
      },
      recommended: {
        id: 'app.search.sort.recommended',
        defaultMessage: enDefaults['app.search.sort.recommended']
      },
      newestUpdated: {
        id: 'app.search.sort.updated.newest',
        defaultMessage: enDefaults['app.search.sort.updated.newest']
      },
      oldestUpdated: {
        id: 'app.search.sort.updated.oldest',
        defaultMessage: enDefaults['app.search.sort.updated.oldest']
      },
      nearest: {
        id: 'app.search.sort.distance.nearest',
        defaultMessage: enDefaults['app.search.sort.distance.nearest']
      },
      farthest: {
        id: 'app.search.sort.distance.farthest',
        defaultMessage: enDefaults['app.search.sort.distance.farthest']
      },
      newestYear: {
        id: 'app.search.sort.year.newest',
        defaultMessage: enDefaults['app.search.sort.year.newest']
      },
      oldestYear: {
        id: 'app.search.sort.year.oldest',
        defaultMessage: enDefaults['app.search.sort.year.oldest']
      },
      longest: {
        id: 'app.search.sort.length.longest',
        defaultMessage: enDefaults['app.search.sort.length.longest']
      },
      shortest: {
        id: 'app.search.sort.length.shortest',
        defaultMessage: enDefaults['app.search.sort.length.shortest']
      },
      pricey: {
        id: 'app.search.sort.price.highest',
        defaultMessage: enDefaults['app.search.sort.price.highest']
      },
      cheapest: {
        id: 'app.search.sort.price.lowest',
        defaultMessage: enDefaults['app.search.sort.price.lowest']
      },
      nameDesc: {
        id: 'app.search.sort.name.desc',
        defaultMessage: enDefaults['app.search.sort.name.desc']
      },
      nameAsc: {
        id: 'app.search.sort.name.asc',
        defaultMessage: enDefaults['app.search.sort.name.asc']
      },
      firstMake: {
        id: 'app.search.sort.make.asc',
        defaultMessage: enDefaults['app.search.sort.make.asc']
      },
      lastMake: {
        id: 'app.search.sort.make.desc',
        defaultMessage: enDefaults['app.search.sort.make.desc']
      },
      leastPowerful: {
        id: 'app.search.sort.powerhp.asc',
        defaultMessage: enDefaults['app.search.sort.powerhp.asc']
      },
      mostPowerful: {
        id: 'app.search.sort.powerhp.desc',
        defaultMessage: enDefaults['app.search.sort.powerhp.desc']
      }
    },
    viewing: {
      listings: {
        id: 'app.search.viewing.listings',
        defaultMessage: enDefaults['app.search.viewing.listings'],
        combined: {
          id: 'app.search.viewing.listings.combined',
          defaultMessage: enDefaults['app.search.viewing.listings.combined']
        },
        class: {
          id: 'app.search.viewing.listings.class',
          defaultMessage: enDefaults['app.search.viewing.listings.class']
        },
        make: {
          id: 'app.search.viewing.listings.make',
          defaultMessage: enDefaults['app.search.viewing.listings.make'],
          norepeat: {
            id: 'app.search.viewing.listings.make.norepeat',
            defaultMessage:
              enDefaults['app.search.viewing.listings.make.norepeat']
          }
        },
        model: {
          id: 'app.search.viewing.listings.model',
          defaultMessage: enDefaults['app.search.viewing.listings.model']
        },
        type: {
          id: 'app.search.viewing.listings.type',
          defaultMessage: enDefaults['app.search.viewing.listings.type']
        },
        condition: {
          id: 'app.search.viewing.listings.condition',
          defaultMessage: enDefaults['app.search.viewing.listings.condition']
        },
        country: {
          id: 'app.search.viewing.listings.country',
          defaultMessage: enDefaults['app.search.viewing.listings.country']
        },
        region: {
          id: 'app.search.viewing.listings.region',
          defaultMessage: enDefaults['app.search.viewing.listings.region']
        },
        subdivision: {
          id: 'app.search.viewing.listings.subdivision',
          defaultMessage: enDefaults['app.search.viewing.listings.subdivision']
        },
        city: {
          id: 'app.search.viewing.listings.city',
          defaultMessage: enDefaults['app.search.viewing.listings.city']
        }
      },
      engines: {
        id: 'app.search.viewing.engines',
        defaultMessage: enDefaults['app.search.viewing.engines'],
        combined: {
          id: 'app.search.viewing.engines.combined',
          defaultMessage: enDefaults['app.search.viewing.engines.combined']
        },
        condition: {
          id: 'app.search.viewing.engines.condition',
          defaultMessage: enDefaults['app.search.viewing.engines.condition']
        }
      },
      noListings: {
        id: 'app.search.viewing.nolistings',
        defaultMessage: enDefaults['app.search.viewing.nolistings']
      }
    }
  },
  noSelected: {
    id: 'app.search.filter.noSelected',
    defaultMessage: enDefaults['app.search.filter.noSelected']
  },
  upTo: {
    id: 'app.search.filter.upTo',
    defaultMessage: enDefaults['app.search.filter.upTo']
  },
  filter: {
    id: 'app.search.filter',
    defaultMessage: enDefaults['app.search.filter']
  },
  clearFilter: {
    id: 'app.search.filter.clear',
    defaultMessage: enDefaults['app.search.filter.clear']
  },
  searchTypeBoats: {
    id: 'app.search.types.boats',
    defaultMessage: enDefaults['app.search.types.boats']
  },
  searchTypeEngines: {
    id: 'app.search.types.engines',
    defaultMessage: enDefaults['app.search.types.engines']
  },
  condition: {
    id: 'app.search.filter.condition',
    defaultMessage: enDefaults['app.search.filter.condition']
  },
  searchLength: {
    id: 'app.search.filter.length',
    defaultMessage: enDefaults['app.search.filter.length']
  },
  page: {
    id: 'app.search.filter.page',
    defaultMessage: enDefaults['app.search.filter.page']
  },
  price: {
    id: 'app.search.filter.price',
    defaultMessage: enDefaults['app.search.filter.price']
  },
  year: {
    id: 'app.search.filter.year',
    defaultMessage: enDefaults['app.search.filter.year']
  },
  recommended: {
    id: 'app.search.filter.recommended',
    defaultMessage: enDefaults['app.search.filter.recommended']
  },
  allType: {
    id: 'app.search.filter.class.allType',
    defaultMessage: enDefaults['app.search.filter.class.allType']
  },
  type: {
    id: 'app.search.filter.type',
    defaultMessage: enDefaults['app.search.filter.type']
  },
  make: {
    id: 'app.search.filter.make',
    defaultMessage: enDefaults['app.search.filter.make']
  },
  makePlaceholder: {
    id: 'app.search.filter.make.placeholder',
    defaultMessage: enDefaults['app.search.filter.make.placeholder']
  },
  moreMakes: {
    id: 'app.search.filter.make.more',
    defaultMessage: enDefaults['app.search.filter.make.more']
  },
  model: {
    id: 'app.search.filter.model',
    defaultMessage: enDefaults['app.search.filter.model']
  },
  modelRange: {
    id: 'app.search.filter.modelRange',
    defaultMessage: enDefaults['app.search.filter.modelRange']
  },
  modelFilterHeader: {
    id: 'app.search.filter.model.header',
    defaultMessage: enDefaults['app.search.filter.model.header']
  },
  modelPlaceholder: {
    id: 'app.search.filter.model.placeholder',
    defaultMessage: enDefaults['app.search.filter.model.placeholder']
  },
  moreModels: {
    id: 'app.search.filter.model.more',
    defaultMessage: enDefaults['app.search.filter.model.more']
  },
  modal: {
    id: 'app.search.filter.modal',
    defaultMessage: enDefaults['app.search.filter.modal']
  },
  forSale: {
    id: 'app.search.filter.forSale',
    defaultMessage: enDefaults['app.search.filter.forSale']
  },
  dealersAndPrivateSellers: {
    id: 'app.search.filter.forSale.dealersAndPrivateSellers',
    defaultMessage:
      enDefaults['app.search.filter.forSale.dealersAndPrivateSellers']
  },
  dealers: {
    id: 'app.search.filter.forSale.dealers',
    defaultMessage: enDefaults['app.search.filter.forSale.dealers']
  },
  dealerContact: {
    callNow: {
      id: 'app.dealerContact.callNow',
      defaultMessage: enDefaults['app.dealerContact.callNow']
    },
    contactDealer: {
      id: 'app.dealerContact.contactDealer',
      defaultMessage: enDefaults['app.dealerContact.contactDealer']
    },
    viewAddress: {
      id: 'app.dealerContact.viewAddress',
      defaultMessage: enDefaults['app.dealerContact.viewAddress']
    },
    visitWebsite: {
      id: 'app.dealerContact.visitWebsite',
      defaultMessage: enDefaults['app.dealerContact.visitWebsite']
    },
    manufacturerListing: {
      id: 'app.dealerContact.manufacturerListing',
      defaultMessage: enDefaults['app.dealerContact.manufacturerListing']
    }
  },
  dealerLocatorModal: {
    headerTitle: {
      id: 'app.dealerLocatorModal.headerTitle',
      defaultMessage: enDefaults['app.dealerLocatorModal.headerTitle']
    },
    dealersFound: {
      id: 'app.dealerLocatorModal.dealersFound',
      defaultMessage: enDefaults['app.dealerLocatorModal.dealersFound']
    },
    viewDealerInfo: {
      id: 'app.dealerLocatorModal.viewDealerInfo',
      defaultMessage: enDefaults['app.dealerLocatorModal.viewDealerInfo']
    },
    pagePrevious: {
      id: 'app.dealerLocatorModal.pagePrevious',
      defaultMessage: enDefaults['app.dealerLocatorModal.pagePrevious']
    },
    pageNext: {
      id: 'app.dealerLocatorModal.pageNext',
      defaultMessage: enDefaults['app.dealerLocatorModal.pageNext']
    },
    backToDealerList: {
      id: 'app.dealerLocatorModal.backToDealerList',
      defaultMessage: enDefaults['app.dealerLocatorModal.backToDealerList']
    },
    contactPrepopulateText: {
      id: 'app.dealerLocatorModal.contactPrepopulateText',
      defaultMessage:
        enDefaults['app.dealerLocatorModal.contactPrepopulateText']
    }
  },
  powerhpMin: {
    id: 'app.search.filter.powerhp.min',
    defaultMessage: enDefaults['app.search.filter.powerhp.min']
  },
  powerhpMax: {
    id: 'app.search.filter.powerhp.max',
    defaultMessage: enDefaults['app.search.filter.powerhp.max']
  },
  privateSellers: {
    id: 'app.search.filter.forSale.privateSellers',
    defaultMessage: enDefaults['app.search.filter.forSale.privateSellers']
  },
  lengthMin: {
    id: 'app.search.filter.length.min',
    defaultMessage: enDefaults['app.search.filter.length.min']
  },
  lengthMax: {
    id: 'app.search.filter.length.max',
    defaultMessage: enDefaults['app.search.filter.length.max']
  },
  location: {
    id: 'app.search.filter.location',
    defaultMessage: enDefaults['app.search.filter.location']
  },
  priceMin: {
    id: 'app.search.filter.price.min',
    defaultMessage: enDefaults['app.search.filter.price.min']
  },
  priceMax: {
    id: 'app.search.filter.price.max',
    defaultMessage: enDefaults['app.search.filter.price.max']
  },
  yearMin: {
    id: 'app.search.filter.year.min',
    defaultMessage: enDefaults['app.search.filter.year.min']
  },
  yearMax: {
    id: 'app.search.filter.year.max',
    defaultMessage: enDefaults['app.search.filter.year.max']
  },
  makeModel: {
    id: 'app.search.filter.makeModel',
    defaultMessage: enDefaults['app.search.filter.makeModel']
  },
  fuel: {
    id: 'app.search.filter.fuelType',
    defaultMessage: enDefaults['app.search.filter.fuelType']
  },
  fuelType: {
    id: 'app.search.filter.fuelType',
    defaultMessage: enDefaults['app.search.filter.fuelType']
  },
  keyword: {
    id: 'app.search.filter.keyword',
    defaultMessage: enDefaults['app.search.filter.keyword']
  },
  hullMaterial: {
    id: 'app.search.filter.hullMaterial',
    defaultMessage: enDefaults['app.search.filter.hullMaterial']
  },
  radius: {
    id: 'app.search.filter.radius',
    defaultMessage: enDefaults['app.search.filter.radius']
  },
  byRadius: {
    id: 'app.search.filter.byRadius',
    defaultMessage: enDefaults['app.search.filter.byRadius']
  },
  multiFacetedBoatTypeClass: {
    id: 'app.search.filter.class',
    defaultMessage: enDefaults['app.search.filter.class']
  },
  currency: {
    id: 'app.search.filter.currency',
    defaultMessage: 'Currency'
  },
  engine: {
    id: 'routes.search.item.engine',
    defaultMessage: enDefaults['routes.search.item.engine']
  },
  engineMake: {
    id: 'routes.search.item.engine-make',
    defaultMessage: enDefaults['routes.search.item.engine-make']
  },
  group: {
    id: 'app.search.filter.group',
    defaultMessage: enDefaults['app.search.filter.group']
  },
  subdivision: {
    id: 'app.search.filter.subdivision',
    defaultMessage: enDefaults['app.search.filter.subdivision'],
    FR: {
      id: 'app.search.filter.subdivision.FR',
      defaultMessage: enDefaults['app.search.filter.subdivision.FR']
    },
    GB: {
      id: 'app.search.filter.subdivision.GB',
      defaultMessage: enDefaults['app.search.filter.subdivision.GB']
    },
    DE: {
      id: 'app.search.filter.subdivision.DE',
      defaultMessage: enDefaults['app.search.filter.subdivision.DE']
    },
    US: {
      id: 'app.search.filter.subdivision.US',
      defaultMessage: enDefaults['app.search.filter.subdivision.US']
    },
    ES: {
      id: 'app.search.filter.subdivision.ES',
      defaultMessage: enDefaults['app.search.filter.subdivision.ES']
    },
    IT: {
      id: 'app.search.filter.subdivision.IT',
      defaultMessage: enDefaults['app.search.filter.subdivision.IT']
    }
  },
  subdivisionsPlaceholder: {
    id: 'app.search.filter.subdivision.placeholder',
    defaultMessage: enDefaults['app.search.filter.subdivision.placeholder']
  },
  allSubdivisions: {
    id: 'app.search.filter.subdivisions.all',
    defaultMessage: enDefaults['app.search.filter.subdivisions.all']
  },
  moreSubdivisions: {
    id: 'app.search.filter.subdivisions.more',
    defaultMessage: enDefaults['app.search.filter.subdivisions.more']
  },
  region: {
    id: 'app.search.filter.region',
    defaultMessage: enDefaults['app.search.filter.region']
  },
  moreRegions: {
    id: 'app.search.filter.regions.more',
    defaultMessage: enDefaults['app.search.filter.regions.more']
  },
  worldRegion: {
    id: 'app.search.filter.worldRegion',
    defaultMessage: enDefaults['app.search.filter.worldRegion']
  },
  allRegions: {
    id: 'app.search.filter.regions.all',
    defaultMessage: enDefaults['app.search.filter.regions.all']
  },
  allMake: {
    id: 'app.search.filter.make.all',
    defaultMessage: enDefaults['app.search.filter.make.all']
  },
  otherMake: {
    id: 'app.search.filter.make.other',
    defaultMessage: enDefaults['app.search.filter.make.other']
  },
  country: {
    id: 'app.search.filter.country',
    defaultMessage: enDefaults['app.search.filter.country']
  },
  byCountry: {
    id: 'app.search.filter.byCountry',
    defaultMessage: enDefaults['app.search.filter.byCountry']
  },
  countryPlaceholder: {
    id: 'app.search.filter.country.placeholder',
    defaultMessage: enDefaults['app.search.filter.country.placeholder']
  },
  moreCountries: {
    id: 'app.search.filter.country.more',
    defaultMessage: enDefaults['app.search.filter.country.more']
  },
  allCountries: {
    id: 'app.search.filter.countries.all',
    defaultMessage: enDefaults['app.search.filter.countries.all']
  },
  city: {
    id: 'app.search.filter.city',
    defaultMessage: enDefaults['app.search.filter.city']
  },
  cityPlaceholder: {
    id: 'app.search.filter.city.placeholder',
    defaultMessage: enDefaults['app.search.filter.city.placeholder']
  },
  moreCities: {
    id: 'app.search.filter.city.more',
    defaultMessage: enDefaults['app.search.filter.city.more']
  },
  citiesInCountry: {
    id: 'app.search.filter.cities.in.country',
    defaultMessage: enDefaults['app.search.filter.cities.in.country']
  },
  postalCode: {
    id: 'app.search.filter.postalCode',
    defaultMessage: enDefaults['app.search.filter.postalCode']
  },
  sort: {
    id: 'app.search.filter.sort',
    defaultMessage: enDefaults['app.search.filter.sort']
  },
  distance: {
    id: 'app.search.filter.distance',
    defaultMessage: enDefaults['app.search.filter.distance']
  },
  numberOfEngines: {
    id: 'app.search.filter.enginesnumber',
    defaultMessage: enDefaults['app.search.filter.enginesnumber']
  },
  engineDetailsFacet: {
    engineNumber: {
      id: 'app.search.filter.enginedetails.number',
      defaultMessage: enDefaults['app.search.filter.enginedetails.number'],
    },
    engineType: {
      id: 'app.search.filter.enginedetails.type',
      defaultMessage: enDefaults['app.search.filter.enginedetails.type'],
    },
    engineBrand: {
      id: 'app.search.filter.enginedetails.brand',
      defaultMessage: enDefaults['app.search.filter.enginedetails.brand'],
    },
    title: {
      id: 'app.search.filter.enginedetails',
      defaultMessage: enDefaults['app.search.filter.enginedetails'],
    }
  },
  updated: {
    id: 'app.search.filter.updated',
    defaultMessage: enDefaults['app.search.filter.updated']
  },
  searchRoot: {
    id: 'routes.search.root',
    defaultMessage: enDefaults['routes.search.root']
  },
  enginesSearchRoot: {
    id: 'routes.engines.search.root',
    defaultMessage: enDefaults['routes.engines.search.root']
  },
  dealerSearchRoot: {
    id: 'routes.dealerSearch.root',
    defaultMessage: enDefaults['routes.dealerSearch.root']
  },
  dealerEnginesSearchRoot: {
    id: 'routes.engines.dealerSearch.root',
    defaultMessage: enDefaults['routes.engines.dealerSearch.root']
  },
  brandedOemSearchRoot: {
    id: 'routes.brandedOemSearch.root',
    defaultMessage: enDefaults['routes.brandedOemSearch.root']
  },
  sellRoot: {
    id: 'routes.sell.root',
    defaultMessage: enDefaults['routes.sell.root']
  },
  sellEnginesRoot: {
    id: 'routes.sell-engines.root',
    defaultMessage: enDefaults['routes.sell-engines.root']
  },
  partySearchRoot: {
    id: 'routes.partySearch.root',
    defaultMessage: enDefaults['routes.partySearch.root']
  },
  brandedSearchRoot: {
    id: 'routes.brandedSearch.root',
    defaultMessage: enDefaults['routes.brandedSearch.root']
  },
  customBrandedSearchRoot: {
    id: 'routes.brandedSearch.root.custom',
    defaultMessage: enDefaults['routes.brandedSearch.root.custom']
  },
  brandedSearchBroker: {
    id: 'routes.brandedSearch.broker',
    defaultMessage: enDefaults['routes.brandedSearch.broker']
  },
  dealerPrefix: {
    id: 'routes.prefix.dealer',
    defaultMessage: enDefaults['routes.prefix.dealer']
  },
  resourcesRoot: {
    id: 'routes.resources.root',
    defaultMessage: enDefaults['routes.resources.root']
  },
  blogRoot: {
    id: 'routes.blog.root',
    defaultMessage: enDefaults['routes.blog.root']
  },
  personalBoatShopper: {
    id: 'routes.personalBoatShopper.root',
    defaultMessage: enDefaults['routes.personalBoatShopper.root']
  },
  servicesRoot: {
    id: 'routes.services.root',
    defaultMessage: enDefaults['routes.services.root']
  },
  fsboRoot: {
    id: 'routes.fsbo.root',
    defaultMessage: enDefaults['routes.fsbo.root']
  },
  boatDealers: {
    id: 'routes.boatDealers',
    defaultMessage: enDefaults['routes.boatDealers']
  },
  boatLoans: {
    id: 'routes.boatLoans',
    defaultMessage: enDefaults['routes.boatLoans']
  },
  yachtLoansCalculator: {
    id: 'routes.yachtLoansCalculator',
    defaultMessage: enDefaults['routes.yachtLoansCalculator']
  },
  insurance: {
    id: 'routes.insurance',
    defaultMessage: enDefaults['routes.insurance']
  },
  boatTransport: {
    id: 'routes.boatTransport',
    defaultMessage: enDefaults['routes.boatTransport']
  },
  directoryRoot: {
    id: 'routes.directory.root',
    defaultMessage: enDefaults['routes.directory.root']
  },
  search: {
    category: {
      id: 'routes.search.item.category',
      defaultMessage: enDefaults['routes.search.item.category']
    },
    types: {
      id: 'routes.search.item.types',
      defaultMessage: enDefaults['routes.search.item.types']
    },
    class: {
      id: 'routes.search.item.class',
      defaultMessage: enDefaults['routes.search.item.class']
    },
    group: {
      id: 'routes.search.item.group',
      defaultMessage: enDefaults['routes.search.item.group']
    },
    make: {
      id: 'routes.search.item.make',
      defaultMessage: enDefaults['routes.search.item.make']
    },
    model: {
      id: 'routes.search.item.model',
      defaultMessage: enDefaults['routes.search.item.model']
    },
    modelRange: {
      id: 'routes.search.item.modelrange',
      defaultMessage: enDefaults['routes.search.item.modelrange']
    },
    subdivision: {
      id: 'routes.search.item.subdivision',
      defaultMessage: enDefaults['routes.search.item.subdivision']
    },
    subdivisionUS: {
      id: 'routes.search.item.subdivision.us',
      defaultMessage: enDefaults['routes.search.item.subdivision.us']
    },
    subdivisionCA: {
      id: 'routes.search.item.subdivision.ca',
      defaultMessage: enDefaults['routes.search.item.subdivision.ca']
    },
    subdivisionES: {
      id: 'routes.search.item.subdivision.es',
      defaultMessage: enDefaults['routes.search.item.subdivision.es']
    },
    subdivisionIT: {
      id: 'routes.search.item.subdivision.it',
      defaultMessage: enDefaults['routes.search.item.subdivision.it']
    },
    region: {
      id: 'routes.search.item.region',
      defaultMessage: enDefaults['routes.search.item.region']
    },
    worldRegion: {
      id: 'routes.search.item.worldRegion',
      defaultMessage: enDefaults['routes.search.item.worldRegion']
    },
    country: {
      id: 'routes.search.item.country',
      defaultMessage: enDefaults['routes.search.item.country']
    },
    city: {
      id: 'routes.search.item.city',
      defaultMessage: enDefaults['routes.search.item.city']
    },
    postalCode: {
      id: 'routes.search.item.postalcode',
      defaultMessage: enDefaults['routes.search.item.postalcode']
    },
    by: {
      id: 'routes.search.item.by',
      defaultMessage: enDefaults['routes.search.item.by']
    },
    radius: {
      id: 'routes.search.item.radius',
      defaultMessage: enDefaults['routes.search.item.radius']
    },
    makeModel: {
      id: 'routes.search.item.makemodel',
      defaultMessage: enDefaults['routes.search.item.makemodel']
    },
    fuel: {
      id: 'routes.search.item.fuel',
      defaultMessage: enDefaults['routes.search.item.fuel']
    },
    hull: {
      id: 'routes.search.item.hull',
      defaultMessage: enDefaults['routes.search.item.hull']
    },
    engine: {
      id: 'routes.search.item.engine',
      defaultMessage: enDefaults['routes.search.item.engine']
    },
    engineMake: {
      id: 'routes.search.item.engine-make',
      defaultMessage: enDefaults['routes.search.item.engine-make']
    },
    recommended: {
      id: 'routes.search.item.recommended',
      defaultMessage: enDefaults['routes.search.item.recommended']
    },
    length: {
      id: 'routes.search.item.length',
      defaultMessage: enDefaults['routes.search.item.length']
    },
    price: {
      id: 'routes.search.item.price',
      defaultMessage: enDefaults['routes.search.item.price']
    },
    year: {
      id: 'routes.search.item.year',
      defaultMessage: enDefaults['routes.search.item.year']
    },
    condition: {
      id: 'routes.search.item.condition',
      defaultMessage: enDefaults['routes.search.item.condition']
    },
    owner: {
      id: 'routes.brandedSearch.broker',
      defaultMessage: enDefaults['routes.brandedSearch.broker']
    },
    keyword: {
      id: 'routes.search.item.keyword',
      defaultMessage: enDefaults['routes.search.item.keyword']
    },
    page: {
      id: 'routes.search.item.page',
      defaultMessage: enDefaults['routes.search.item.page']
    },
    sort: {
      id: 'routes.search.item.sort',
      defaultMessage: enDefaults['routes.search.item.sort']
    },
    distance: {
      id: 'routes.search.item.distance',
      defaultMessage: enDefaults['routes.search.item.distance']
    },
    updated: {
      id: 'routes.search.item.updated',
      defaultMessage: enDefaults['routes.search.item.updated']
    },
    powerhp: {
      id: 'routes.search.item.powerhp',
      defaultMessage: enDefaults['routes.search.item.powerhp']
    },
    salesRep: {
      id: 'routes.search.item.salesrep',
      defaultMessage: enDefaults['routes.search.item.salesrep']
    },
    enginesNumber: {
      id: 'routes.search.item.enginesnumber',
      defaultMessage: enDefaults['routes.search.item.enginesnumber']
    }
  },
  detailsRoot: {
    id: 'routes.details.root',
    defaultMessage: enDefaults['routes.details.root']
  },
  detailsEngine: {
    id: 'routes.search.item.engine',
    defaultMessage: enDefaults['routes.search.item.engine']
  },
  sortFacet: {
    desc: {
      id: 'routes.search.item.sort.desc',
      defaultMessage: enDefaults['routes.search.item.sort.desc']
    },
    asc: {
      id: 'routes.search.item.sort.asc',
      defaultMessage: enDefaults['routes.search.item.sort.asc']
    }
  },
  conditionFacet: {
    new: {
      id: 'routes.search.item.condition.new',
      defaultMessage: enDefaults['routes.search.item.condition.new']
    },
    used: {
      id: 'routes.search.item.condition.used',
      defaultMessage: enDefaults['routes.search.item.condition.used']
    }
  },
  forSaleFacet: {
    dealer: {
      id: 'routes.search.item.forSale.dealer',
      defaultMessage: enDefaults['routes.search.item.forSale.dealer']
    },
    owner: {
      id: 'routes.search.item.forSale.owner',
      defaultMessage: enDefaults['routes.search.item.forSale.owner']
    }
  },
  typesFacet: {
    power: {
      id: 'routes.search.item.types.power',
      defaultMessage: enDefaults['routes.search.item.types.power']
    },
    sail: {
      id: 'routes.search.item.types.sail',
      defaultMessage: enDefaults['routes.search.item.types.sail']
    },
    pwc: {
      id: 'routes.search.item.types.pwc',
      defaultMessage: enDefaults['routes.search.item.types.pwc']
    },
    unpowered: {
      id: 'routes.search.item.types.unpowered',
      defaultMessage: enDefaults['routes.search.item.types.unpowered']
    },
    any: {
      id: 'routes.search.item.types.any',
      defaultMessage: enDefaults['routes.search.item.types.any']
    }
  },
  groupRoutes: {
    'canal-boats': {
      id: 'routes.search.item.group.canal',
      defaultMessage: enDefaults['routes.search.item.group.canal']
    },
    'fishing-boats': {
      id: 'routes.search.item.group.fishing',
      defaultMessage: enDefaults['routes.search.item.group.fishing']
    },
    yachts: {
      id: 'routes.search.item.group.yachts',
      defaultMessage: enDefaults['routes.search.item.group.yachts']
    }
  },
  classFacet: {
    'power-aft': {
      id: 'routes.search.item.class.power-aft',
      defaultMessage: enDefaults['routes.search.item.class.power-aft']
    },
    'power-airboat': {
      id: 'routes.search.item.class.power-airboat',
      defaultMessage: enDefaults['routes.search.item.class.power-airboat']
    },
    'power-aluminum': {
      id: 'routes.search.item.class.power-aluminum',
      defaultMessage: enDefaults['routes.search.item.class.power-aluminum']
    },
    'power-antique': {
      id: 'routes.search.item.class.power-antique',
      defaultMessage: enDefaults['routes.search.item.class.power-antique']
    },
    'power-barge': {
      id: 'routes.search.item.class.power-barge',
      defaultMessage: enDefaults['routes.search.item.class.power-barge']
    },
    'power-bass': {
      id: 'routes.search.item.class.power-bass',
      defaultMessage: enDefaults['routes.search.item.class.power-bass']
    },
    'power-bay': {
      id: 'routes.search.item.class.power-bay',
      defaultMessage: enDefaults['routes.search.item.class.power-bay']
    },
    'power-bowrider': {
      id: 'routes.search.item.class.power-bowrider',
      defaultMessage: enDefaults['routes.search.item.class.power-bowrider']
    },
    'power-cargo': {
      id: 'routes.search.item.class.power-cargo',
      defaultMessage: enDefaults['routes.search.item.class.power-cargo']
    },
    'power-center': {
      id: 'routes.search.item.class.power-center',
      defaultMessage: enDefaults['routes.search.item.class.power-center']
    },
    'power-commercial': {
      id: 'routes.search.item.class.power-commercial',
      defaultMessage: enDefaults['routes.search.item.class.power-commercial']
    },
    'power-convertible': {
      id: 'routes.search.item.class.power-convertible',
      defaultMessage: enDefaults['routes.search.item.class.power-convertible']
    },
    'power-cruiser': {
      id: 'routes.search.item.class.power-cruiser',
      defaultMessage: enDefaults['routes.search.item.class.power-cruiser']
    },
    'power-cruiseship': {
      id: 'routes.search.item.class.power-cruiseship',
      defaultMessage: enDefaults['routes.search.item.class.power-cruiseship']
    },
    'power-cuddy': {
      id: 'routes.search.item.class.power-cuddy',
      defaultMessage: enDefaults['routes.search.item.class.power-cuddy']
    },
    'power-deck': {
      id: 'routes.search.item.class.power-deck',
      defaultMessage: enDefaults['routes.search.item.class.power-deck']
    },
    'power-dinghy': {
      id: 'routes.search.item.class.power-dinghy',
      defaultMessage: enDefaults['routes.search.item.class.power-dinghy']
    },
    'power-dive': {
      id: 'routes.search.item.class.power-dive',
      defaultMessage: enDefaults['routes.search.item.class.power-dive']
    },
    'power-downeast': {
      id: 'routes.search.item.class.power-downeast',
      defaultMessage: enDefaults['routes.search.item.class.power-downeast']
    },
    'power-dragger': {
      id: 'routes.search.item.class.power-dragger',
      defaultMessage: enDefaults['routes.search.item.class.power-dragger']
    },
    'power-dualconsole': {
      id: 'routes.search.item.class.power-dualconsole',
      defaultMessage: enDefaults['routes.search.item.class.power-dualconsole']
    },
    'power-expresscruiser': {
      id: 'routes.search.item.class.power-expresscruiser',
      defaultMessage:
        enDefaults['routes.search.item.class.power-expresscruiser']
    },
    'power-flats': {
      id: 'routes.search.item.class.power-flats',
      defaultMessage: enDefaults['routes.search.item.class.power-flats']
    },
    'power-flybridge': {
      id: 'routes.search.item.class.power-flybridge',
      defaultMessage: enDefaults['routes.search.item.class.power-flybridge']
    },
    'power-fresh': {
      id: 'routes.search.item.class.power-fresh',
      defaultMessage: enDefaults['routes.search.item.class.power-fresh']
    },
    'power-gulet': {
      id: 'routes.search.item.class.power-gulet',
      defaultMessage: enDefaults['routes.search.item.class.power-gulet']
    },
    'power-highperf': {
      id: 'routes.search.item.class.power-highperf',
      defaultMessage: enDefaults['routes.search.item.class.power-highperf']
    },
    'power-house': {
      id: 'routes.search.item.class.power-house',
      defaultMessage: enDefaults['routes.search.item.class.power-house']
    },
    'power-inflatable': {
      id: 'routes.search.item.class.power-inflatable',
      defaultMessage: enDefaults['routes.search.item.class.power-inflatable']
    },
    'power-jet': {
      id: 'routes.search.item.class.power-jet',
      defaultMessage: enDefaults['routes.search.item.class.power-jet']
    },
    'power-jon': {
      id: 'routes.search.item.class.power-jon',
      defaultMessage: enDefaults['routes.search.item.class.power-jon']
    },
    'power-llaut': {
      id: 'routes.search.item.class.power-llaut',
      defaultMessage: enDefaults['routes.search.item.class.power-llaut']
    },
    'power-lobster': {
      id: 'routes.search.item.class.power-lobster',
      defaultMessage: enDefaults['routes.search.item.class.power-lobster']
    },
    'power-mega': {
      id: 'routes.search.item.class.power-mega',
      defaultMessage: enDefaults['routes.search.item.class.power-mega']
    },
    'power-motor': {
      id: 'routes.search.item.class.power-motor',
      defaultMessage: enDefaults['routes.search.item.class.power-motor']
    },
    'power-motorsailer': {
      id: 'routes.search.item.class.power-motorsailer',
      defaultMessage: enDefaults['routes.search.item.class.power-motorsailer']
    },
    'power-narrow': {
      id: 'routes.search.item.class.power-narrow',
      defaultMessage: enDefaults['routes.search.item.class.power-narrow']
    },
    'power-other': {
      id: 'routes.search.item.class.power-other',
      defaultMessage: enDefaults['routes.search.item.class.power-other']
    },
    'power-passenger': {
      id: 'routes.search.item.class.power-passenger',
      defaultMessage: enDefaults['routes.search.item.class.power-passenger']
    },
    'power-pcatamaran': {
      id: 'routes.search.item.class.power-pcatamaran',
      defaultMessage: enDefaults['routes.search.item.class.power-pcatamaran']
    },
    'power-pilot': {
      id: 'routes.search.item.class.power-pilot',
      defaultMessage: enDefaults['routes.search.item.class.power-pilot']
    },
    'power-pontoon': {
      id: 'routes.search.item.class.power-pontoon',
      defaultMessage: enDefaults['routes.search.item.class.power-pontoon']
    },
    'power-pwc': {
      id: 'routes.search.item.class.power-pwc',
      defaultMessage: enDefaults['routes.search.item.class.power-pwc']
    },
    'power-rib': {
      id: 'routes.search.item.class.power-rib',
      defaultMessage: enDefaults['routes.search.item.class.power-rib']
    },
    'power-rivercruiser': {
      id: 'routes.search.item.class.power-rivercruiser',
      defaultMessage: enDefaults['routes.search.item.class.power-rivercruiser']
    },
    'power-runabout': {
      id: 'routes.search.item.class.power-runabout',
      defaultMessage: enDefaults['routes.search.item.class.power-runabout']
    },
    'power-saltfish': {
      id: 'routes.search.item.class.power-saltfish',
      defaultMessage: enDefaults['routes.search.item.class.power-saltfish']
    },
    'power-skiff': {
      id: 'routes.search.item.class.power-skiff',
      defaultMessage: enDefaults['routes.search.item.class.power-skiff']
    },
    'power-skifish': {
      id: 'routes.search.item.class.power-skifish',
      defaultMessage: enDefaults['routes.search.item.class.power-skifish']
    },
    'power-skiwake': {
      id: 'routes.search.item.class.power-skiwake',
      defaultMessage: enDefaults['routes.search.item.class.power-skiwake']
    },
    'power-sloop': {
      id: 'routes.search.item.class.power-sloop',
      defaultMessage: enDefaults['routes.search.item.class.power-sloop']
    },
    'power-sportcruiser': {
      id: 'routes.search.item.class.power-sportcruiser',
      defaultMessage: enDefaults['routes.search.item.class.power-sportcruiser']
    },
    'power-sportfish': {
      id: 'routes.search.item.class.power-sportfish',
      defaultMessage: enDefaults['routes.search.item.class.power-sportfish']
    },
    'power-tender': {
      id: 'routes.search.item.class.power-tender',
      defaultMessage: enDefaults['routes.search.item.class.power-tender']
    },
    'power-trawler': {
      id: 'routes.search.item.class.power-trawler',
      defaultMessage: enDefaults['routes.search.item.class.power-trawler']
    },
    'power-troller': {
      id: 'routes.search.item.class.power-troller',
      defaultMessage: enDefaults['routes.search.item.class.power-troller']
    },
    'power-tug': {
      id: 'routes.search.item.class.power-tug',
      defaultMessage: enDefaults['routes.search.item.class.power-tug']
    },
    'power-unspec': {
      id: 'routes.search.item.class.power-unspec',
      defaultMessage: enDefaults['routes.search.item.class.power-unspec']
    },
    'power-util': {
      id: 'routes.search.item.class.power-util',
      defaultMessage: enDefaults['routes.search.item.class.power-util']
    },
    'power-walk': {
      id: 'routes.search.item.class.power-walk',
      defaultMessage: enDefaults['routes.search.item.class.power-walk']
    },
    'sail-antique': {
      id: 'routes.search.item.class.sail-antique',
      defaultMessage: enDefaults['routes.search.item.class.sail-antique']
    },
    'sail-barge': {
      id: 'routes.search.item.class.sail-barge',
      defaultMessage: enDefaults['routes.search.item.class.sail-barge']
    },
    'sail-beachcat': {
      id: 'routes.search.item.class.sail-beachcat',
      defaultMessage: enDefaults['routes.search.item.class.sail-beachcat']
    },
    'sail-catamaran': {
      id: 'routes.search.item.class.sail-catamaran',
      defaultMessage: enDefaults['routes.search.item.class.sail-catamaran']
    },
    'sail-centercockpit': {
      id: 'routes.search.item.class.sail-centercockpit',
      defaultMessage: enDefaults['routes.search.item.class.sail-centercockpit']
    },
    'sail-commercial': {
      id: 'routes.search.item.class.sail-commercial',
      defaultMessage: enDefaults['routes.search.item.class.sail-commercial']
    },
    'sail-cruiser': {
      id: 'routes.search.item.class.sail-cruiser',
      defaultMessage: enDefaults['routes.search.item.class.sail-cruiser']
    },
    'sail-cutter': {
      id: 'routes.search.item.class.sail-cutter',
      defaultMessage: enDefaults['routes.search.item.class.sail-cutter']
    },
    'sail-day': {
      id: 'routes.search.item.class.sail-day',
      defaultMessage: enDefaults['routes.search.item.class.sail-day']
    },
    'sail-deck': {
      id: 'routes.search.item.class.sail-deck',
      defaultMessage: enDefaults['routes.search.item.class.sail-deck']
    },
    'sail-dinghy': {
      id: 'routes.search.item.class.sail-dinghy',
      defaultMessage: enDefaults['routes.search.item.class.sail-dinghy']
    },
    'sail-gulet': {
      id: 'routes.search.item.class.sail-gulet',
      defaultMessage: enDefaults['routes.search.item.class.sail-gulet']
    },
    'sail-ketch': {
      id: 'routes.search.item.class.sail-ketch',
      defaultMessage: enDefaults['routes.search.item.class.sail-ketch']
    },
    'sail-motor': {
      id: 'routes.search.item.class.sail-motor',
      defaultMessage: enDefaults['routes.search.item.class.sail-motor']
    },
    'sail-multihull': {
      id: 'routes.search.item.class.sail-multihull',
      defaultMessage: enDefaults['routes.search.item.class.sail-multihull']
    },
    'sail-other': {
      id: 'routes.search.item.class.sail-other',
      defaultMessage: enDefaults['routes.search.item.class.sail-other']
    },
    'sail-performance': {
      id: 'routes.search.item.class.sail-performance',
      defaultMessage: enDefaults['routes.search.item.class.sail-performance']
    },
    'sail-pilot': {
      id: 'routes.search.item.class.sail-pilot',
      defaultMessage: enDefaults['routes.search.item.class.sail-pilot']
    },
    'sail-racer': {
      id: 'routes.search.item.class.sail-racer',
      defaultMessage: enDefaults['routes.search.item.class.sail-racer']
    },
    'sail-racercruiser': {
      id: 'routes.search.item.class.sail-racercruiser',
      defaultMessage: enDefaults['routes.search.item.class.sail-racercruiser']
    },
    'sail-schooner': {
      id: 'routes.search.item.class.sail-schooner',
      defaultMessage: enDefaults['routes.search.item.class.sail-schooner']
    },
    'sail-sloop': {
      id: 'routes.search.item.class.sail-sloop',
      defaultMessage: enDefaults['routes.search.item.class.sail-sloop']
    },
    'sail-trimaran': {
      id: 'routes.search.item.class.sail-trimaran',
      defaultMessage: enDefaults['routes.search.item.class.sail-trimaran']
    },
    'sail-unspec': {
      id: 'routes.search.item.class.sail-unspec',
      defaultMessage: enDefaults['routes.search.item.class.sail-unspec']
    },
    'sail-yawl': {
      id: 'routes.search.item.class.sail-yawl',
      defaultMessage: enDefaults['routes.search.item.class.sail-yawl']
    },
    'unpowered-barge': {
      id: 'routes.search.item.class.unpowered-barge',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-barge']
    },
    'unpowered-dinghy': {
      id: 'routes.search.item.class.unpowered-dinghy',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-dinghy']
    },
    'unpowered-inflatable': {
      id: 'routes.search.item.class.unpowered-inflatable',
      defaultMessage:
        enDefaults['routes.search.item.class.unpowered-inflatable']
    },
    'unpowered-kayak': {
      id: 'routes.search.item.class.unpowered-kayak',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-kayak']
    },
    'unpowered-narrow': {
      id: 'routes.search.item.class.unpowered-narrow',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-narrow']
    },
    'unpowered-other': {
      id: 'routes.search.item.class.unpowered-other',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-other']
    },
    'unpowered-tender': {
      id: 'routes.search.item.class.unpowered-tender',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-tender']
    },
    'unpowered-unspec': {
      id: 'routes.search.item.class.unpowered-unspec',
      defaultMessage: enDefaults['routes.search.item.class.unpowered-unspec']
    }
  },
  radiusFacet: {
    any: {
      id: 'routes.search.item.radius.any',
      defaultMessage: enDefaults['routes.search.item.radius.any']
    },
    exact: {
      id: 'routes.search.item.radius.exact',
      defaultMessage: enDefaults['routes.search.item.radius.exact']
    },
    label: {
      id: 'routes.search.item.radius.label',
      defaultMessage: enDefaults['routes.search.item.radius.label']
    }
  },
  categoryFacet: {
    inboard: {
      id: 'routes.search.item.category.inboard',
      defaultMessage: enDefaults['routes.search.item.category.inboard']
    },
    jet: {
      id: 'routes.search.item.category.jet',
      defaultMessage: enDefaults['routes.search.item.category.jet']
    },
    outboard: {
      id: 'routes.search.item.category.outboard',
      defaultMessage: enDefaults['routes.search.item.category.outboard']
    },
    'outboard-2s': {
      id: 'routes.search.item.category.outboard-2s',
      defaultMessage: enDefaults['routes.search.item.category.outboard-2s']
    },
    'outboard-4s': {
      id: 'routes.search.item.category.outboard-4s',
      defaultMessage: enDefaults['routes.search.item.category.outboard-4s']
    },
    'stern-drive': {
      id: 'routes.search.item.category.stern-drive',
      defaultMessage: enDefaults['routes.search.item.category.stern-drive']
    }
  },
  categoryFacetText: {
    inboard: {
      id: 'app.search.filter.category.inboard',
      defaultMessage: enDefaults['app.search.filter.category.inboard']
    },
    jet: {
      id: 'app.search.filter.category.jet',
      defaultMessage: enDefaults['app.search.filter.category.jet']
    },
    outboard: {
      id: 'app.search.filter.category.outboard',
      defaultMessage: enDefaults['app.search.filter.category.outboard']
    },
    'outboard-2s': {
      id: 'app.search.filter.category.outboard-2s',
      defaultMessage: enDefaults['app.search.filter.category.outboard-2s']
    },
    'outboard-4s': {
      id: 'app.search.filter.category.outboard-4s',
      defaultMessage: enDefaults['app.search.filter.category.outboard-4s']
    },
    'stern-drive': {
      id: 'app.search.filter.category.stern-drive',
      defaultMessage: enDefaults['app.search.filter.category.stern-drive']
    }
  },
  fuelTypeFacet: {
    diesel: {
      id: 'routes.search.item.fuel-type.diesel',
      defaultMessage: enDefaults['routes.search.item.fuel-type.diesel']
    },
    electric: {
      id: 'routes.search.item.fuel-type.electric',
      defaultMessage: enDefaults['routes.search.item.fuel-type.electric']
    },
    gasoline: {
      id: 'routes.search.item.fuel-type.gasoline',
      defaultMessage: enDefaults['routes.search.item.fuel-type.gasoline']
    },
    lpg: {
      id: 'routes.search.item.fuel-type.lpg',
      defaultMessage: enDefaults['routes.search.item.fuel-type.lpg']
    },
    other: {
      id: 'routes.search.item.fuel-type.other',
      defaultMessage: enDefaults['routes.search.item.fuel-type.other']
    }
  },
  fuelTypeFacetText: {
    diesel: {
      id: 'app.search.filter.fuelType.diesel',
      defaultMessage: enDefaults['app.search.filter.fuelType.diesel']
    },
    electric: {
      id: 'app.search.filter.fuelType.electric',
      defaultMessage: enDefaults['app.search.filter.fuelType.electric']
    },
    gasoline: {
      id: 'app.search.filter.fuelType.gasoline',
      defaultMessage: enDefaults['app.search.filter.fuelType.gasoline']
    },
    lpg: {
      id: 'app.search.filter.fuelType.lpg',
      defaultMessage: enDefaults['app.search.filter.fuelType.lpg']
    },
    other: {
      id: 'app.search.filter.fuelType.other',
      defaultMessage: enDefaults['app.search.filter.fuelType.other']
    }
  },
  fuelTypeHeadingText: {
    electric: {
      id: 'app.search.filter.fuelType.electric.heading',
      defaultMessage: 'app.search.filter.fuelType.electric.heading'
    }
  },
  hullMaterialFacet: {
    aluminum: {
      id: 'routes.search.item.hull-material.aluminum',
      defaultMessage: enDefaults['routes.search.item.hull-material.aluminum']
    },
    composite: {
      id: 'routes.search.item.hull-material.composite',
      defaultMessage: enDefaults['routes.search.item.hull-material.composite']
    },
    'ferro-cement': {
      id: 'routes.search.item.hull-material.ferro-cement',
      defaultMessage:
        enDefaults['routes.search.item.hull-material.ferro-cement']
    },
    fiberglass: {
      id: 'routes.search.item.hull-material.fiberglass',
      defaultMessage: enDefaults['routes.search.item.hull-material.fiberglass']
    },
    hypalon: {
      id: 'routes.search.item.hull-material.hypalon',
      defaultMessage: enDefaults['routes.search.item.hull-material.hypalon']
    },
    other: {
      id: 'routes.search.item.hull-material.other',
      defaultMessage: enDefaults['routes.search.item.hull-material.other']
    },
    plastic: {
      id: 'routes.search.item.hull-material.plastic',
      defaultMessage: enDefaults['routes.search.item.hull-material.plastic']
    },
    pvc: {
      id: 'routes.search.item.hull-material.plastic',
      defaultMessage: enDefaults['routes.search.item.hull-material.plastic']
    },
    steel: {
      id: 'routes.search.item.hull-material.steel',
      defaultMessage: enDefaults['routes.search.item.hull-material.steel']
    },
    wood: {
      id: 'routes.search.item.hull-material.wood',
      defaultMessage: enDefaults['routes.search.item.hull-material.wood']
    }
  },
  hullMaterialFacetText: {
    aluminum: {
      id: 'app.search.filter.hullMaterial.aluminum',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.aluminum']
    },
    composite: {
      id: 'app.search.filter.hullMaterial.composite',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.composite']
    },
    'ferro-cement': {
      id: 'app.search.filter.hullMaterial.ferro-cement',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.ferro-cement']
    },
    fiberglass: {
      id: 'app.search.filter.hullMaterial.fiberglass',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.fiberglass']
    },
    hypalon: {
      id: 'app.search.filter.hullMaterial.hypalon',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.hypalon']
    },
    other: {
      id: 'app.search.filter.hullMaterial.other',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.other']
    },
    plastic: {
      id: 'app.search.filter.hullMaterial.plastic',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.plastic']
    },
    pvc: {
      id: 'app.search.filter.hullMaterial.plastic',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.plastic']
    },
    roplene: {
      id: 'app.search.filter.hullMaterial.roplene',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.roplene']
    },
    steel: {
      id: 'app.search.filter.hullMaterial.steel',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.steel']
    },
    wood: {
      id: 'app.search.filter.hullMaterial.wood',
      defaultMessage: enDefaults['app.search.filter.hullMaterial.wood']
    }
  },
  engineFacetText: {
    direct: {
      id: 'app.boatDetails.value.drive-type.direct',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.direct']
    },
    stern: {
      id: 'app.boatDetails.value.drive-type.stern',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.stern']
    },
    sail: {
      id: 'app.boatDetails.value.drive-type.sail',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.sail']
    },
    v: {
      id: 'app.boatDetails.value.drive-type.v',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.v']
    },
    pod: {
      id: 'app.boatDetails.value.drive-type.pod',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.pod']
    },
    other: {
      id: 'app.boatDetails.value.drive-type.other',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.other']
    },
    jet: {
      id: 'app.boatDetails.value.drive-type.jet',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.jet']
    },
    surface: {
      id: 'app.boatDetails.value.drive-type.surface',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.surface']
    },
    'air-propeller': {
      id: 'app.boatDetails.value.drive-type.air-propeller',
      defaultMessage: enDefaults['app.boatDetails.value.drive-type.air-propeller']
    }
  },
  regionFacet: {
    northeast: {
      id: 'routes.search.item.region.us.northeast',
      defaultMessage: enDefaults['routes.search.item.region.us.northeast']
    },
    midatlantic: {
      id: 'routes.search.item.region.us.mid-atlantic',
      defaultMessage: enDefaults['routes.search.item.region.us.mid-atlantic']
    },
    greatlakes: {
      id: 'routes.search.item.region.us.great-lakes',
      defaultMessage: enDefaults['routes.search.item.region.us.great-lakes']
    },
    midwest: {
      id: 'routes.search.item.region.us.midwest',
      defaultMessage: enDefaults['routes.search.item.region.us.midwest']
    },
    southeast: {
      id: 'routes.search.item.region.us.southeast',
      defaultMessage: enDefaults['routes.search.item.region.us.southeast']
    },
    gulfcoast: {
      id: 'routes.search.item.region.us.gulf-coast',
      defaultMessage: enDefaults['routes.search.item.region.us.gulf-coast']
    },
    southwest: {
      id: 'routes.search.item.region.us.southwest',
      defaultMessage: enDefaults['routes.search.item.region.us.southwest']
    },
    west: {
      id: 'routes.search.item.region.us.west',
      defaultMessage: enDefaults['routes.search.item.region.us.west']
    },
    pacificnorthwest: {
      id: 'routes.search.item.region.us.pacific-northwest',
      defaultMessage:
        enDefaults['routes.search.item.region.us.pacific-northwest']
    },
    heartland: {
      id: 'routes.search.item.region.us.heartland',
      defaultMessage: enDefaults['routes.search.item.region.us.heartland']
    }
  },
  worldRegionFacet: {
    africa: {
      id: 'routes.search.item.worldRegion.africa',
      defaultMessage: enDefaults['routes.search.item.worldRegion.africa']
    },
    asia: {
      id: 'routes.search.item.worldRegion.asia',
      defaultMessage: enDefaults['routes.search.item.worldRegion.asia']
    },
    europe: {
      id: 'routes.search.item.worldRegion.europe',
      defaultMessage: enDefaults['routes.search.item.worldRegion.europe']
    },
    northamerica: {
      id: 'routes.search.item.worldRegion.northamerica',
      defaultMessage: enDefaults['routes.search.item.worldRegion.northamerica']
    },
    oceania: {
      id: 'routes.search.item.worldRegion.oceania',
      defaultMessage: enDefaults['routes.search.item.worldRegion.oceania']
    },
    southamerica: {
      id: 'routes.search.item.worldRegion.southamerica',
      defaultMessage: enDefaults['routes.search.item.worldRegion.southamerica']
    }
  },
  footer: {
    allRightsReserved: {
      id: 'app.footer.allRightsReserved',
      defaultMessage: enDefaults['app.footer.allRightsReserved']
    },
    endorsedBranding: {
      id: 'app.footer.endorsedBranding',
      defaultMessage: enDefaults['app.footer.endorsedBranding']
    },
    impressum: {
      name: {
        id: 'app.footer.impressum.name',
        defaultMessage: enDefaults['app.footer.impressum.name']
      },
      url: {
        id: 'app.footer.impressum.url',
        defaultMessage: enDefaults['app.footer.impressum.url']
      }
    },
    aboutUs: {
      name: {
        id: 'app.footer.aboutUs.name',
        defaultMessage: enDefaults['app.footer.aboutUs.name']
      },
      url: {
        id: 'app.footer.aboutUs.url',
        defaultMessage: enDefaults['app.footer.aboutUs.url']
      }
    },
    boatsGroup: {
      id: 'app.footer.boatsGroup',
      defaultMessage: enDefaults['app.footer.boatsGroup']
    },
    copyright: {
      id: 'app.footer.copyright',
      defaultMessage: enDefaults['app.footer.copyright']
    },
    copyrightLink: {
      name: {
        id: 'app.footer.copyrightLink.name',
        defaultMessage: enDefaults['app.footer.copyrightLink.name']
      }
    },
    cookiesPolicy: {
      name: {
        id: 'app.footer.cookiesPolicy.name',
        defaultMessage: enDefaults['app.footer.cookiesPolicy.name']
      },
      url: {
        id: 'app.footer.cookiesPolicy.url',
        defaultMessage: enDefaults['app.footer.cookiesPolicy.url']
      }
    },
    termsAndConditions: {
      name: {
        id: 'app.footer.termsAndConditions.name',
        defaultMessage: enDefaults['app.footer.termsAndConditions.name']
      },
      url: {
        id: 'app.footer.termsAndConditions.url',
        defaultMessage: enDefaults['app.footer.termsAndConditions.url']
      }
    },
    privacyPolicy: {
      name: {
        id: 'app.footer.privacyPolicy.name',
        defaultMessage: enDefaults['app.footer.privacyPolicy.name']
      },
      url: {
        id: 'app.footer.privacyPolicy.url',
        defaultMessage: enDefaults['app.footer.privacyPolicy.url']
      }
    },
    adChoices: {
      id: 'app.footer.adChoices',
      defaultMessage: enDefaults['app.footer.adChoices']
    },
    advertiseWithUs: {
      name: {
        id: 'app.footer.subFooter.advertiseWithUs.name',
        defaultMessage: enDefaults['app.footer.subFooter.advertiseWithUs.name']
      },
      url: {
        id: 'app.footer.subFooter.advertiseWithUs.url',
        defaultMessage: enDefaults['app.footer.subFooter.advertiseWithUs.url']
      }
    },
    doNotSellMyPersonalInfo: {
      name: {
        id: 'app.footer.doNotSellMyPersonalInfo.name',
        defaultMessage: enDefaults['app.footer.doNotSellMyPersonalInfo.name']
      },
      url: {
        id: 'app.footer.doNotSellMyPersonalInfo.url',
        defaultMessage: enDefaults['app.footer.doNotSellMyPersonalInfo.url']
      }
    },
    socialLinks: {
      youtube: {
        name: {
          id: 'app.footer.socialLinks.youtube.name',
          defaultMessage: enDefaults['app.footer.socialLinks.youtube.name']
        },
        url: {
          id: 'app.footer.socialLinks.youtube.url',
          defaultMessage: enDefaults['app.footer.socialLinks.youtube.url']
        }
      },
      instagram: {
        name: {
          id: 'app.footer.socialLinks.instagram.name',
          defaultMessage: enDefaults['app.footer.socialLinks.instagram.name']
        },
        url: {
          id: 'app.footer.socialLinks.instagram.url',
          defaultMessage: enDefaults['app.footer.socialLinks.instagram.url']
        }
      },
      facebook: {
        name: {
          id: 'app.footer.socialLinks.facebook.name',
          defaultMessage: enDefaults['app.footer.socialLinks.facebook.name']
        },
        url: {
          id: 'app.footer.socialLinks.facebook.url',
          defaultMessage: enDefaults['app.footer.socialLinks.facebook.url']
        }
      },
      twitter: {
        name: {
          id: 'app.footer.socialLinks.twitter.name',
          defaultMessage: enDefaults['app.footer.socialLinks.twitter.name']
        },
        url: {
          id: 'app.footer.socialLinks.twitter.url',
          defaultMessage: enDefaults['app.footer.socialLinks.twitter.url']
        }
      }
    },
    subFooter: {
      contactUs: {
        name: {
          id: 'app.footer.subFooter.contactUs.name',
          defaultMessage: enDefaults['app.footer.subFooter.contactUs.name']
        },
        url: {
          id: 'app.footer.subFooter.contactUs.url',
          defaultMessage: enDefaults['app.footer.subFooter.contactUs.url']
        }
      },
      help: {
        name: {
          id: 'app.footer.subFooter.help.name',
          defaultMessage: enDefaults['app.footer.subFooter.help.name']
        },
        url: {
          id: 'app.footer.subFooter.help.url',
          defaultMessage: enDefaults['app.footer.subFooter.help.url']
        }
      },
      aboutUs: {
        name: {
          id: 'app.footer.subFooter.aboutUs.name',
          defaultMessage: enDefaults['app.footer.subFooter.aboutUs.name']
        },
        url: {
          id: 'app.footer.subFooter.aboutUs.url',
          defaultMessage: enDefaults['app.footer.subFooter.aboutUs.url']
        }
      },
      advertiseWithUs: {
        name: {
          id: 'app.footer.subFooter.advertiseWithUs.name',
          defaultMessage:
            enDefaults['app.footer.subFooter.advertiseWithUs.name']
        },
        url: {
          id: 'app.footer.subFooter.advertiseWithUs.url',
          defaultMessage: enDefaults['app.footer.subFooter.advertiseWithUs.url']
        }
      },
      mediaKit: {
        name: {
          id: 'app.footer.subFooter.mediaKit.name',
          defaultMessage: enDefaults['app.footer.subFooter.mediaKit.name']
        },
        url: {
          id: 'app.footer.subFooter.mediaKit.url',
          defaultMessage: enDefaults['app.footer.subFooter.mediaKit.url']
        }
      },
      membership: {
        name: {
          id: 'app.footer.subFooter.membership.name',
          defaultMessage: enDefaults['app.footer.subFooter.membership.name']
        },
        url: {
          id: 'app.footer.subFooter.membership.url',
          defaultMessage: enDefaults['app.footer.subFooter.membership.url']
        }
      },
      cookies: {
        name: {
          id: 'app.footer.subFooter.cookies.name',
          defaultMessage: enDefaults['app.footer.subFooter.cookies.name']
        },
        url: {
          id: 'app.footer.subFooter.cookies.url',
          defaultMessage: enDefaults['app.footer.subFooter.cookies.url']
        }
      },
      doNotSellMyPersonalInformation: {
        name: {
          id: 'app.footer.subFooter.doNotSellMyPersonalInformation.name',
          defaultMessage:
            enDefaults[
              'app.footer.subFooter.doNotSellMyPersonalInformation.name'
            ]
        },
        url: {
          id: 'app.footer.subFooter.doNotSellMyPersonalInformation.url',
          defaultMessage:
            enDefaults[
              'app.footer.subFooter.doNotSellMyPersonalInformation.url'
            ]
        }
      }
    },
    newsletterSubscription: {
      signUp: {
        id: 'app.footer.newsletterSubscription.signUp',
        defaultMessage: enDefaults['app.footer.newsletterSubscription.signUp']
      },
      description: {
        id: 'app.footer.newsletterSubscription.description',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.description']
      },
      disclaimer: {
        id: 'app.footer.newsletterSubscription.disclaimer',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.disclaimer']
      },
      disclaimerAnd: {
        id: 'app.footer.newsletterSubscription.disclaimerAnd',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.disclaimerAnd']
      },
      enterEmail: {
        id: 'app.footer.newsletterSubscription.enterEmail',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.enterEmail']
      },
      subscribe: {
        id: 'app.footer.newsletterSubscription.subscribe',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.subscribe']
      },
      confirmation: {
        id: 'app.footer.newsletterSubscription.confirmation',
        defaultMessage:
          enDefaults['app.footer.newsletterSubscription.confirmation']
      }
    }
  },
  brandedSearch: {
    SEO: {
      metaElements: {
        title: {
          id: 'app.brandedSearch.SEO.metaElements.title',
          defaultMessage: enDefaults['app.brandedSearch.SEO.metaElements.title']
        },
        description: {
          id: 'app.brandedSearch.SEO.metaElements.description',
          defaultMessage:
            enDefaults['app.brandedSearch.SEO.metaElements.description']
        }
      },
      breadcrumbs: {
        id: 'app.brandedSearch.SEO.breadcrumbs',
        defaultMessage: enDefaults['app.brandedSearch.SEO.breadcrumbs']
      }
    }
  },
  brandedOemSearch: {
    brand: {
      aboutTitle: {
        id: 'app.brandedOemSearch.brand.aboutTitle',
        defaultMessage: enDefaults['app.brandedOemSearch.brand.learnMoreAbout']
      },
      seeListings: {
        id: 'app.brandedOemSearch.brand.seeListings',
        defaultMessage: enDefaults['app.brandedOemSearch.brand.seeListings']
      },
      learnMoreAbout: {
        id: 'app.brandedOemSearch.brand.learnMoreAbout',
        defaultMessage: enDefaults['app.brandedOemSearch.brand.learnMoreAbout']
      },
      informationTitle: {
        id: 'app.brandedOemSearch.brand.informationTitle',
        defaultMessage:
          enDefaults['app.brandedOemSearch.brand.informationTitle']
      },
      externalLinks: {
        buildPrice: {
          id: 'app.brandedOemSearch.brand.externalLinks.buildPrice',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.buildPrice']
        },
        customService: {
          id: 'app.brandedOemSearch.brand.externalLinks.customService',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.customService']
        },
        helpMeChoose: {
          id: 'app.brandedOemSearch.brand.externalLinks.helpMeChoose',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.helpMeChoose']
        },
        learnMore: {
          id: 'app.brandedOemSearch.brand.externalLinks.learnMore',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.learnMore']
        },
        maintenance: {
          id: 'app.brandedOemSearch.brand.externalLinks.maintenance',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.maintenance']
        },
        news: {
          id: 'app.brandedOemSearch.brand.externalLinks.news',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.news']
        },
        ownersManuals: {
          id: 'app.brandedOemSearch.brand.externalLinks.ownersManuals',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.ownersManuals']
        },
        performanceTests: {
          id: 'app.brandedOemSearch.brand.externalLinks.performanceTests',
          defaultMessage:
            enDefaults[
              'app.brandedOemSearch.brand.externalLinks.performanceTests'
            ]
        },
        promotions: {
          id: 'app.brandedOemSearch.brand.externalLinks.promotions',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.promotions']
        },
        upcomingEvents: {
          id: 'app.brandedOemSearch.brand.externalLinks.upcomingEvents',
          defaultMessage:
            enDefaults[
              'app.brandedOemSearch.brand.externalLinks.upcomingEvents'
            ]
        },
        warranty: {
          id: 'app.brandedOemSearch.brand.externalLinks.warranty',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.warranty']
        },
        resources: {
          id: 'app.brandedOemSearch.brand.externalLinks.resources',
          defaultMessage:
            enDefaults['app.brandedOemSearch.brand.externalLinks.resources']
        }
      }
    },
    manufacturerContact: {
      back: {
        id: 'app.brandedOemSearch.manufacturerContact.back',
        defaultMessage: ''
      },
      title: {
        id: 'app.brandedOemSearch.manufacturerContact.title',
        defaultMessage: ''
      }
    },
    dealerContact: {
      title: {
        id: 'app.brandedOemSearch.dealerContact.title',
        defaultMessage: ''
      }
    }
  },
  partySearch: {
    title: {
      id: 'app.partySearch.title',
      defaultMessage: enDefaults['app.partySearch.title']
    },
    results: {
      tel: {
        id: 'app.partySearch.results.tel',
        defaultMessage: enDefaults['app.partySearch.results.tel']
      }
    },
    radius: {
      id: 'app.partySearch.radius',
      defaultMessage: enDefaults['app.partySearch.radius']
    },
    error: {
      id: 'app.partySearch.error',
      defaultMessage: enDefaults['app.partySearch.error']
    },
    noResults: {
      id: 'app.partySearch.noResults',
      defaultMessage: enDefaults['app.partySearch.noResults']
    },
    withinRadius: {
      id: 'app.partySearch.withinRadius',
      defaultMessage: enDefaults['app.partySearch.withinRadius']
    },
    keywordPlaceHolder: {
      id: 'app.partySearch.keywordPlaceHolder',
      defaultMessage: enDefaults['app.partySearch.keywordPlaceHolder']
    },
    dealerPlaceHolder: {
      id: 'app.partySearch.dealerPlaceHolder',
      defaultMessage: enDefaults['app.partySearch.dealerPlaceHolder']
    },
    locationPlaceHolder: {
      id: 'app.partySearch.locationPlaceHolder',
      defaultMessage: enDefaults['app.partySearch.locationPlaceHolder']
    },
    search: {
      id: 'app.partySearch.search',
      defaultMessage: enDefaults['app.partySearch.search']
    },
    SEO: {
      metaElements: {
        title: {
          id: 'app.partySearch.SEO.metaElements.title',
          defaultMessage: enDefaults['app.partySearch.SEO.metaElements.title']
        },
        description: {
          id: 'app.partySearch.SEO.metaElements.description',
          defaultMessage:
            enDefaults['app.partySearch.SEO.metaElements.description']
        }
      },
      breadcrumbs: {
        id: 'app.partySearch.SEO.breadcrumbs',
        defaultMessage: enDefaults['app.partySearch.SEO.breadcrumbs']
      }
    },
    routes: {
      keyword: {
        param: {
          id: 'app.partySearch.routes.item.keyword.param',
          defaultMessage:
            enDefaults['app.partySearch.routes.item.keyword.param']
        }
      },
      location: {
        param: {
          id: 'app.partySearch.routes.item.location.param',
          defaultMessage:
            enDefaults['app.partySearch.routes.item.location.param']
        }
      },
      distance: {
        param: {
          id: 'app.partySearch.routes.item.distance.param',
          defaultMessage:
            enDefaults['app.partySearch.routes.item.distance.param']
        }
      },
      sort: {
        param: {
          id: 'app.partySearch.routes.item.sort.param',
          defaultMessage: enDefaults['app.partySearch.routes.item.sort.param']
        },
        value: {
          'proximity-asc': {
            id: 'app.partySearch.routes.item.sort.value.proximity.asc',
            defaultMessage:
              enDefaults['app.partySearch.routes.item.sort.value.proximity.asc']
          },
          'proximity-desc': {
            id: 'app.partySearch.routes.item.sort.value.proximity.desc',
            defaultMessage:
              enDefaults[
                'app.partySearch.routes.item.sort.value.proximity.desc'
              ]
          },
          'displayName-asc': {
            id: 'app.partySearch.routes.item.sort.value.display-name.asc',
            defaultMessage:
              enDefaults[
                'app.partySearch.routes.item.sort.value.display-name.asc'
              ]
          },
          'displayName-desc': {
            id: 'app.partySearch.routes.item.sort.value.display-name.desc',
            defaultMessage:
              enDefaults[
                'app.partySearch.routes.item.sort.value.display-name.desc'
              ]
          }
        }
      },
      page: {
        param: {
          id: 'app.partySearch.routes.item.page.param',
          defaultMessage: enDefaults['app.partySearch.routes.item.page.param']
        }
      },
      region: {
        param: {
          id: 'app.partySearch.routes.item.region.param',
          defaultMessage: enDefaults['app.partySearch.routes.item.region.param']
        }
      },
      subdivision: {
        param: {
          id: 'app.partySearch.routes.item.subdivision.param',
          defaultMessage:
            enDefaults['app.partySearch.routes.item.subdivision.param']
        }
      }
    }
  },
  additionalLeads: {
    thankYou: {
      id: 'app.additionalLeads.thankYou',
      defaultMessage: enDefaults['app.additionalLeads.thankYou']
    },
    messageSent: {
      id: 'app.additionalLeads.messageSent',
      defaultMessage: enDefaults['app.additionalLeads.messageSent']
    },
    similarBoats: {
      id: 'app.additionalLeads.similarBoats',
      defaultMessage: enDefaults['app.additionalLeads.similarBoats']
    },
    requestInfo: {
      id: 'app.additionalLeads.requestInfo',
      defaultMessage: enDefaults['app.additionalLeads.requestInfo']
    },
    keepLooking: {
      id: 'app.additionalLeads.keepLooking',
      defaultMessage: enDefaults['app.additionalLeads.keepLooking']
    },
    sendAdditionalEmails: {
      id: 'app.additionalLeads.sendAdditionalEmails',
      defaultMessage: enDefaults['app.additionalLeads.sendAdditionalEmails']
    }
  },
  contactForm: {
    fullName: {
      id: 'app.contactForm.fullName',
      defaultMessage: enDefaults['app.contactForm.fullName']
    },
    email: {
      id: 'app.contactForm.email',
      defaultMessage: enDefaults['app.contactForm.email']
    },
    phone: {
      id: 'app.contactForm.phone',
      defaultMessage: enDefaults['app.contactForm.phone']
    },
    comments: {
      id: 'app.contactForm.comments',
      defaultMessage: enDefaults['app.contactForm.comments']
    },
    firstName: {
      id: 'app.contactForm.firstName',
      defaultMessage: enDefaults['app.contactForm.firstName']
    },
    yourEmail: {
      id: 'app.contactForm.yourEmail',
      defaultMessage: enDefaults['app.contactForm.yourEmail']
    },
    yourPhone: {
      id: 'app.contactForm.yourPhone',
      defaultMessage: enDefaults['app.contactForm.yourPhone']
    },
    selectCountry: {
      id: 'app.contactForm.selectCountry',
      defaultMessage: enDefaults['app.contactForm.selectCountry']
    },
    country: {
      id: 'app.contactForm.country',
      defaultMessage: enDefaults['app.contactForm.country']
    },
    title: {
      id: 'app.contactForm.title',
      defaultMessage: enDefaults['app.contactForm.title']
    },
    contactButton: {
      id: 'app.contactForm.contactButton',
      defaultMessage: enDefaults['app.contactForm.contactButton']
    },
    close: {
      id: 'app.contactForm.close',
      defaultMessage: enDefaults['app.contactForm.close']
    },
    formError: {
      id: 'app.contactForm.formError',
      defaultMessage: enDefaults['app.contactForm.formError']
    },
    messageSentTitle: {
      id: 'app.contactForm.messageSentTitle',
      defaultMessage: enDefaults['app.contactForm.messageSentTitle']
    },
    messageSent: {
      id: 'app.contactForm.messageSent',
      defaultMessage: enDefaults['app.contactForm.messageSent']
    },
    messageErrorTitle: {
      id: 'app.contactForm.messageErrorTitle',
      defaultMessage: enDefaults['app.contactForm.messageErrorTitle']
    },
    messageError: {
      id: 'app.contactForm.messageError',
      defaultMessage: enDefaults['app.contactForm.messageError']
    },
    prePopulatedText: {
      id: 'app.contactForm.prePopulatedText',
      defaultMessage: enDefaults['app.contactForm.prePopulatedText']
    },
    prePopulatedTextBrandedSrp: {
      id: 'app.contactForm.prePopulatedText.brandedSRP',
      defaultMessage: enDefaults['app.contactForm.prePopulatedText.brandedSRP']
    }
  },
  detailsManufacturer: {
    findDealerButton: {
      id: 'app.detailsManufacturer.findDealerButton',
      defaultMessage: enDefaults['app.detailsManufacturer.findDealerButton']
    },
    dealerContactButton: {
      id: 'app.detailsManufacturer.dealerContactButton',
      defaultMessage: enDefaults['app.detailsManufacturer.dealerContactButton']
    }
  },
  contactGroup: {
    requestInformation: {
      id: 'app.contactGroup.requestInformation',
      defaultMessage: enDefaults['app.contactGroup.requestInformation']
    },
    call: {
      id: 'app.contactGroup.call',
      defaultMessage: enDefaults['app.contactGroup.call']
    },
    callNow: {
      id: 'app.contactGroup.callNow',
      defaultMessage: enDefaults['app.contactGroup.callNow']
    },
    callSellerNow: {
      id: 'app.contactGroup.callSellerNow',
      defaultMessage: enDefaults['app.contactGroup.callSellerNow']
    },
    contact: {
      id: 'app.contactGroup.contact',
      defaultMessage: enDefaults['app.contactGroup.contact']
    },
    offeredBy: {
      id: 'app.contactGroup.offeredBy',
      defaultMessage: enDefaults['app.contactGroup.offeredBy']
    },
    phoneReveal: {
      id: 'app.contactGroup.phoneReveal',
      defaultMessage: enDefaults['app.contactGroup.phoneReveal']
    }
  },
  relatedContent: {
    boats: {
      listingConditions: {
        new: {
          id: 'app.relatedContent.boats.listing.condition.new',
          defaultMessage:
            enDefaults['app.relatedContent.boats.listing.condition.new']
        },
        used: {
          id: 'app.relatedContent.boats.listing.condition.used',
          defaultMessage:
            enDefaults['app.relatedContent.boats.listing.condition.used']
        }
      },
      listingCondition: {
        id: 'app.relatedContent.boats.listing.condition',
        defaultMessage: enDefaults['app.relatedContent.boats.listing.condition']
      },
      listingConditionMake: {
        id: 'app.relatedContent.boats.listing.condition-make',
        defaultMessage:
          enDefaults['app.relatedContent.boats.listing.condition-make']
      },
      listingTypeMake: {
        id: 'app.relatedContent.boats.listing.type-make',
        defaultMessage: enDefaults['app.relatedContent.boats.listing.type-make']
      },
      headerType: {
        id: 'app.relatedContent.boats.header.type',
        defaultMessage: enDefaults['app.relatedContent.boats.header.type']
      },
      headerCondition: {
        id: 'app.relatedContent.boats.header.condition',
        defaultMessage: enDefaults['app.relatedContent.boats.header.condition']
      },
      headerConditionMake: {
        id: 'app.relatedContent.boats.header.condition-make',
        defaultMessage:
          enDefaults['app.relatedContent.boats.header.condition-make']
      },
      headerModel: {
        id: 'app.relatedContent.boats.header.model',
        defaultMessage: enDefaults['app.relatedContent.boats.header.model']
      },
      headerModelRange: {
        id: 'app.relatedContent.boats.header.modelRange',
        defaultMessage: enDefaults['app.relatedContent.boats.header.modelRange']
      },
      headerMake: {
        id: 'app.relatedContent.boats.header.make',
        defaultMessage: enDefaults['app.relatedContent.boats.header.make']
      },
      headerClasses: {
        id: 'app.relatedContent.boats.header.classes',
        defaultMessage: enDefaults['app.relatedContent.boats.header.classes']
      }
    },
    engines: {
      listingConditions: {
        new: {
          id: 'app.relatedContent.engines.listing.condition.new',
          defaultMessage:
            enDefaults['app.relatedContent.engines.listing.condition.new']
        },
        used: {
          id: 'app.relatedContent.engines.listing.condition.used',
          defaultMessage:
            enDefaults['app.relatedContent.engines.listing.condition.used']
        }
      },
      listingCondition: {
        id: 'app.relatedContent.engines.listing.condition',
        defaultMessage:
          enDefaults['app.relatedContent.engines.listing.condition']
      },
      listingConditionMake: {
        id: 'app.relatedContent.engines.listing.condition-make',
        defaultMessage:
          enDefaults['app.relatedContent.engines.listing.condition-make']
      },
      headerCondition: {
        id: 'app.relatedContent.engines.header.condition',
        defaultMessage:
          enDefaults['app.relatedContent.engines.header.condition']
      },
      headerConditionMake: {
        id: 'app.relatedContent.engines.header.condition-make',
        defaultMessage:
          enDefaults['app.relatedContent.engines.header.condition-make']
      },
      headerModel: {
        id: 'app.relatedContent.engines.header.model',
        defaultMessage: enDefaults['app.relatedContent.engines.header.model']
      },
      headerMake: {
        id: 'app.relatedContent.engines.header.make',
        defaultMessage: enDefaults['app.relatedContent.engines.header.make']
      }
    }
  },
  dynamicContent: {
    descriptionMakeParagraph1Section0: {
      id: 'app.dynamicContent.description.make.paragraph1.section0',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph1.section0']
    },
    descriptionMakeParagraph1Section1: {
      id: 'app.dynamicContent.description.make.paragraph1.section1',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph1.section1']
    },
    descriptionMakeParagraph1Section2: {
      id: 'app.dynamicContent.description.make.paragraph1.section2',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph1.section2']
    },
    descriptionMakeParagraph2Section1: {
      id: 'app.dynamicContent.description.make.paragraph2.section1',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph2.section1']
    },
    descriptionMakeParagraph2Section2: {
      id: 'app.dynamicContent.description.make.paragraph2.section2',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph2.section2']
    },
    descriptionMakeParagraph2Section3: {
      id: 'app.dynamicContent.description.make.paragraph2.section3',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph2.section3']
    },
    descriptionMakeParagraph2Section4: {
      id: 'app.dynamicContent.description.make.paragraph2.section4',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph2.section4']
    },
    descriptionMakeParagraph2Section5: {
      id: 'app.dynamicContent.description.make.paragraph2.section5',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph2.section5']
    },
    descriptionMakeParagraph3Section1: {
      id: 'app.dynamicContent.description.make.paragraph3.section1',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph3.section1']
    },
    descriptionMakeParagraph3Section2: {
      id: 'app.dynamicContent.description.make.paragraph3.section2',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph3.section2']
    },
    descriptionMakeParagraph3Section3: {
      id: 'app.dynamicContent.description.make.paragraph3.section3',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph3.section3']
    },
    descriptionMakeParagraph4Section1: {
      id: 'app.dynamicContent.description.make.paragraph4.section1',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph4.section1']
    },
    descriptionMakeParagraph4Section2: {
      id: 'app.dynamicContent.description.make.paragraph4.section2',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph4.section2']
    },
    descriptionMakeParagraph4Section3: {
      id: 'app.dynamicContent.description.make.paragraph4.section3',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph4.section3']
    },
    descriptionMakeParagraph5Section1: {
      id: 'app.dynamicContent.description.make.paragraph5.section1',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph5.section1']
    },
    descriptionMakeParagraph5Section2: {
      id: 'app.dynamicContent.description.make.paragraph5.section2',
      defaultMessage:
        enDefaults['app.dynamicContent.description.make.paragraph5.section2']
    },
    descriptionModelPowerParagraph1Section1: {
      id: 'app.dynamicContent.description.model.power.paragraph1.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph1.section1'
        ]
    },
    descriptionModelPowerParagraph1Section2: {
      id: 'app.dynamicContent.description.model.power.paragraph1.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph1.section2'
        ]
    },
    descriptionModelPowerParagraph1Section3: {
      id: 'app.dynamicContent.description.model.power.paragraph1.section3',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph1.section3'
        ]
    },
    descriptionModelPowerParagraph1Section4: {
      id: 'app.dynamicContent.description.model.power.paragraph1.section4',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph1.section4'
        ]
    },
    descriptionModelPowerParagraph1Section5: {
      id: 'app.dynamicContent.description.model.power.paragraph1.section5',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph1.section5'
        ]
    },
    descriptionModelPowerParagraph2Section1: {
      id: 'app.dynamicContent.description.model.power.paragraph2.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph2.section1'
        ]
    },
    descriptionModelPowerParagraph2Section2: {
      id: 'app.dynamicContent.description.model.power.paragraph2.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph2.section2'
        ]
    },
    descriptionModelPowerParagraph2Section3: {
      id: 'app.dynamicContent.description.model.power.paragraph2.section3',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph2.section3'
        ]
    },
    descriptionModelPowerParagraph2Section4: {
      id: 'app.dynamicContent.description.model.power.paragraph2.section4',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph2.section4'
        ]
    },
    descriptionModelPowerParagraph2Section5: {
      id: 'app.dynamicContent.description.model.power.paragraph2.section5',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.model.power.paragraph2.section5'
        ]
    },
    descriptionAnd: {
      id: 'app.dynamicContent.description.and',
      defaultMessage: enDefaults['app.dynamicContent.description.and']
    },
    descriptionNewVessels: {
      id: 'app.dynamicContent.description.newVessels',
      defaultMessage: enDefaults['app.dynamicContent.description.newVessels']
    },
    descriptionUsedBoats: {
      id: 'app.dynamicContent.description.usedBoats',
      defaultMessage: enDefaults['app.dynamicContent.description.usedBoats']
    },
    descriptionClassPowerParagraph1Section1: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section1'
        ]
    },
    descriptionClassPowerParagraph1Section2: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section2'
        ]
    },
    descriptionClassPowerParagraph1Section3: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section3',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section3'
        ]
    },
    descriptionClassPowerParagraph1Section4: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section4',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section4'
        ]
    },
    descriptionClassPowerParagraph1Section5: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section5',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section5'
        ]
    },
    descriptionClassPowerParagraph1Section6: {
      id: 'app.dynamicContent.description.class.power.paragraph1.section6',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph1.section6'
        ]
    },
    descriptionClassPowerParagraph2Section1: {
      id: 'app.dynamicContent.description.class.power.paragraph2.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph2.section1'
        ]
    },
    descriptionClassPowerParagraph2Section2: {
      id: 'app.dynamicContent.description.class.power.paragraph2.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph2.section2'
        ]
    },
    descriptionClassPowerParagraph3Section1: {
      id: 'app.dynamicContent.description.class.power.paragraph3.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph3.section1'
        ]
    },
    descriptionClassPowerParagraph3Section2: {
      id: 'app.dynamicContent.description.class.power.paragraph3.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph3.section2'
        ]
    },
    descriptionClassPowerParagraph4Section1: {
      id: 'app.dynamicContent.description.class.power.paragraph4.section1',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph4.section1'
        ]
    },
    descriptionClassPowerParagraph4Section2: {
      id: 'app.dynamicContent.description.class.power.paragraph4.section2',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.power.paragraph4.section2'
        ]
    },
    descriptionClassSailParagraph1Section3: {
      id: 'app.dynamicContent.description.class.sail.paragraph1.section3',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.sail.paragraph1.section3'
        ]
    },
    descriptionClassSailParagraph1Section4: {
      id: 'app.dynamicContent.description.class.sail.paragraph1.section4',
      defaultMessage:
        enDefaults[
          'app.dynamicContent.description.class.sail.paragraph1.section4'
        ]
    }
  },
  carouselModal: {
    close: {
      id: 'app.carouselModal.close',
      defaultMessage: enDefaults['app.carouselModal.close']
    }
  },
  viewCarousel360Images: {
    image360: {
      id: 'app.viewCarousel360Images.image360',
      defaultMessage: enDefaults['app.viewCarousel360Images.image360']
    }
  },
  CPYB: {
    id: 'app.components.Listing.CPYB',
    defaultMessage: enDefaults['app.components.Listing.CPYB']
  },
  viewCarouselVideos: {
    video: {
      id: 'app.viewCarouselVideos.video',
      defaultMessage: enDefaults['app.viewCarouselVideos.video']
    }
  },
  viewCarouselPhotos: {
    view: {
      id: 'app.viewCarouselPhotos.view',
      defaultMessage: enDefaults['app.viewCarouselPhotos.view']
    },
    photo: {
      id: 'app.viewCarouselPhotos.photo',
      defaultMessage: enDefaults['app.viewCarouselPhotos.photo']
    },
    photos: {
      id: 'app.viewCarouselPhotos.photos',
      defaultMessage: enDefaults['app.viewCarouselPhotos.photos']
    }
  },
  socialShare: {
    loadMore: {
      id: 'app.socialShare.loadMore',
      defaultMessage: enDefaults['app.socialShare.loadMore']
    },
    email: {
      id: 'app.socialShare.email',
      defaultMessage: enDefaults['app.socialShare.email']
    },
    facebook: {
      id: 'app.socialShare.facebook',
      defaultMessage: enDefaults['app.socialShare.facebook']
    },
    print: {
      id: 'app.socialShare.print',
      defaultMessage: enDefaults['app.socialShare.print']
    },
    share: {
      id: 'app.socialShare.share',
      defaultMessage: enDefaults['app.socialShare.share']
    },
    boatDetailsTitle: {
      id: 'app.socialShare.boatDetailsTitle',
      defaultMessage: enDefaults['app.socialShare.boatDetailsTitle']
    },
    twitter: {
      id: 'app.socialShare.twitter',
      defaultMessage: enDefaults['app.socialShare.twitter']
    },
    shareBoat: {
      id: 'app.socialShare.shareBoat',
      defaultMessage: enDefaults['app.socialShare.shareBoat']
    },
    whatsapp: {
      id: 'app.socialShare.whatsapp',
      defaultMessage: enDefaults['app.socialShare.whatsapp']
    },
    pinterest: {
      id: 'app.socialShare.pinterest',
      defaultMessage: enDefaults['app.socialShare.pinterest']
    },
    more: {
      id: 'app.socialShare.more',
      defaultMessage: enDefaults['app.socialShare.more']
    },
    contact: {
      id: 'app.socialShare.contact',
      defaultMessage: enDefaults['app.socialShare.contact']
    },
    copied: {
      id: 'app.socialShare.copied',
      defaultMessage: enDefaults['app.socialShare.copied']
    },
    copyLink: {
      id: 'app.socialShare.copyLink',
      defaultMessage: enDefaults['app.socialShare.copyLink']
    },
    immersiveTour: {
      id: 'app.socialShare.immersiveTour',
      defaultMessage: enDefaults['app.socialShare.immersiveTour']
    }
  },
  dealerBoats: {
    id: 'app.dealerBoats',
    defaultMessage: enDefaults['app.dealerBoats']
  },
  dealerBoatsShort: {
    id: 'app.dealerBoats.short',
    defaultMessage: enDefaults['app.dealerBoats.short']
  },
  liveVideoTour: {
    id: 'app.liveVideoTour',
    defaultMessage: enDefaults['app.liveVideoTour']
  },
  liveVideoTourForm: {
    defaultComment: {
      id: 'app.liveVideoTour.form.defaultComment',
      defaultMessage: enDefaults['app.liveVideoTour.form.defaultComment']
    },
    email: {
      id: 'app.liveVideoTour.form.email',
      defaultMessage: enDefaults['app.liveVideoTour.form.email']
    },
    emailError: {
      id: 'app.liveVideoTour.form.emailError',
      defaultMessage: enDefaults['app.liveVideoTour.form.emailError']
    },
    errorMessage: {
      id: 'app.liveVideoTour.form.errorMessage',
      defaultMessage: enDefaults['app.liveVideoTour.form.errorMessage']
    },
    errorMessageText: {
      id: 'app.liveVideoTour.form.errorMessageText',
      defaultMessage: enDefaults['app.liveVideoTour.form.errorMessageText']
    },
    errorTitle: {
      id: 'app.liveVideoTour.form.errorTitle',
      defaultMessage: enDefaults['app.liveVideoTour.form.errorTitle']
    },
    fullName: {
      id: 'app.liveVideoTour.form.fullName',
      defaultMessage: enDefaults['app.liveVideoTour.form.fullName']
    },
    fullNameError: {
      id: 'app.liveVideoTour.form.fullNameError',
      defaultMessage: enDefaults['app.liveVideoTour.form.fullNameError']
    },
    phone: {
      id: 'app.liveVideoTour.form.phone',
      defaultMessage: enDefaults['app.liveVideoTour.form.phone']
    },
    phoneError: {
      id: 'app.liveVideoTour.form.phoneError',
      defaultMessage: enDefaults['app.liveVideoTour.form.phoneError']
    },
    sendButton: {
      id: 'app.liveVideoTour.form.sendButton',
      defaultMessage: enDefaults['app.liveVideoTour.form.sendButton']
    },
    successMessageText: {
      id: 'app.liveVideoTour.form.successMessageText',
      defaultMessage: enDefaults['app.liveVideoTour.form.succesMessageText']
    },
    successTitle: {
      id: 'app.liveVideoTour.form.successTitle',
      defaultMessage: enDefaults['app.liveVideoTour.form.successTitle']
    },
    text: {
      id: 'app.liveVideoTour.form.text',
      defaultMessage: enDefaults['app.liveVideoTour.form.text']
    },
    title: {
      id: 'app.liveVideoTour.form.title',
      defaultMessage: enDefaults['app.liveVideoTour.form.title']
    }
  },
  searchDealerBoats: {
    id: 'app.searchDealerBoats',
    defaultMessage: enDefaults['app.searchDealerBoats']
  },
  socialTitle: {
    id: 'app.socialTitle',
    defaultMessage: enDefaults['app.socialTitle']
  },
  taxStatus: {
    'tax-paid': {
      id: 'app.taxStatus.tax-paid',
      defaultMessage: enDefaults['app.taxStatus.tax-paid']
    },
    'tax-not-paid': {
      id: 'app.taxStatus.tax-not-paid',
      defaultMessage: enDefaults['app.taxStatus.tax-not-paid']
    },
    'tax-leasing': {
      id: 'app.taxStatus.tax-leasing',
      defaultMessage: enDefaults['app.taxStatus.tax-leasing']
    },
    'tax-not-applicable': {
      id: 'app.taxStatus.tax-not-aplicable',
      defaultMessage: enDefaults['app.taxStatus.tax-not-aplicable']
    }
  },
  locationMap: {
    location: {
      id: 'app.locationMap.location',
      defaultMessage: enDefaults['app.locationMap.location']
    },
    calculateRoute: {
      id: 'app.locationMap.calculateRoute',
      defaultMessage: enDefaults['app.locationMap.calculateRoute']
    }
  },
  directionFormat: {
    id: 'app.directionFormat',
    defaultMessage: enDefaults['app.directionFormat']
  },
  dropdown: {
    selectedOptionNumber: {
      id: 'app.dropdown.selectedOptionNumber',
      defaultMessage: enDefaults['app.dropdown.selectedOptionNumber']
    }
  },
  alertMessage: {
    linkExpired: {
      title: {
        id: 'app.alertMessage.linkExpired.title',
        defaultMessage: enDefaults['app.alertMessage.linkExpired.title']
      },
      description: {
        id: 'app.alertMessage.linkExpired.description',
        defaultMessage: enDefaults['app.alertMessage.linkExpired.description']
      }
    },
    boatUnavailable: {
      title: {
        id: 'app.alertMessage.boatUnavailable.title',
        defaultMessage: enDefaults['app.alertMessage.boatUnavailable.title']
      },
      description: {
        id: 'app.alertMessage.boatUnavailable.description',
        defaultMessage:
          enDefaults['app.alertMessage.boatUnavailable.description']
      }
    },
    similarBoatsForOEMs: {
      title: {
        id: 'app.alertMessage.similarBoatsForOEMs.title',
        defineMessage: enDefaults['app.alertMessage.similarBoatsForOEMs.title']
      },
      description: {
        id: 'app.alertMessage.similarBoatsForOEMs.description',
        defineMessage:
          enDefaults['app.alertMessage.similarBoatsForOEMs.description']
      }
    }
  },
  classFacetValues: {
    'all-class': {
      id: 'app.facet.class.all',
      defaultMessage: enDefaults['app.facet.class.all']
    },
    'power-all': {
      id: 'app.facet.class.power-all',
      defaultMessage: enDefaults['app.facet.class.power-all']
    },
    'power-aft': {
      id: 'app.facet.class.power-aft',
      defaultMessage: enDefaults['app.facet.class.power-aft']
    },
    'power-airboat': {
      id: 'app.facet.class.power-airboat',
      defaultMessage: enDefaults['app.facet.class.power-airboat']
    },
    'power-aluminum': {
      id: 'app.facet.class.power-aluminum',
      defaultMessage: enDefaults['app.facet.class.power-aluminum']
    },
    'power-antique': {
      id: 'app.facet.class.power-antique',
      defaultMessage: enDefaults['app.facet.class.power-antique']
    },
    'power-barge': {
      id: 'app.facet.class.power-barge',
      defaultMessage: enDefaults['app.facet.class.power-barge']
    },
    'power-bass': {
      id: 'app.facet.class.power-bass',
      defaultMessage: enDefaults['app.facet.class.power-bass']
    },
    'power-bay': {
      id: 'app.facet.class.power-bay',
      defaultMessage: enDefaults['app.facet.class.power-bay']
    },
    'power-bowrider': {
      id: 'app.facet.class.power-bowrider',
      defaultMessage: enDefaults['app.facet.class.power-bowrider']
    },
    'power-cargo': {
      id: 'app.facet.class.power-cargo',
      defaultMessage: enDefaults['app.facet.class.power-cargo']
    },
    'power-center': {
      id: 'app.facet.class.power-center',
      defaultMessage: enDefaults['app.facet.class.power-center']
    },
    'power-commercial': {
      id: 'app.facet.class.power-commercial',
      defaultMessage: enDefaults['app.facet.class.power-commercial']
    },
    'power-convertible': {
      id: 'app.facet.class.power-convertible',
      defaultMessage: enDefaults['app.facet.class.power-convertible']
    },
    'power-cruiser': {
      id: 'app.facet.class.power-cruiser',
      defaultMessage: enDefaults['app.facet.class.power-cruiser']
    },
    'power-cruiseship': {
      id: 'app.facet.class.power-cruiseship',
      defaultMessage: enDefaults['app.facet.class.power-cruiseship']
    },
    'power-cuddy': {
      id: 'app.facet.class.power-cuddy',
      defaultMessage: enDefaults['app.facet.class.power-cuddy']
    },
    'power-deck': {
      id: 'app.facet.class.power-deck',
      defaultMessage: enDefaults['app.facet.class.power-deck']
    },
    'power-dinghy': {
      id: 'app.facet.class.power-dinghy',
      defaultMessage: enDefaults['app.facet.class.power-dinghy']
    },
    'power-dive': {
      id: 'app.facet.class.power-dive',
      defaultMessage: enDefaults['app.facet.class.power-dive']
    },
    'power-downeast': {
      id: 'app.facet.class.power-downeast',
      defaultMessage: enDefaults['app.facet.class.power-downeast']
    },
    'power-dragger': {
      id: 'app.facet.class.power-dragger',
      defaultMessage: enDefaults['app.facet.class.power-dragger']
    },
    'power-dualconsole': {
      id: 'app.facet.class.power-dualconsole',
      defaultMessage: enDefaults['app.facet.class.power-dualconsole']
    },
    'power-expresscruiser': {
      id: 'app.facet.class.power-expresscruiser',
      defaultMessage: enDefaults['app.facet.class.power-expresscruiser']
    },
    'power-flats': {
      id: 'app.facet.class.power-flats',
      defaultMessage: enDefaults['app.facet.class.power-flats']
    },
    'power-flybridge': {
      id: 'app.facet.class.power-flybridge',
      defaultMessage: enDefaults['app.facet.class.power-flybridge']
    },
    'power-fresh': {
      id: 'app.facet.class.power-fresh',
      defaultMessage: enDefaults['app.facet.class.power-fresh']
    },
    'power-gulet': {
      id: 'app.facet.class.power-gulet',
      defaultMessage: enDefaults['app.facet.class.power-gulet']
    },
    'power-highperf': {
      id: 'app.facet.class.power-highperf',
      defaultMessage: enDefaults['app.facet.class.power-highperf']
    },
    'power-house': {
      id: 'app.facet.class.power-house',
      defaultMessage: enDefaults['app.facet.class.power-house']
    },
    'power-inflatable': {
      id: 'app.facet.class.power-inflatable',
      defaultMessage: enDefaults['app.facet.class.power-inflatable']
    },
    'power-jet': {
      id: 'app.facet.class.power-jet',
      defaultMessage: enDefaults['app.facet.class.power-jet']
    },
    'power-jon': {
      id: 'app.facet.class.power-jon',
      defaultMessage: enDefaults['app.facet.class.power-jon']
    },
    'power-llaut': {
      id: 'app.facet.class.power-llaut',
      defaultMessage: enDefaults['app.facet.class.power-llaut']
    },
    'power-lobster': {
      id: 'app.facet.class.power-lobster',
      defaultMessage: enDefaults['app.facet.class.power-lobster']
    },
    'power-mega': {
      id: 'app.facet.class.power-mega',
      defaultMessage: enDefaults['app.facet.class.power-mega']
    },
    'power-motor': {
      id: 'app.facet.class.power-motor',
      defaultMessage: enDefaults['app.facet.class.power-motor']
    },
    'power-motorsailer': {
      id: 'app.facet.class.power-motorsailer',
      defaultMessage: enDefaults['app.facet.class.power-motorsailer']
    },
    'power-narrow': {
      id: 'app.facet.class.power-narrow',
      defaultMessage: enDefaults['app.facet.class.power-narrow']
    },
    'power-other': {
      id: 'app.facet.class.power-other',
      defaultMessage: enDefaults['app.facet.class.power-other']
    },
    'power-passenger': {
      id: 'app.facet.class.power-passenger',
      defaultMessage: enDefaults['app.facet.class.power-passenger']
    },
    'power-pcatamaran': {
      id: 'app.facet.class.power-pcatamaran',
      defaultMessage: enDefaults['app.facet.class.power-pcatamaran']
    },
    'power-pilot': {
      id: 'app.facet.class.power-pilot',
      defaultMessage: enDefaults['app.facet.class.power-pilot']
    },
    'power-pontoon': {
      id: 'app.facet.class.power-pontoon',
      defaultMessage: enDefaults['app.facet.class.power-pontoon']
    },
    'power-pwc': {
      id: 'app.facet.class.power-pwc',
      defaultMessage: enDefaults['app.facet.class.power-pwc']
    },
    'power-rib': {
      id: 'app.facet.class.power-rib',
      defaultMessage: enDefaults['app.facet.class.power-rib']
    },
    'power-rivercruiser': {
      id: 'app.facet.class.power-rivercruiser',
      defaultMessage: enDefaults['app.facet.class.power-rivercruiser']
    },
    'power-runabout': {
      id: 'app.facet.class.power-runabout',
      defaultMessage: enDefaults['app.facet.class.power-runabout']
    },
    'power-saltfish': {
      id: 'app.facet.class.power-saltfish',
      defaultMessage: enDefaults['app.facet.class.power-saltfish']
    },
    'power-skiff': {
      id: 'app.facet.class.power-skiff',
      defaultMessage: enDefaults['app.facet.class.power-skiff']
    },
    'power-skifish': {
      id: 'app.facet.class.power-skifish',
      defaultMessage: enDefaults['app.facet.class.power-skifish']
    },
    'power-skiwake': {
      id: 'app.facet.class.power-skiwake',
      defaultMessage: enDefaults['app.facet.class.power-skiwake']
    },
    'power-sloop': {
      id: 'app.facet.class.power-sloop',
      defaultMessage: enDefaults['app.facet.class.power-sloop']
    },
    'power-sportcruiser': {
      id: 'app.facet.class.power-sportcruiser',
      defaultMessage: enDefaults['app.facet.class.power-sportcruiser']
    },
    'power-sportfish': {
      id: 'app.facet.class.power-sportfish',
      defaultMessage: enDefaults['app.facet.class.power-sportfish']
    },
    'power-tender': {
      id: 'app.facet.class.power-tender',
      defaultMessage: enDefaults['app.facet.class.power-tender']
    },
    'power-trawler': {
      id: 'app.facet.class.power-trawler',
      defaultMessage: enDefaults['app.facet.class.power-trawler']
    },
    'power-troller': {
      id: 'app.facet.class.power-troller',
      defaultMessage: enDefaults['app.facet.class.power-troller']
    },
    'power-tug': {
      id: 'app.facet.class.power-tug',
      defaultMessage: enDefaults['app.facet.class.power-tug']
    },
    'power-unspec': {
      id: 'app.facet.class.power-unspec',
      defaultMessage: enDefaults['app.facet.class.power-unspec']
    },
    'power-util': {
      id: 'app.facet.class.power-util',
      defaultMessage: enDefaults['app.facet.class.power-util']
    },
    'power-walk': {
      id: 'app.facet.class.power-walk',
      defaultMessage: enDefaults['app.facet.class.power-walk']
    },
    'sail-all': {
      id: 'app.facet.class.sail-all',
      defaultMessage: enDefaults['app.facet.class.sail-all']
    },
    'sail-antique': {
      id: 'app.facet.class.sail-antique',
      defaultMessage: enDefaults['app.facet.class.sail-antique']
    },
    'sail-barge': {
      id: 'app.facet.class.sail-barge',
      defaultMessage: enDefaults['app.facet.class.sail-barge']
    },
    'sail-beachcat': {
      id: 'app.facet.class.sail-beachcat',
      defaultMessage: enDefaults['app.facet.class.sail-beachcat']
    },
    'sail-catamaran': {
      id: 'app.facet.class.sail-catamaran',
      defaultMessage: enDefaults['app.facet.class.sail-catamaran']
    },
    'sail-centercockpit': {
      id: 'app.facet.class.sail-centercockpit',
      defaultMessage: enDefaults['app.facet.class.sail-centercockpit']
    },
    'sail-commercial': {
      id: 'app.facet.class.sail-commercial',
      defaultMessage: enDefaults['app.facet.class.sail-commercial']
    },
    'sail-cruiser': {
      id: 'app.facet.class.sail-cruiser',
      defaultMessage: enDefaults['app.facet.class.sail-cruiser']
    },
    'sail-cutter': {
      id: 'app.facet.class.sail-cutter',
      defaultMessage: enDefaults['app.facet.class.sail-cutter']
    },
    'sail-day': {
      id: 'app.facet.class.sail-day',
      defaultMessage: enDefaults['app.facet.class.sail-day']
    },
    'sail-deck': {
      id: 'app.facet.class.sail-deck',
      defaultMessage: enDefaults['app.facet.class.sail-deck']
    },
    'sail-dinghy': {
      id: 'app.facet.class.sail-dinghy',
      defaultMessage: enDefaults['app.facet.class.sail-dinghy']
    },
    'sail-gulet': {
      id: 'app.facet.class.sail-gulet',
      defaultMessage: enDefaults['app.facet.class.sail-gulet']
    },
    'sail-ketch': {
      id: 'app.facet.class.sail-ketch',
      defaultMessage: enDefaults['app.facet.class.sail-ketch']
    },
    'sail-motor': {
      id: 'app.facet.class.sail-motor',
      defaultMessage: enDefaults['app.facet.class.sail-motor']
    },
    'sail-multihull': {
      id: 'app.facet.class.sail-multihull',
      defaultMessage: enDefaults['app.facet.class.sail-multihull']
    },
    'sail-other': {
      id: 'app.facet.class.sail-other',
      defaultMessage: enDefaults['app.facet.class.sail-other']
    },
    'sail-performance': {
      id: 'app.facet.class.sail-performance',
      defaultMessage: enDefaults['app.facet.class.sail-performance']
    },
    'sail-pilot': {
      id: 'app.facet.class.sail-pilot',
      defaultMessage: enDefaults['app.facet.class.sail-pilot']
    },
    'sail-racer': {
      id: 'app.facet.class.sail-racer',
      defaultMessage: enDefaults['app.facet.class.sail-racer']
    },
    'sail-racercruiser': {
      id: 'app.facet.class.sail-racercruiser',
      defaultMessage: enDefaults['app.facet.class.sail-racercruiser']
    },
    'sail-schooner': {
      id: 'app.facet.class.sail-schooner',
      defaultMessage: enDefaults['app.facet.class.sail-schooner']
    },
    'sail-sloop': {
      id: 'app.facet.class.sail-sloop',
      defaultMessage: enDefaults['app.facet.class.sail-sloop']
    },
    'sail-trimaran': {
      id: 'app.facet.class.sail-trimaran',
      defaultMessage: enDefaults['app.facet.class.sail-trimaran']
    },
    'sail-unspec': {
      id: 'app.facet.class.sail-unspec',
      defaultMessage: enDefaults['app.facet.class.sail-unspec']
    },
    'sail-yawl': {
      id: 'app.facet.class.sail-yawl',
      defaultMessage: enDefaults['app.facet.class.sail-yawl']
    },
    'unpowered-all': {
      id: 'app.facet.class.unpowered-all',
      defaultMessage: enDefaults['app.facet.class.unpowered-all']
    },
    'unpowered-barge': {
      id: 'app.facet.class.unpowered-barge',
      defaultMessage: enDefaults['app.facet.class.unpowered-barge']
    },
    'unpowered-dinghy': {
      id: 'app.facet.class.unpowered-dinghy',
      defaultMessage: enDefaults['app.facet.class.unpowered-dinghy']
    },
    'unpowered-inflatable': {
      id: 'app.facet.class.unpowered-inflatable',
      defaultMessage: enDefaults['app.facet.class.unpowered-inflatable']
    },
    'unpowered-kayak': {
      id: 'app.facet.class.unpowered-kayak',
      defaultMessage: enDefaults['app.facet.class.unpowered-kayak']
    },
    'unpowered-narrow': {
      id: 'app.facet.class.unpowered-narrow',
      defaultMessage: enDefaults['app.facet.class.unpowered-narrow']
    },
    'unpowered-other': {
      id: 'app.facet.class.unpowered-other',
      defaultMessage: enDefaults['app.facet.class.unpowered-other']
    },
    'unpowered-tender': {
      id: 'app.facet.class.unpowered-tender',
      defaultMessage: enDefaults['app.facet.class.unpowered-tender']
    },
    'unpowered-unspec': {
      id: 'app.facet.class.unpowered-unspec',
      defaultMessage: enDefaults['app.facet.class.unpowered-unspec']
    }
  },
  sortFacetValues: {
    asc: {
      id: 'app.facet.sort.asc',
      defaultMessage: enDefaults['app.facet.sort.asc']
    },
    desc: {
      id: 'app.facet.sort.desc',
      defaultMessage: enDefaults['app.facet.sort.desc']
    }
  },
  nextPrevious: {
    next: {
      id: 'app.nextPrevious.next',
      defaultMessage: enDefaults['app.nextPrevious.next']
    },
    nextShort: {
      id: 'app.nextPrevious.next.short',
      defaultMessage: enDefaults['app.nextPrevious.next.short']
    },
    previous: {
      id: 'app.nextPrevious.previous',
      defaultMessage: enDefaults['app.nextPrevious.previous']
    },
    previousShort: {
      id: 'app.nextPrevious.previous.short',
      defaultMessage: enDefaults['app.nextPrevious.previous.short']
    },
    backToSearch: {
      id: 'app.nextPrevious.backToSearch',
      defaultMessage: enDefaults['app.nextPrevious.backToSearch']
    },
    backToSearchShort: {
      id: 'app.nextPrevious.backToSearch.short',
      defaultMessage: enDefaults['app.nextPrevious.backToSearch.short']
    },
    backToSearchBrokerShort: {
      id: 'app.nextPrevious.backToSearchBroker.short',
      defaultMessage: enDefaults['app.nextPrevious.backToSearchBroker.short']
    },
    engines: {
      next: {
        id: 'app.nextPrevious.engines.next',
        defaultMessage: enDefaults['app.nextPrevious.engines.next']
      },
      nextShort: {
        id: 'app.nextPrevious.engines.next.short',
        defaultMessage: enDefaults['app.nextPrevious.engines.next.short']
      },
      previous: {
        id: 'app.nextPrevious.engines.previous',
        defaultMessage: enDefaults['app.nextPrevious.engines.previous']
      },
      previousShort: {
        id: 'app.nextPrevious.engines.previous.short',
        defaultMessage: enDefaults['app.nextPrevious.engines.previous.short']
      }
    }
  },
  error: {
    genericMessage: {
      id: 'app.error.message',
      defaultMessage: enDefaults['app.error.message']
    },
    server: {
      id: 'app.error.server',
      defaultMessage: enDefaults['app.error.server']
    },
    notFound: {
      title: {
        id: 'app.error.notFound.title',
        defaultMessage: enDefaults['app.error.notFound.title']
      },
      subtitle: {
        id: 'app.error.notFound.subtitle',
        defaultMessage: enDefaults['app.error.notFound.subtitle']
      },
      intro: {
        id: 'app.error.notFound.intro',
        defaultMessage: enDefaults['app.error.notFound.intro']
      },
      option0: {
        id: 'app.error.notFound.option0',
        defaultMessage: enDefaults['app.error.notFound.option0']
      },
      option1: {
        id: 'app.error.notFound.option1',
        defaultMessage: enDefaults['app.error.notFound.option1']
      },
      option2: {
        id: 'app.error.notFound.option2',
        defaultMessage: enDefaults['app.error.notFound.option2']
      },
      action0: {
        id: 'app.error.notFound.action0',
        defaultMessage: enDefaults['app.error.notFound.action0']
      },
      action1: {
        id: 'app.error.notFound.action1',
        defaultMessage: enDefaults['app.error.notFound.action1']
      },
      action2: {
        id: 'app.error.notFound.action2',
        defaultMessage: enDefaults['app.error.notFound.action2']
      },
      home: {
        id: 'app.error.notFound.home',
        defaultMessage: enDefaults['app.error.notFound.home']
      },
      find: {
        id: 'app.error.notFound.find',
        defaultMessage: enDefaults['app.error.notFound.find']
      },
      sell: {
        id: 'app.error.notFound.sell',
        defaultMessage: enDefaults['app.error.notFound.sell']
      },
      services: {
        id: 'app.error.notFound.services',
        defaultMessage: enDefaults['app.error.notFound.services']
      }
    },
    wrong: {
      id: 'app.error.wrong',
      defaultMessage: enDefaults['app.error.wrong']
    },
    reset: {
      id: 'app.error.reset',
      defaultMessage: enDefaults['app.error.reset']
    }
  },
  countrySubdivision: {
    'all-subdivisions': {
      id: 'app.countrySubdivision.all',
      defaultMessage: enDefaults['app.countrySubdivision.all']
    },
    '01': {
      id: 'app.countrySubdivision.FR-01',
      defaultMessage: enDefaults['app.countrySubdivision.FR-01']
    },
    '02': {
      id: 'app.countrySubdivision.FR-02',
      defaultMessage: enDefaults['app.countrySubdivision.FR-02']
    },
    '03': {
      id: 'app.countrySubdivision.FR-03',
      defaultMessage: enDefaults['app.countrySubdivision.FR-03']
    },
    '04': {
      id: 'app.countrySubdivision.FR-04',
      defaultMessage: enDefaults['app.countrySubdivision.FR-04']
    },
    '05': {
      id: 'app.countrySubdivision.FR-05',
      defaultMessage: enDefaults['app.countrySubdivision.FR-05']
    },
    '06': {
      id: 'app.countrySubdivision.FR-06',
      defaultMessage: enDefaults['app.countrySubdivision.FR-06']
    },
    '07': {
      id: 'app.countrySubdivision.FR-07',
      defaultMessage: enDefaults['app.countrySubdivision.FR-07']
    },
    '08': {
      id: 'app.countrySubdivision.FR-08',
      defaultMessage: enDefaults['app.countrySubdivision.FR-08']
    },
    '09': {
      id: 'app.countrySubdivision.FR-09',
      defaultMessage: enDefaults['app.countrySubdivision.FR-09']
    },
    '10': {
      id: 'app.countrySubdivision.FR-10',
      defaultMessage: enDefaults['app.countrySubdivision.FR-10']
    },
    '11': {
      id: 'app.countrySubdivision.FR-11',
      defaultMessage: enDefaults['app.countrySubdivision.FR-11']
    },
    '12': {
      id: 'app.countrySubdivision.FR-12',
      defaultMessage: enDefaults['app.countrySubdivision.FR-12']
    },
    '13': {
      id: 'app.countrySubdivision.FR-13',
      defaultMessage: enDefaults['app.countrySubdivision.FR-13']
    },
    '14': {
      id: 'app.countrySubdivision.FR-14',
      defaultMessage: enDefaults['app.countrySubdivision.FR-14']
    },
    '15': {
      id: 'app.countrySubdivision.FR-15',
      defaultMessage: enDefaults['app.countrySubdivision.FR-15']
    },
    '16': {
      id: 'app.countrySubdivision.FR-16',
      defaultMessage: enDefaults['app.countrySubdivision.FR-16']
    },
    '17': {
      id: 'app.countrySubdivision.FR-17',
      defaultMessage: enDefaults['app.countrySubdivision.FR-17']
    },
    '18': {
      id: 'app.countrySubdivision.FR-18',
      defaultMessage: enDefaults['app.countrySubdivision.FR-18']
    },
    '19': {
      id: 'app.countrySubdivision.FR-19',
      defaultMessage: enDefaults['app.countrySubdivision.FR-19']
    },
    '20': {
      id: 'app.countrySubdivision.FR-20',
      defaultMessage: enDefaults['app.countrySubdivision.FR-20']
    },
    '21': {
      id: 'app.countrySubdivision.FR-21',
      defaultMessage: enDefaults['app.countrySubdivision.FR-21']
    },
    '22': {
      id: 'app.countrySubdivision.FR-22',
      defaultMessage: enDefaults['app.countrySubdivision.FR-22']
    },
    '23': {
      id: 'app.countrySubdivision.FR-23',
      defaultMessage: enDefaults['app.countrySubdivision.FR-23']
    },
    '24': {
      id: 'app.countrySubdivision.FR-24',
      defaultMessage: enDefaults['app.countrySubdivision.FR-24']
    },
    '25': {
      id: 'app.countrySubdivision.FR-25',
      defaultMessage: enDefaults['app.countrySubdivision.FR-25']
    },
    '26': {
      id: 'app.countrySubdivision.FR-26',
      defaultMessage: enDefaults['app.countrySubdivision.FR-26']
    },
    '27': {
      id: 'app.countrySubdivision.FR-27',
      defaultMessage: enDefaults['app.countrySubdivision.FR-27']
    },
    '28': {
      id: 'app.countrySubdivision.FR-28',
      defaultMessage: enDefaults['app.countrySubdivision.FR-28']
    },
    '29': {
      id: 'app.countrySubdivision.FR-29',
      defaultMessage: enDefaults['app.countrySubdivision.FR-29']
    },
    '30': {
      id: 'app.countrySubdivision.FR-30',
      defaultMessage: enDefaults['app.countrySubdivision.FR-30']
    },
    '31': {
      id: 'app.countrySubdivision.FR-31',
      defaultMessage: enDefaults['app.countrySubdivision.FR-31']
    },
    '32': {
      id: 'app.countrySubdivision.FR-32',
      defaultMessage: enDefaults['app.countrySubdivision.FR-32']
    },
    '33': {
      id: 'app.countrySubdivision.FR-33',
      defaultMessage: enDefaults['app.countrySubdivision.FR-33']
    },
    '34': {
      id: 'app.countrySubdivision.FR-34',
      defaultMessage: enDefaults['app.countrySubdivision.FR-34']
    },
    '35': {
      id: 'app.countrySubdivision.FR-35',
      defaultMessage: enDefaults['app.countrySubdivision.FR-35']
    },
    '36': {
      id: 'app.countrySubdivision.FR-36',
      defaultMessage: enDefaults['app.countrySubdivision.FR-36']
    },
    '37': {
      id: 'app.countrySubdivision.FR-37',
      defaultMessage: enDefaults['app.countrySubdivision.FR-37']
    },
    '38': {
      id: 'app.countrySubdivision.FR-38',
      defaultMessage: enDefaults['app.countrySubdivision.FR-38']
    },
    '39': {
      id: 'app.countrySubdivision.FR-39',
      defaultMessage: enDefaults['app.countrySubdivision.FR-39']
    },
    '40': {
      id: 'app.countrySubdivision.FR-40',
      defaultMessage: enDefaults['app.countrySubdivision.FR-40']
    },
    '41': {
      id: 'app.countrySubdivision.FR-41',
      defaultMessage: enDefaults['app.countrySubdivision.FR-41']
    },
    '42': {
      id: 'app.countrySubdivision.FR-42',
      defaultMessage: enDefaults['app.countrySubdivision.FR-42']
    },
    '43': {
      id: 'app.countrySubdivision.FR-43',
      defaultMessage: enDefaults['app.countrySubdivision.FR-43']
    },
    '44': {
      id: 'app.countrySubdivision.FR-44',
      defaultMessage: enDefaults['app.countrySubdivision.FR-44']
    },
    '45': {
      id: 'app.countrySubdivision.FR-45',
      defaultMessage: enDefaults['app.countrySubdivision.FR-45']
    },
    '46': {
      id: 'app.countrySubdivision.FR-46',
      defaultMessage: enDefaults['app.countrySubdivision.FR-46']
    },
    '47': {
      id: 'app.countrySubdivision.FR-47',
      defaultMessage: enDefaults['app.countrySubdivision.FR-47']
    },
    '48': {
      id: 'app.countrySubdivision.FR-48',
      defaultMessage: enDefaults['app.countrySubdivision.FR-48']
    },
    '49': {
      id: 'app.countrySubdivision.FR-49',
      defaultMessage: enDefaults['app.countrySubdivision.FR-49']
    },
    '50': {
      id: 'app.countrySubdivision.FR-50',
      defaultMessage: enDefaults['app.countrySubdivision.FR-50']
    },
    '51': {
      id: 'app.countrySubdivision.FR-51',
      defaultMessage: enDefaults['app.countrySubdivision.FR-51']
    },
    '52': {
      id: 'app.countrySubdivision.FR-52',
      defaultMessage: enDefaults['app.countrySubdivision.FR-52']
    },
    '53': {
      id: 'app.countrySubdivision.FR-53',
      defaultMessage: enDefaults['app.countrySubdivision.FR-53']
    },
    '54': {
      id: 'app.countrySubdivision.FR-54',
      defaultMessage: enDefaults['app.countrySubdivision.FR-54']
    },
    '55': {
      id: 'app.countrySubdivision.FR-55',
      defaultMessage: enDefaults['app.countrySubdivision.FR-55']
    },
    '56': {
      id: 'app.countrySubdivision.FR-56',
      defaultMessage: enDefaults['app.countrySubdivision.FR-56']
    },
    '57': {
      id: 'app.countrySubdivision.FR-57',
      defaultMessage: enDefaults['app.countrySubdivision.FR-57']
    },
    '58': {
      id: 'app.countrySubdivision.FR-58',
      defaultMessage: enDefaults['app.countrySubdivision.FR-58']
    },
    '59': {
      id: 'app.countrySubdivision.FR-59',
      defaultMessage: enDefaults['app.countrySubdivision.FR-59']
    },
    '60': {
      id: 'app.countrySubdivision.FR-60',
      defaultMessage: enDefaults['app.countrySubdivision.FR-60']
    },
    '61': {
      id: 'app.countrySubdivision.FR-61',
      defaultMessage: enDefaults['app.countrySubdivision.FR-61']
    },
    '62': {
      id: 'app.countrySubdivision.FR-62',
      defaultMessage: enDefaults['app.countrySubdivision.FR-62']
    },
    '63': {
      id: 'app.countrySubdivision.FR-63',
      defaultMessage: enDefaults['app.countrySubdivision.FR-63']
    },
    '64': {
      id: 'app.countrySubdivision.FR-64',
      defaultMessage: enDefaults['app.countrySubdivision.FR-64']
    },
    '65': {
      id: 'app.countrySubdivision.FR-65',
      defaultMessage: enDefaults['app.countrySubdivision.FR-65']
    },
    '66': {
      id: 'app.countrySubdivision.FR-66',
      defaultMessage: enDefaults['app.countrySubdivision.FR-66']
    },
    '67': {
      id: 'app.countrySubdivision.FR-67',
      defaultMessage: enDefaults['app.countrySubdivision.FR-67']
    },
    '68': {
      id: 'app.countrySubdivision.FR-68',
      defaultMessage: enDefaults['app.countrySubdivision.FR-68']
    },
    '69': {
      id: 'app.countrySubdivision.FR-69',
      defaultMessage: enDefaults['app.countrySubdivision.FR-69']
    },
    '70': {
      id: 'app.countrySubdivision.FR-70',
      defaultMessage: enDefaults['app.countrySubdivision.FR-70']
    },
    '71': {
      id: 'app.countrySubdivision.FR-71',
      defaultMessage: enDefaults['app.countrySubdivision.FR-71']
    },
    '72': {
      id: 'app.countrySubdivision.FR-72',
      defaultMessage: enDefaults['app.countrySubdivision.FR-72']
    },
    '73': {
      id: 'app.countrySubdivision.FR-73',
      defaultMessage: enDefaults['app.countrySubdivision.FR-73']
    },
    '74': {
      id: 'app.countrySubdivision.FR-74',
      defaultMessage: enDefaults['app.countrySubdivision.FR-74']
    },
    '75': {
      id: 'app.countrySubdivision.FR-75',
      defaultMessage: enDefaults['app.countrySubdivision.FR-75']
    },
    '76': {
      id: 'app.countrySubdivision.FR-76',
      defaultMessage: enDefaults['app.countrySubdivision.FR-76']
    },
    '77': {
      id: 'app.countrySubdivision.FR-77',
      defaultMessage: enDefaults['app.countrySubdivision.FR-77']
    },
    '78': {
      id: 'app.countrySubdivision.FR-78',
      defaultMessage: enDefaults['app.countrySubdivision.FR-78']
    },
    '79': {
      id: 'app.countrySubdivision.FR-79',
      defaultMessage: enDefaults['app.countrySubdivision.FR-79']
    },
    '80': {
      id: 'app.countrySubdivision.FR-80',
      defaultMessage: enDefaults['app.countrySubdivision.FR-80']
    },
    '81': {
      id: 'app.countrySubdivision.FR-81',
      defaultMessage: enDefaults['app.countrySubdivision.FR-81']
    },
    '82': {
      id: 'app.countrySubdivision.FR-82',
      defaultMessage: enDefaults['app.countrySubdivision.FR-82']
    },
    '83': {
      id: 'app.countrySubdivision.FR-83',
      defaultMessage: enDefaults['app.countrySubdivision.FR-83']
    },
    '84': {
      id: 'app.countrySubdivision.FR-84',
      defaultMessage: enDefaults['app.countrySubdivision.FR-84']
    },
    '85': {
      id: 'app.countrySubdivision.FR-85',
      defaultMessage: enDefaults['app.countrySubdivision.FR-85']
    },
    '86': {
      id: 'app.countrySubdivision.FR-86',
      defaultMessage: enDefaults['app.countrySubdivision.FR-86']
    },
    '87': {
      id: 'app.countrySubdivision.FR-87',
      defaultMessage: enDefaults['app.countrySubdivision.FR-87']
    },
    '88': {
      id: 'app.countrySubdivision.FR-88',
      defaultMessage: enDefaults['app.countrySubdivision.FR-88']
    },
    '89': {
      id: 'app.countrySubdivision.FR-89',
      defaultMessage: enDefaults['app.countrySubdivision.FR-89']
    },
    '90': {
      id: 'app.countrySubdivision.FR-90',
      defaultMessage: enDefaults['app.countrySubdivision.FR-90']
    },
    '91': {
      id: 'app.countrySubdivision.FR-91',
      defaultMessage: enDefaults['app.countrySubdivision.FR-91']
    },
    '92': {
      id: 'app.countrySubdivision.FR-92',
      defaultMessage: enDefaults['app.countrySubdivision.FR-92']
    },
    '93': {
      id: 'app.countrySubdivision.FR-93',
      defaultMessage: enDefaults['app.countrySubdivision.FR-93']
    },
    '94': {
      id: 'app.countrySubdivision.FR-94',
      defaultMessage: enDefaults['app.countrySubdivision.FR-94']
    },
    '95': {
      id: 'app.countrySubdivision.FR-95',
      defaultMessage: enDefaults['app.countrySubdivision.FR-95']
    },
    'AU': {
      'ACT': {
        id: 'app.countrySubdivision.AU-ACT',
        defaultMessage: enDefaults['app.countrySubdivision.AU-ACT']
      },
      'NSW': {
        id: 'app.countrySubdivision.AU-NSW',
        defaultMessage: enDefaults['app.countrySubdivision.AU-NSW']
      },
      'NT': {
        id: 'app.countrySubdivision.AU-NT',
        defaultMessage: enDefaults['app.countrySubdivision.AU-NT']
      },
      'QLD': {
        id: 'app.countrySubdivision.AU-QLD',
        defaultMessage: enDefaults['app.countrySubdivision.AU-QLD']
      },
      'SA': {
        id: 'app.countrySubdivision.AU-SA',
        defaultMessage: enDefaults['app.countrySubdivision.AU-SA']
      },
      'TAS': {
        id: 'app.countrySubdivision.AU-TAS',
        defaultMessage: enDefaults['app.countrySubdivision.AU-TAS']
      },
      'VIC': {
        id: 'app.countrySubdivision.AU-VIC',
        defaultMessage: enDefaults['app.countrySubdivision.AU-VIC']
      },
      'WA': {
        id: 'app.countrySubdivision.AU-WA',
        defaultMessage: enDefaults['app.countrySubdivision.AU-WA']
      }
    },
    'CA': {
      'AB': {
        id: 'app.countrySubdivision.CA-AB',
        defaultMessage: enDefaults['app.countrySubdivision.CA-AB']
      },
      'BC': {
        id: 'app.countrySubdivision.CA-BC',
        defaultMessage: enDefaults['app.countrySubdivision.CA-BC']
      },
      'MB': {
        id: 'app.countrySubdivision.CA-MB',
        defaultMessage: enDefaults['app.countrySubdivision.CA-MB']
      },
      'NB': {
        id: 'app.countrySubdivision.CA-NB',
        defaultMessage: enDefaults['app.countrySubdivision.CA-NB']
      },
      'NL': {
        id: 'app.countrySubdivision.CA-NL',
        defaultMessage: enDefaults['app.countrySubdivision.CA-NL']
      },
      'NS': {
        id: 'app.countrySubdivision.CA-NS',
        defaultMessage: enDefaults['app.countrySubdivision.CA-NS']
      },
      'NT': {
        id: 'app.countrySubdivision.CA-NT',
        defaultMessage: enDefaults['app.countrySubdivision.CA-NT']
      },
      'NU': {
        id: 'app.countrySubdivision.CA-NU',
        defaultMessage: enDefaults['app.countrySubdivision.CA-NU']
      },
      'ON': {
        id: 'app.countrySubdivision.CA-ON',
        defaultMessage: enDefaults['app.countrySubdivision.CA-ON']
      },
      'PE': {
        id: 'app.countrySubdivision.CA-PE',
        defaultMessage: enDefaults['app.countrySubdivision.CA-PE']
      },
      'QC': {
        id: 'app.countrySubdivision.CA-QC',
        defaultMessage: enDefaults['app.countrySubdivision.CA-QC']
      },
      'SK': {
        id: 'app.countrySubdivision.CA-SK',
        defaultMessage: enDefaults['app.countrySubdivision.CA-SK']
      },
      'YT': {
        id: 'app.countrySubdivision.CA-YT',
        defaultMessage: enDefaults['app.countrySubdivision.CA-YT']
      }
    },
    'FR': {
      '01': {
        id: 'app.countrySubdivision.FR-01',
        defaultMessage: enDefaults['app.countrySubdivision.FR-01']
      },
      '02': {
        id: 'app.countrySubdivision.FR-02',
        defaultMessage: enDefaults['app.countrySubdivision.FR-02']
      },
      '03': {
        id: 'app.countrySubdivision.FR-03',
        defaultMessage: enDefaults['app.countrySubdivision.FR-03']
      },
      '04': {
        id: 'app.countrySubdivision.FR-04',
        defaultMessage: enDefaults['app.countrySubdivision.FR-04']
      },
      '05': {
        id: 'app.countrySubdivision.FR-05',
        defaultMessage: enDefaults['app.countrySubdivision.FR-05']
      },
      '06': {
        id: 'app.countrySubdivision.FR-06',
        defaultMessage: enDefaults['app.countrySubdivision.FR-06']
      },
      '07': {
        id: 'app.countrySubdivision.FR-07',
        defaultMessage: enDefaults['app.countrySubdivision.FR-07']
      },
      '08': {
        id: 'app.countrySubdivision.FR-08',
        defaultMessage: enDefaults['app.countrySubdivision.FR-08']
      },
      '09': {
        id: 'app.countrySubdivision.FR-09',
        defaultMessage: enDefaults['app.countrySubdivision.FR-09']
      },
      '10': {
        id: 'app.countrySubdivision.FR-10',
        defaultMessage: enDefaults['app.countrySubdivision.FR-10']
      },
      '11': {
        id: 'app.countrySubdivision.FR-11',
        defaultMessage: enDefaults['app.countrySubdivision.FR-11']
      },
      '12': {
        id: 'app.countrySubdivision.FR-12',
        defaultMessage: enDefaults['app.countrySubdivision.FR-12']
      },
      '13': {
        id: 'app.countrySubdivision.FR-13',
        defaultMessage: enDefaults['app.countrySubdivision.FR-13']
      },
      '14': {
        id: 'app.countrySubdivision.FR-14',
        defaultMessage: enDefaults['app.countrySubdivision.FR-14']
      },
      '15': {
        id: 'app.countrySubdivision.FR-15',
        defaultMessage: enDefaults['app.countrySubdivision.FR-15']
      },
      '16': {
        id: 'app.countrySubdivision.FR-16',
        defaultMessage: enDefaults['app.countrySubdivision.FR-16']
      },
      '17': {
        id: 'app.countrySubdivision.FR-17',
        defaultMessage: enDefaults['app.countrySubdivision.FR-17']
      },
      '18': {
        id: 'app.countrySubdivision.FR-18',
        defaultMessage: enDefaults['app.countrySubdivision.FR-18']
      },
      '19': {
        id: 'app.countrySubdivision.FR-19',
        defaultMessage: enDefaults['app.countrySubdivision.FR-19']
      },
      '20': {
        id: 'app.countrySubdivision.FR-20',
        defaultMessage: enDefaults['app.countrySubdivision.FR-20']
      },
      '21': {
        id: 'app.countrySubdivision.FR-21',
        defaultMessage: enDefaults['app.countrySubdivision.FR-21']
      },
      '22': {
        id: 'app.countrySubdivision.FR-22',
        defaultMessage: enDefaults['app.countrySubdivision.FR-22']
      },
      '23': {
        id: 'app.countrySubdivision.FR-23',
        defaultMessage: enDefaults['app.countrySubdivision.FR-23']
      },
      '24': {
        id: 'app.countrySubdivision.FR-24',
        defaultMessage: enDefaults['app.countrySubdivision.FR-24']
      },
      '25': {
        id: 'app.countrySubdivision.FR-25',
        defaultMessage: enDefaults['app.countrySubdivision.FR-25']
      },
      '26': {
        id: 'app.countrySubdivision.FR-26',
        defaultMessage: enDefaults['app.countrySubdivision.FR-26']
      },
      '27': {
        id: 'app.countrySubdivision.FR-27',
        defaultMessage: enDefaults['app.countrySubdivision.FR-27']
      },
      '28': {
        id: 'app.countrySubdivision.FR-28',
        defaultMessage: enDefaults['app.countrySubdivision.FR-28']
      },
      '29': {
        id: 'app.countrySubdivision.FR-29',
        defaultMessage: enDefaults['app.countrySubdivision.FR-29']
      },
      '30': {
        id: 'app.countrySubdivision.FR-30',
        defaultMessage: enDefaults['app.countrySubdivision.FR-30']
      },
      '31': {
        id: 'app.countrySubdivision.FR-31',
        defaultMessage: enDefaults['app.countrySubdivision.FR-31']
      },
      '32': {
        id: 'app.countrySubdivision.FR-32',
        defaultMessage: enDefaults['app.countrySubdivision.FR-32']
      },
      '33': {
        id: 'app.countrySubdivision.FR-33',
        defaultMessage: enDefaults['app.countrySubdivision.FR-33']
      },
      '34': {
        id: 'app.countrySubdivision.FR-34',
        defaultMessage: enDefaults['app.countrySubdivision.FR-34']
      },
      '35': {
        id: 'app.countrySubdivision.FR-35',
        defaultMessage: enDefaults['app.countrySubdivision.FR-35']
      },
      '36': {
        id: 'app.countrySubdivision.FR-36',
        defaultMessage: enDefaults['app.countrySubdivision.FR-36']
      },
      '37': {
        id: 'app.countrySubdivision.FR-37',
        defaultMessage: enDefaults['app.countrySubdivision.FR-37']
      },
      '38': {
        id: 'app.countrySubdivision.FR-38',
        defaultMessage: enDefaults['app.countrySubdivision.FR-38']
      },
      '39': {
        id: 'app.countrySubdivision.FR-39',
        defaultMessage: enDefaults['app.countrySubdivision.FR-39']
      },
      '40': {
        id: 'app.countrySubdivision.FR-40',
        defaultMessage: enDefaults['app.countrySubdivision.FR-40']
      },
      '41': {
        id: 'app.countrySubdivision.FR-41',
        defaultMessage: enDefaults['app.countrySubdivision.FR-41']
      },
      '42': {
        id: 'app.countrySubdivision.FR-42',
        defaultMessage: enDefaults['app.countrySubdivision.FR-42']
      },
      '43': {
        id: 'app.countrySubdivision.FR-43',
        defaultMessage: enDefaults['app.countrySubdivision.FR-43']
      },
      '44': {
        id: 'app.countrySubdivision.FR-44',
        defaultMessage: enDefaults['app.countrySubdivision.FR-44']
      },
      '45': {
        id: 'app.countrySubdivision.FR-45',
        defaultMessage: enDefaults['app.countrySubdivision.FR-45']
      },
      '46': {
        id: 'app.countrySubdivision.FR-46',
        defaultMessage: enDefaults['app.countrySubdivision.FR-46']
      },
      '47': {
        id: 'app.countrySubdivision.FR-47',
        defaultMessage: enDefaults['app.countrySubdivision.FR-47']
      },
      '48': {
        id: 'app.countrySubdivision.FR-48',
        defaultMessage: enDefaults['app.countrySubdivision.FR-48']
      },
      '49': {
        id: 'app.countrySubdivision.FR-49',
        defaultMessage: enDefaults['app.countrySubdivision.FR-49']
      },
      '50': {
        id: 'app.countrySubdivision.FR-50',
        defaultMessage: enDefaults['app.countrySubdivision.FR-50']
      },
      '51': {
        id: 'app.countrySubdivision.FR-51',
        defaultMessage: enDefaults['app.countrySubdivision.FR-51']
      },
      '52': {
        id: 'app.countrySubdivision.FR-52',
        defaultMessage: enDefaults['app.countrySubdivision.FR-52']
      },
      '53': {
        id: 'app.countrySubdivision.FR-53',
        defaultMessage: enDefaults['app.countrySubdivision.FR-53']
      },
      '54': {
        id: 'app.countrySubdivision.FR-54',
        defaultMessage: enDefaults['app.countrySubdivision.FR-54']
      },
      '55': {
        id: 'app.countrySubdivision.FR-55',
        defaultMessage: enDefaults['app.countrySubdivision.FR-55']
      },
      '56': {
        id: 'app.countrySubdivision.FR-56',
        defaultMessage: enDefaults['app.countrySubdivision.FR-56']
      },
      '57': {
        id: 'app.countrySubdivision.FR-57',
        defaultMessage: enDefaults['app.countrySubdivision.FR-57']
      },
      '58': {
        id: 'app.countrySubdivision.FR-58',
        defaultMessage: enDefaults['app.countrySubdivision.FR-58']
      },
      '59': {
        id: 'app.countrySubdivision.FR-59',
        defaultMessage: enDefaults['app.countrySubdivision.FR-59']
      },
      '60': {
        id: 'app.countrySubdivision.FR-60',
        defaultMessage: enDefaults['app.countrySubdivision.FR-60']
      },
      '61': {
        id: 'app.countrySubdivision.FR-61',
        defaultMessage: enDefaults['app.countrySubdivision.FR-61']
      },
      '62': {
        id: 'app.countrySubdivision.FR-62',
        defaultMessage: enDefaults['app.countrySubdivision.FR-62']
      },
      '63': {
        id: 'app.countrySubdivision.FR-63',
        defaultMessage: enDefaults['app.countrySubdivision.FR-63']
      },
      '64': {
        id: 'app.countrySubdivision.FR-64',
        defaultMessage: enDefaults['app.countrySubdivision.FR-64']
      },
      '65': {
        id: 'app.countrySubdivision.FR-65',
        defaultMessage: enDefaults['app.countrySubdivision.FR-65']
      },
      '66': {
        id: 'app.countrySubdivision.FR-66',
        defaultMessage: enDefaults['app.countrySubdivision.FR-66']
      },
      '67': {
        id: 'app.countrySubdivision.FR-67',
        defaultMessage: enDefaults['app.countrySubdivision.FR-67']
      },
      '68': {
        id: 'app.countrySubdivision.FR-68',
        defaultMessage: enDefaults['app.countrySubdivision.FR-68']
      },
      '69': {
        id: 'app.countrySubdivision.FR-69',
        defaultMessage: enDefaults['app.countrySubdivision.FR-69']
      },
      '70': {
        id: 'app.countrySubdivision.FR-70',
        defaultMessage: enDefaults['app.countrySubdivision.FR-70']
      },
      '71': {
        id: 'app.countrySubdivision.FR-71',
        defaultMessage: enDefaults['app.countrySubdivision.FR-71']
      },
      '72': {
        id: 'app.countrySubdivision.FR-72',
        defaultMessage: enDefaults['app.countrySubdivision.FR-72']
      },
      '73': {
        id: 'app.countrySubdivision.FR-73',
        defaultMessage: enDefaults['app.countrySubdivision.FR-73']
      },
      '74': {
        id: 'app.countrySubdivision.FR-74',
        defaultMessage: enDefaults['app.countrySubdivision.FR-74']
      },
      '75': {
        id: 'app.countrySubdivision.FR-75',
        defaultMessage: enDefaults['app.countrySubdivision.FR-75']
      },
      '76': {
        id: 'app.countrySubdivision.FR-76',
        defaultMessage: enDefaults['app.countrySubdivision.FR-76']
      },
      '77': {
        id: 'app.countrySubdivision.FR-77',
        defaultMessage: enDefaults['app.countrySubdivision.FR-77']
      },
      '78': {
        id: 'app.countrySubdivision.FR-78',
        defaultMessage: enDefaults['app.countrySubdivision.FR-78']
      },
      '79': {
        id: 'app.countrySubdivision.FR-79',
        defaultMessage: enDefaults['app.countrySubdivision.FR-79']
      },
      '80': {
        id: 'app.countrySubdivision.FR-80',
        defaultMessage: enDefaults['app.countrySubdivision.FR-80']
      },
      '81': {
        id: 'app.countrySubdivision.FR-81',
        defaultMessage: enDefaults['app.countrySubdivision.FR-81']
      },
      '82': {
        id: 'app.countrySubdivision.FR-82',
        defaultMessage: enDefaults['app.countrySubdivision.FR-82']
      },
      '83': {
        id: 'app.countrySubdivision.FR-83',
        defaultMessage: enDefaults['app.countrySubdivision.FR-83']
      },
      '84': {
        id: 'app.countrySubdivision.FR-84',
        defaultMessage: enDefaults['app.countrySubdivision.FR-84']
      },
      '85': {
        id: 'app.countrySubdivision.FR-85',
        defaultMessage: enDefaults['app.countrySubdivision.FR-85']
      },
      '86': {
        id: 'app.countrySubdivision.FR-86',
        defaultMessage: enDefaults['app.countrySubdivision.FR-86']
      },
      '87': {
        id: 'app.countrySubdivision.FR-87',
        defaultMessage: enDefaults['app.countrySubdivision.FR-87']
      },
      '88': {
        id: 'app.countrySubdivision.FR-88',
        defaultMessage: enDefaults['app.countrySubdivision.FR-88']
      },
      '89': {
        id: 'app.countrySubdivision.FR-89',
        defaultMessage: enDefaults['app.countrySubdivision.FR-89']
      },
      '90': {
        id: 'app.countrySubdivision.FR-90',
        defaultMessage: enDefaults['app.countrySubdivision.FR-90']
      },
      '91': {
        id: 'app.countrySubdivision.FR-91',
        defaultMessage: enDefaults['app.countrySubdivision.FR-91']
      },
      '92': {
        id: 'app.countrySubdivision.FR-92',
        defaultMessage: enDefaults['app.countrySubdivision.FR-92']
      },
      '93': {
        id: 'app.countrySubdivision.FR-93',
        defaultMessage: enDefaults['app.countrySubdivision.FR-93']
      },
      '94': {
        id: 'app.countrySubdivision.FR-94',
        defaultMessage: enDefaults['app.countrySubdivision.FR-94']
      },
      '95': {
        id: 'app.countrySubdivision.FR-95',
        defaultMessage: enDefaults['app.countrySubdivision.FR-95']
      }
    },
    'GB': {
      'E00': {
        id: 'app.countrySubdivision.GB-E00',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E00']
      },
      'E01': {
        id: 'app.countrySubdivision.GB-E01',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E01']
      },
      'E02': {
        id: 'app.countrySubdivision.GB-E02',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E02']
      },
      'E03': {
        id: 'app.countrySubdivision.GB-E03',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E03']
      },
      'E031': {
        id: 'app.countrySubdivision.GB-E031',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E031']
      },
      'E04': {
        id: 'app.countrySubdivision.GB-E04',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E04']
      },
      'E05': {
        id: 'app.countrySubdivision.GB-E05',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E05']
      },
      'E06': {
        id: 'app.countrySubdivision.GB-E06',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E06']
      },
      'E07': {
        id: 'app.countrySubdivision.GB-E07',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E07']
      },
      'E08': {
        id: 'app.countrySubdivision.GB-E08',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E08']
      },
      'E09': {
        id: 'app.countrySubdivision.GB-E09',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E09']
      },
      'E10': {
        id: 'app.countrySubdivision.GB-E10',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E10']
      },
      'E11': {
        id: 'app.countrySubdivision.GB-E11',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E11']
      },
      'E12': {
        id: 'app.countrySubdivision.GB-E12',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E12']
      },
      'E13': {
        id: 'app.countrySubdivision.GB-E13',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E13']
      },
      'E14': {
        id: 'app.countrySubdivision.GB-E14',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E14']
      },
      'E15': {
        id: 'app.countrySubdivision.GB-E15',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E15']
      },
      'E16': {
        id: 'app.countrySubdivision.GB-E16',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E16']
      },
      'E17': {
        id: 'app.countrySubdivision.GB-E17',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E17']
      },
      'E18': {
        id: 'app.countrySubdivision.GB-E18',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E18']
      },
      'E19': {
        id: 'app.countrySubdivision.GB-E19',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E19']
      },
      'E20': {
        id: 'app.countrySubdivision.GB-E20',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E20']
      },
      'E201': {
        id: 'app.countrySubdivision.GB-E201',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E201']
      },
      'E21': {
        id: 'app.countrySubdivision.GB-E21',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E21']
      },
      'E22': {
        id: 'app.countrySubdivision.GB-E22',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E22']
      },
      'E23': {
        id: 'app.countrySubdivision.GB-E23',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E23']
      },
      'E24': {
        id: 'app.countrySubdivision.GB-E24',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E24']
      },
      'E25': {
        id: 'app.countrySubdivision.GB-E25',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E25']
      },
      'E26': {
        id: 'app.countrySubdivision.GB-E26',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E26']
      },
      'E27': {
        id: 'app.countrySubdivision.GB-E27',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E27']
      },
      'E28': {
        id: 'app.countrySubdivision.GB-E28',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E28']
      },
      'E29': {
        id: 'app.countrySubdivision.GB-E29',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E29']
      },
      'E30': {
        id: 'app.countrySubdivision.GB-E30',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E30']
      },
      'E31': {
        id: 'app.countrySubdivision.GB-E31',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E31']
      },
      'E32': {
        id: 'app.countrySubdivision.GB-E32',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E32']
      },
      'E33': {
        id: 'app.countrySubdivision.GB-E33',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E33']
      },
      'E34': {
        id: 'app.countrySubdivision.GB-E34',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E34']
      },
      'E35': {
        id: 'app.countrySubdivision.GB-E35',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E35']
      },
      'E36': {
        id: 'app.countrySubdivision.GB-E36',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E36']
      },
      'E37': {
        id: 'app.countrySubdivision.GB-E37',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E37']
      },
      'E38': {
        id: 'app.countrySubdivision.GB-E38',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E38']
      },
      'E39': {
        id: 'app.countrySubdivision.GB-E39',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E39']
      },
      'E40': {
        id: 'app.countrySubdivision.GB-E40',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E40']
      },
      'E41': {
        id: 'app.countrySubdivision.GB-E41',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E41']
      },
      'E42': {
        id: 'app.countrySubdivision.GB-E42',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E42']
      },
      'E43': {
        id: 'app.countrySubdivision.GB-E43',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E43']
      },
      'E44': {
        id: 'app.countrySubdivision.GB-E44',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E44']
      },
      'E45': {
        id: 'app.countrySubdivision.GB-E45',
        defaultMessage: enDefaults['app.countrySubdivision.GB-E45']
      },
      'N00': {
        id: 'app.countrySubdivision.GB-N00',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N00']
      },
      'N01': {
        id: 'app.countrySubdivision.GB-N01',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N01']
      },
      'N011': {
        id: 'app.countrySubdivision.GB-N011',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N011']
      },
      'N012': {
        id: 'app.countrySubdivision.GB-N012',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N012']
      },
      'N02': {
        id: 'app.countrySubdivision.GB-N02',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N02']
      },
      'N021': {
        id: 'app.countrySubdivision.GB-N021',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N021']
      },
      'N03': {
        id: 'app.countrySubdivision.GB-N03',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N03']
      },
      'N04': {
        id: 'app.countrySubdivision.GB-N04',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N04']
      },
      'N041': {
        id: 'app.countrySubdivision.GB-N041',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N041']
      },
      'N042': {
        id: 'app.countrySubdivision.GB-N042',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N042']
      },
      'N05': {
        id: 'app.countrySubdivision.GB-N05',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N05']
      },
      'N051': {
        id: 'app.countrySubdivision.GB-N051',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N051']
      },
      'N06': {
        id: 'app.countrySubdivision.GB-N06',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N06']
      },
      'N07': {
        id: 'app.countrySubdivision.GB-N07',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N07']
      },
      'N08': {
        id: 'app.countrySubdivision.GB-N08',
        defaultMessage: enDefaults['app.countrySubdivision.GB-N08']
      },
      'S00': {
        id: 'app.countrySubdivision.GB-S00',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S00']
      },
      'S01': {
        id: 'app.countrySubdivision.GB-S01',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S01']
      },
      'S02': {
        id: 'app.countrySubdivision.GB-S02',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S02']
      },
      'S03': {
        id: 'app.countrySubdivision.GB-S03',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S03']
      },
      'S04': {
        id: 'app.countrySubdivision.GB-S04',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S04']
      },
      'S05': {
        id: 'app.countrySubdivision.GB-S05',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S05']
      },
      'S06': {
        id: 'app.countrySubdivision.GB-S06',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S06']
      },
      'S07': {
        id: 'app.countrySubdivision.GB-S07',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S07']
      },
      'S08': {
        id: 'app.countrySubdivision.GB-S08',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S08']
      },
      'S09': {
        id: 'app.countrySubdivision.GB-S09',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S09']
      },
      'S10': {
        id: 'app.countrySubdivision.GB-S10',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S10']
      },
      'S11': {
        id: 'app.countrySubdivision.GB-S11',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S11']
      },
      'S12': {
        id: 'app.countrySubdivision.GB-S12',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S12']
      },
      'S13': {
        id: 'app.countrySubdivision.GB-S13',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S13']
      },
      'S14': {
        id: 'app.countrySubdivision.GB-S14',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S14']
      },
      'S141': {
        id: 'app.countrySubdivision.GB-S141',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S141']
      },
      'S15': {
        id: 'app.countrySubdivision.GB-S15',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S15']
      },
      'S16': {
        id: 'app.countrySubdivision.GB-S16',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S16']
      },
      'S17': {
        id: 'app.countrySubdivision.GB-S17',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S17']
      },
      'S18': {
        id: 'app.countrySubdivision.GB-S18',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S18']
      },
      'S19': {
        id: 'app.countrySubdivision.GB-S19',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S19']
      },
      'S20': {
        id: 'app.countrySubdivision.GB-S20',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S20']
      },
      'S21': {
        id: 'app.countrySubdivision.GB-S21',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S21']
      },
      'S22': {
        id: 'app.countrySubdivision.GB-S22',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S22']
      },
      'S23': {
        id: 'app.countrySubdivision.GB-S23',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S23']
      },
      'S24': {
        id: 'app.countrySubdivision.GB-S24',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S24']
      },
      'S25': {
        id: 'app.countrySubdivision.GB-S25',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S25']
      },
      'S26': {
        id: 'app.countrySubdivision.GB-S26',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S26']
      },
      'S27': {
        id: 'app.countrySubdivision.GB-S27',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S27']
      },
      'S28': {
        id: 'app.countrySubdivision.GB-S28',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S28']
      },
      'S29': {
        id: 'app.countrySubdivision.GB-S29',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S29']
      },
      'S30': {
        id: 'app.countrySubdivision.GB-S30',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S30']
      },
      'S31': {
        id: 'app.countrySubdivision.GB-S31',
        defaultMessage: enDefaults['app.countrySubdivision.GB-S31']
      },
      'W00': {
        id: 'app.countrySubdivision.GB-W00',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W00']
      },
      'W01': {
        id: 'app.countrySubdivision.GB-W01',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W01']
      },
      'W02': {
        id: 'app.countrySubdivision.GB-W02',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W02']
      },
      'W03': {
        id: 'app.countrySubdivision.GB-W03',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W03']
      },
      'W04': {
        id: 'app.countrySubdivision.GB-W04',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W04']
      },
      'W05': {
        id: 'app.countrySubdivision.GB-W05',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W05']
      },
      'W06': {
        id: 'app.countrySubdivision.GB-W06',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W06']
      },
      'W07': {
        id: 'app.countrySubdivision.GB-W07',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W07']
      },
      'W08': {
        id: 'app.countrySubdivision.GB-W08',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W08']
      },
      'W09': {
        id: 'app.countrySubdivision.GB-W09',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W09']
      },
      'W10': {
        id: 'app.countrySubdivision.GB-W10',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W10']
      },
      'W11': {
        id: 'app.countrySubdivision.GB-W11',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W11']
      },
      'W12': {
        id: 'app.countrySubdivision.GB-W12',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W12']
      },
      'W13': {
        id: 'app.countrySubdivision.GB-W13',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W13']
      },
      'W14': {
        id: 'app.countrySubdivision.GB-W14',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W14']
      },
      'W15': {
        id: 'app.countrySubdivision.GB-W15',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W15']
      },
      'W16': {
        id: 'app.countrySubdivision.GB-W16',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W16']
      },
      'W17': {
        id: 'app.countrySubdivision.GB-W17',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W17']
      },
      'W18': {
        id: 'app.countrySubdivision.GB-W18',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W18']
      },
      'W19': {
        id: 'app.countrySubdivision.GB-W19',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W19']
      },
      'W20': {
        id: 'app.countrySubdivision.GB-W20',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W20']
      },
      'W21': {
        id: 'app.countrySubdivision.GB-W21',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W21']
      },
      'W22': {
        id: 'app.countrySubdivision.GB-W22',
        defaultMessage: enDefaults['app.countrySubdivision.GB-W22']
      }
    },
    'US': {
      'AK': {
        id: 'app.countrySubdivision.US-AK',
        defaultMessage: enDefaults['app.countrySubdivision.US-AK']
      },
      'AL': {
        id: 'app.countrySubdivision.US-AL',
        defaultMessage: enDefaults['app.countrySubdivision.US-AL']
      },
      'AR': {
        id: 'app.countrySubdivision.US-AR',
        defaultMessage: enDefaults['app.countrySubdivision.US-AR']
      },
      'AZ': {
        id: 'app.countrySubdivision.US-AZ',
        defaultMessage: enDefaults['app.countrySubdivision.US-AZ']
      },
      'CA': {
        id: 'app.countrySubdivision.US-CA',
        defaultMessage: enDefaults['app.countrySubdivision.US-CA']
      },
      'CO': {
        id: 'app.countrySubdivision.US-CO',
        defaultMessage: enDefaults['app.countrySubdivision.US-CO']
      },
      'CT': {
        id: 'app.countrySubdivision.US-CT',
        defaultMessage: enDefaults['app.countrySubdivision.US-CT']
      },
      'DC': {
        id: 'app.countrySubdivision.US-DC',
        defaultMessage: enDefaults['app.countrySubdivision.US-DC']
      },
      'DE': {
        id: 'app.countrySubdivision.US-DE',
        defaultMessage: enDefaults['app.countrySubdivision.US-DE']
      },
      'FL': {
        id: 'app.countrySubdivision.US-FL',
        defaultMessage: enDefaults['app.countrySubdivision.US-FL']
      },
      'GA': {
        id: 'app.countrySubdivision.US-GA',
        defaultMessage: enDefaults['app.countrySubdivision.US-GA']
      },
      'HI': {
        id: 'app.countrySubdivision.US-HI',
        defaultMessage: enDefaults['app.countrySubdivision.US-HI']
      },
      'IA': {
        id: 'app.countrySubdivision.US-IA',
        defaultMessage: enDefaults['app.countrySubdivision.US-IA']
      },
      'ID': {
        id: 'app.countrySubdivision.US-ID',
        defaultMessage: enDefaults['app.countrySubdivision.US-ID']
      },
      'IL': {
        id: 'app.countrySubdivision.US-IL',
        defaultMessage: enDefaults['app.countrySubdivision.US-IL']
      },
      'IN': {
        id: 'app.countrySubdivision.US-IN',
        defaultMessage: enDefaults['app.countrySubdivision.US-IN']
      },
      'KS': {
        id: 'app.countrySubdivision.US-KS',
        defaultMessage: enDefaults['app.countrySubdivision.US-KS']
      },
      'KY': {
        id: 'app.countrySubdivision.US-KY',
        defaultMessage: enDefaults['app.countrySubdivision.US-KY']
      },
      'LA': {
        id: 'app.countrySubdivision.US-LA',
        defaultMessage: enDefaults['app.countrySubdivision.US-LA']
      },
      'MA': {
        id: 'app.countrySubdivision.US-MA',
        defaultMessage: enDefaults['app.countrySubdivision.US-MA']
      },
      'MD': {
        id: 'app.countrySubdivision.US-MD',
        defaultMessage: enDefaults['app.countrySubdivision.US-MD']
      },
      'ME': {
        id: 'app.countrySubdivision.US-ME',
        defaultMessage: enDefaults['app.countrySubdivision.US-ME']
      },
      'MI': {
        id: 'app.countrySubdivision.US-MI',
        defaultMessage: enDefaults['app.countrySubdivision.US-MI']
      },
      'MN': {
        id: 'app.countrySubdivision.US-MN',
        defaultMessage: enDefaults['app.countrySubdivision.US-MN']
      },
      'MO': {
        id: 'app.countrySubdivision.US-MO',
        defaultMessage: enDefaults['app.countrySubdivision.US-MO']
      },
      'MS': {
        id: 'app.countrySubdivision.US-MS',
        defaultMessage: enDefaults['app.countrySubdivision.US-MS']
      },
      'MT': {
        id: 'app.countrySubdivision.US-MT',
        defaultMessage: enDefaults['app.countrySubdivision.US-MT']
      },
      'NC': {
        id: 'app.countrySubdivision.US-NC',
        defaultMessage: enDefaults['app.countrySubdivision.US-NC']
      },
      'ND': {
        id: 'app.countrySubdivision.US-ND',
        defaultMessage: enDefaults['app.countrySubdivision.US-ND']
      },
      'NE': {
        id: 'app.countrySubdivision.US-NE',
        defaultMessage: enDefaults['app.countrySubdivision.US-NE']
      },
      'NH': {
        id: 'app.countrySubdivision.US-NH',
        defaultMessage: enDefaults['app.countrySubdivision.US-NH']
      },
      'NJ': {
        id: 'app.countrySubdivision.US-NJ',
        defaultMessage: enDefaults['app.countrySubdivision.US-NJ']
      },
      'NM': {
        id: 'app.countrySubdivision.US-NM',
        defaultMessage: enDefaults['app.countrySubdivision.US-NM']
      },
      'NV': {
        id: 'app.countrySubdivision.US-NV',
        defaultMessage: enDefaults['app.countrySubdivision.US-NV']
      },
      'NY': {
        id: 'app.countrySubdivision.US-NY',
        defaultMessage: enDefaults['app.countrySubdivision.US-NY']
      },
      'OH': {
        id: 'app.countrySubdivision.US-OH',
        defaultMessage: enDefaults['app.countrySubdivision.US-OH']
      },
      'OK': {
        id: 'app.countrySubdivision.US-OK',
        defaultMessage: enDefaults['app.countrySubdivision.US-OK']
      },
      'OR': {
        id: 'app.countrySubdivision.US-OR',
        defaultMessage: enDefaults['app.countrySubdivision.US-OR']
      },
      'OTHER': {
        id: 'app.countrySubdivision.US-OTHER',
        defaultMessage: enDefaults['app.countrySubdivision.US-OTHER']
      },
      'PA': {
        id: 'app.countrySubdivision.US-PA',
        defaultMessage: enDefaults['app.countrySubdivision.US-PA']
      },
      'RI': {
        id: 'app.countrySubdivision.US-RI',
        defaultMessage: enDefaults['app.countrySubdivision.US-RI']
      },
      'SC': {
        id: 'app.countrySubdivision.US-SC',
        defaultMessage: enDefaults['app.countrySubdivision.US-SC']
      },
      'SD': {
        id: 'app.countrySubdivision.US-SD',
        defaultMessage: enDefaults['app.countrySubdivision.US-SD']
      },
      'TN': {
        id: 'app.countrySubdivision.US-TN',
        defaultMessage: enDefaults['app.countrySubdivision.US-TN']
      },
      'TX': {
        id: 'app.countrySubdivision.US-TX',
        defaultMessage: enDefaults['app.countrySubdivision.US-TX']
      },
      'UT': {
        id: 'app.countrySubdivision.US-UT',
        defaultMessage: enDefaults['app.countrySubdivision.US-UT']
      },
      'VA': {
        id: 'app.countrySubdivision.US-VA',
        defaultMessage: enDefaults['app.countrySubdivision.US-VA']
      },
      'VT': {
        id: 'app.countrySubdivision.US-VT',
        defaultMessage: enDefaults['app.countrySubdivision.US-VT']
      },
      'WA': {
        id: 'app.countrySubdivision.US-WA',
        defaultMessage: enDefaults['app.countrySubdivision.US-WA']
      },
      'WI': {
        id: 'app.countrySubdivision.US-WI',
        defaultMessage: enDefaults['app.countrySubdivision.US-WI']
      },
      'WV': {
        id: 'app.countrySubdivision.US-WV',
        defaultMessage: enDefaults['app.countrySubdivision.US-WV']
      },
      'WY': {
        id: 'app.countrySubdivision.US-WY',
        defaultMessage: enDefaults['app.countrySubdivision.US-WY']
      }
    },
    'DE': {
      'BW': {
        id: 'app.countrySubdivision.DE-BW',
        defaultMessage: enDefaults['app.countrySubdivision.DE-BW']
      },
      'BY': {
        id: 'app.countrySubdivision.DE-BY',
        defaultMessage: enDefaults['app.countrySubdivision.DE-BY']
      },
      'BE': {
        id: 'app.countrySubdivision.DE-BE',
        defaultMessage: enDefaults['app.countrySubdivision.DE-BE']
      },
      'BB': {
        id: 'app.countrySubdivision.DE-BB',
        defaultMessage: enDefaults['app.countrySubdivision.DE-BB']
      },
      'HB': {
        id: 'app.countrySubdivision.DE-HB',
        defaultMessage: enDefaults['app.countrySubdivision.DE-HB']
      },
      'HH': {
        id: 'app.countrySubdivision.DE-HH',
        defaultMessage: enDefaults['app.countrySubdivision.DE-HH']
      },
      'HE': {
        id: 'app.countrySubdivision.DE-HE',
        defaultMessage: enDefaults['app.countrySubdivision.DE-HE']
      },
      'MV': {
        id: 'app.countrySubdivision.DE-MV',
        defaultMessage: enDefaults['app.countrySubdivision.DE-MV']
      },
      'NI': {
        id: 'app.countrySubdivision.DE-NI',
        defaultMessage: enDefaults['app.countrySubdivision.DE-NI']
      },
      'NW': {
        id: 'app.countrySubdivision.DE-NW',
        defaultMessage: enDefaults['app.countrySubdivision.DE-NW']
      },
      'RP': {
        id: 'app.countrySubdivision.DE-RP',
        defaultMessage: enDefaults['app.countrySubdivision.DE-RP']
      },
      'SL': {
        id: 'app.countrySubdivision.DE-SL',
        defaultMessage: enDefaults['app.countrySubdivision.DE-SL']
      },
      'SN': {
        id: 'app.countrySubdivision.DE-SN',
        defaultMessage: enDefaults['app.countrySubdivision.DE-SN']
      },
      'ST': {
        id: 'app.countrySubdivision.DE-ST',
        defaultMessage: enDefaults['app.countrySubdivision.DE-ST']
      },
      'SH': {
        id: 'app.countrySubdivision.DE-SH',
        defaultMessage: enDefaults['app.countrySubdivision.DE-SH']
      },
      'TH': {
        id: 'app.countrySubdivision.DE-TH',
        defaultMessage: enDefaults['app.countrySubdivision.DE-TH']
      }
    },
    'ES': {
      'A': {
        id: 'app.countrySubdivision.ES-A',
        defaultMessage: enDefaults['app.countrySubdivision.ES-A']
      },
      'AB': {
        id: 'app.countrySubdivision.ES-AB',
        defaultMessage: enDefaults['app.countrySubdivision.ES-AB']
      },
      'AL': {
        id: 'app.countrySubdivision.ES-AL',
        defaultMessage: enDefaults['app.countrySubdivision.ES-AL']
      },
      'AV': {
        id: 'app.countrySubdivision.ES-AV',
        defaultMessage: enDefaults['app.countrySubdivision.ES-AV']
      },
      'B': {
        id: 'app.countrySubdivision.ES-B',
        defaultMessage: enDefaults['app.countrySubdivision.ES-B']
      },
      'BA': {
        id: 'app.countrySubdivision.ES-BA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-BA']
      },
      'BI': {
        id: 'app.countrySubdivision.ES-BI',
        defaultMessage: enDefaults['app.countrySubdivision.ES-BI']
      },
      'BU': {
        id: 'app.countrySubdivision.ES-BU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-BU']
      },
      'C': {
        id: 'app.countrySubdivision.ES-C',
        defaultMessage: enDefaults['app.countrySubdivision.ES-C']
      },
      'CA': {
        id: 'app.countrySubdivision.ES-CA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CA']
      },
      'CC': {
        id: 'app.countrySubdivision.ES-CC',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CC']
      },
      'CE': {
        id: 'app.countrySubdivision.ES-CE',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CE']
      },
      'CO': {
        id: 'app.countrySubdivision.ES-CO',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CO']
      },
      'CR': {
        id: 'app.countrySubdivision.ES-CR',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CR']
      },
      'CS': {
        id: 'app.countrySubdivision.ES-CS',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CS']
      },
      'CU': {
        id: 'app.countrySubdivision.ES-CU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-CU']
      },
      'GC': {
        id: 'app.countrySubdivision.ES-GC',
        defaultMessage: enDefaults['app.countrySubdivision.ES-GC']
      },
      'GI': {
        id: 'app.countrySubdivision.ES-GI',
        defaultMessage: enDefaults['app.countrySubdivision.ES-GI']
      },
      'GR': {
        id: 'app.countrySubdivision.ES-GR',
        defaultMessage: enDefaults['app.countrySubdivision.ES-GR']
      },
      'GU': {
        id: 'app.countrySubdivision.ES-GU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-GU']
      },
      'H': {
        id: 'app.countrySubdivision.ES-H',
        defaultMessage: enDefaults['app.countrySubdivision.ES-H']
      },
      'HU': {
        id: 'app.countrySubdivision.ES-HU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-HU']
      },
      'J': {
        id: 'app.countrySubdivision.ES-J',
        defaultMessage: enDefaults['app.countrySubdivision.ES-J']
      },
      'L': {
        id: 'app.countrySubdivision.ES-L',
        defaultMessage: enDefaults['app.countrySubdivision.ES-L']
      },
      'LE': {
        id: 'app.countrySubdivision.ES-LE',
        defaultMessage: enDefaults['app.countrySubdivision.ES-LE']
      },
      'LO': {
        id: 'app.countrySubdivision.ES-LO',
        defaultMessage: enDefaults['app.countrySubdivision.ES-LO']
      },
      'LU': {
        id: 'app.countrySubdivision.ES-LU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-LU']
      },
      'M': {
        id: 'app.countrySubdivision.ES-M',
        defaultMessage: enDefaults['app.countrySubdivision.ES-M']
      },
      'MA': {
        id: 'app.countrySubdivision.ES-MA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-MA']
      },
      'ML': {
        id: 'app.countrySubdivision.ES-ML',
        defaultMessage: enDefaults['app.countrySubdivision.ES-ML']
      },
      'MU': {
        id: 'app.countrySubdivision.ES-MU',
        defaultMessage: enDefaults['app.countrySubdivision.ES-MU']
      },
      'NA': {
        id: 'app.countrySubdivision.ES-NA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-NA']
      },
      'O': {
        id: 'app.countrySubdivision.ES-O',
        defaultMessage: enDefaults['app.countrySubdivision.ES-O']
      },
      'OR': {
        id: 'app.countrySubdivision.ES-OR',
        defaultMessage: enDefaults['app.countrySubdivision.ES-OR']
      },
      'P': {
        id: 'app.countrySubdivision.ES-P',
        defaultMessage: enDefaults['app.countrySubdivision.ES-P']
      },
      'PM': {
        id: 'app.countrySubdivision.ES-PM',
        defaultMessage: enDefaults['app.countrySubdivision.ES-PM']
      },
      'PO': {
        id: 'app.countrySubdivision.ES-PO',
        defaultMessage: enDefaults['app.countrySubdivision.ES-PO']
      },
      'S': {
        id: 'app.countrySubdivision.ES-S',
        defaultMessage: enDefaults['app.countrySubdivision.ES-S']
      },
      'SA': {
        id: 'app.countrySubdivision.ES-SA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-SA']
      },
      'SE': {
        id: 'app.countrySubdivision.ES-SE',
        defaultMessage: enDefaults['app.countrySubdivision.ES-SE']
      },
      'SG': {
        id: 'app.countrySubdivision.ES-SG',
        defaultMessage: enDefaults['app.countrySubdivision.ES-SG']
      },
      'SO': {
        id: 'app.countrySubdivision.ES-SO',
        defaultMessage: enDefaults['app.countrySubdivision.ES-SO']
      },
      'SS': {
        id: 'app.countrySubdivision.ES-SS',
        defaultMessage: enDefaults['app.countrySubdivision.ES-SS']
      },
      'T': {
        id: 'app.countrySubdivision.ES-T',
        defaultMessage: enDefaults['app.countrySubdivision.ES-T']
      },
      'TE': {
        id: 'app.countrySubdivision.ES-TE',
        defaultMessage: enDefaults['app.countrySubdivision.ES-TE']
      },
      'TF': {
        id: 'app.countrySubdivision.ES-TF',
        defaultMessage: enDefaults['app.countrySubdivision.ES-TF']
      },
      'TO': {
        id: 'app.countrySubdivision.ES-TO',
        defaultMessage: enDefaults['app.countrySubdivision.ES-TO']
      },
      'V': {
        id: 'app.countrySubdivision.ES-V',
        defaultMessage: enDefaults['app.countrySubdivision.ES-V']
      },
      'VA': {
        id: 'app.countrySubdivision.ES-VA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-VA']
      },
      'VI': {
        id: 'app.countrySubdivision.ES-VI',
        defaultMessage: enDefaults['app.countrySubdivision.ES-VI']
      },
      'Z': {
        id: 'app.countrySubdivision.ES-Z',
        defaultMessage: enDefaults['app.countrySubdivision.ES-Z']
      },
      'ZA': {
        id: 'app.countrySubdivision.ES-ZA',
        defaultMessage: enDefaults['app.countrySubdivision.ES-ZA']
      }
    },
    'IT': {
      '23': {
        id: 'app.countrySubdivision.IT-23',
        defaultMessage: enDefaults['app.countrySubdivision.IT-23']
      },
      'AG': {
        id: 'app.countrySubdivision.IT-AG',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AG']
      },
      'AL': {
        id: 'app.countrySubdivision.IT-AL',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AL']
      },
      'AN': {
        id: 'app.countrySubdivision.IT-AN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AN']
      },
      'AO': {
        id: 'app.countrySubdivision.IT-AO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AO']
      },
      'AP': {
        id: 'app.countrySubdivision.IT-AP',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AP']
      },
      'AQ': {
        id: 'app.countrySubdivision.IT-AQ',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AQ']
      },
      'AR': {
        id: 'app.countrySubdivision.IT-AR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AR']
      },
      'AT': {
        id: 'app.countrySubdivision.IT-AT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AT']
      },
      'AV': {
        id: 'app.countrySubdivision.IT-AV',
        defaultMessage: enDefaults['app.countrySubdivision.IT-AV']
      },
      'BA': {
        id: 'app.countrySubdivision.IT-BA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BA']
      },
      'BG': {
        id: 'app.countrySubdivision.IT-BG',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BG']
      },
      'BI': {
        id: 'app.countrySubdivision.IT-BI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BI']
      },
      'BL': {
        id: 'app.countrySubdivision.IT-BL',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BL']
      },
      'BN': {
        id: 'app.countrySubdivision.IT-BN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BN']
      },
      'BO': {
        id: 'app.countrySubdivision.IT-BO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BO']
      },
      'BR': {
        id: 'app.countrySubdivision.IT-BR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BR']
      },
      'BS': {
        id: 'app.countrySubdivision.IT-BS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BS']
      },
      'BT': {
        id: 'app.countrySubdivision.IT-BT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BT']
      },
      'BZ': {
        id: 'app.countrySubdivision.IT-BZ',
        defaultMessage: enDefaults['app.countrySubdivision.IT-BZ']
      },
      'CA': {
        id: 'app.countrySubdivision.IT-CA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CA']
      },
      'CB': {
        id: 'app.countrySubdivision.IT-CB',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CB']
      },
      'CE': {
        id: 'app.countrySubdivision.IT-CE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CE']
      },
      'CH': {
        id: 'app.countrySubdivision.IT-CH',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CH']
      },
      'CL': {
        id: 'app.countrySubdivision.IT-CL',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CL']
      },
      'CN': {
        id: 'app.countrySubdivision.IT-CN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CN']
      },
      'CO': {
        id: 'app.countrySubdivision.IT-CO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CO']
      },
      'CR': {
        id: 'app.countrySubdivision.IT-CR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CR']
      },
      'CS': {
        id: 'app.countrySubdivision.IT-CS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CS']
      },
      'CT': {
        id: 'app.countrySubdivision.IT-CT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CT']
      },
      'CZ': {
        id: 'app.countrySubdivision.IT-CZ',
        defaultMessage: enDefaults['app.countrySubdivision.IT-CZ']
      },
      'EN': {
        id: 'app.countrySubdivision.IT-EN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-EN']
      },
      'FC': {
        id: 'app.countrySubdivision.IT-FC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FC']
      },
      'FE': {
        id: 'app.countrySubdivision.IT-FE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FE']
      },
      'FG': {
        id: 'app.countrySubdivision.IT-FG',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FG']
      },
      'FI': {
        id: 'app.countrySubdivision.IT-FI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FI']
      },
      'FM': {
        id: 'app.countrySubdivision.IT-FM',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FM']
      },
      'FR': {
        id: 'app.countrySubdivision.IT-FR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-FR']
      },
      'GE': {
        id: 'app.countrySubdivision.IT-GE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-GE']
      },
      'GO': {
        id: 'app.countrySubdivision.IT-GO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-GO']
      },
      'GR': {
        id: 'app.countrySubdivision.IT-GR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-GR']
      },
      'IM': {
        id: 'app.countrySubdivision.IT-IM',
        defaultMessage: enDefaults['app.countrySubdivision.IT-IM']
      },
      'IS': {
        id: 'app.countrySubdivision.IT-IS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-IS']
      },
      'KR': {
        id: 'app.countrySubdivision.IT-KR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-KR']
      },
      'LC': {
        id: 'app.countrySubdivision.IT-LC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LC']
      },
      'LE': {
        id: 'app.countrySubdivision.IT-LE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LE']
      },
      'LI': {
        id: 'app.countrySubdivision.IT-LI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LI']
      },
      'LO': {
        id: 'app.countrySubdivision.IT-LO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LO']
      },
      'LT': {
        id: 'app.countrySubdivision.IT-LT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LT']
      },
      'LU': {
        id: 'app.countrySubdivision.IT-LU',
        defaultMessage: enDefaults['app.countrySubdivision.IT-LU']
      },
      'MB': {
        id: 'app.countrySubdivision.IT-MB',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MB']
      },
      'MC': {
        id: 'app.countrySubdivision.IT-MC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MC']
      },
      'ME': {
        id: 'app.countrySubdivision.IT-ME',
        defaultMessage: enDefaults['app.countrySubdivision.IT-ME']
      },
      'MI': {
        id: 'app.countrySubdivision.IT-MI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MI']
      },
      'MN': {
        id: 'app.countrySubdivision.IT-MN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MN']
      },
      'MO': {
        id: 'app.countrySubdivision.IT-MO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MO']
      },
      'MS': {
        id: 'app.countrySubdivision.IT-MS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MS']
      },
      'MT': {
        id: 'app.countrySubdivision.IT-MT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-MT']
      },
      'NA': {
        id: 'app.countrySubdivision.IT-NA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-NA']
      },
      'NO': {
        id: 'app.countrySubdivision.IT-NO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-NO']
      },
      'NU': {
        id: 'app.countrySubdivision.IT-NU',
        defaultMessage: enDefaults['app.countrySubdivision.IT-NU']
      },
      'OR': {
        id: 'app.countrySubdivision.IT-OR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-OR']
      },
      'PA': {
        id: 'app.countrySubdivision.IT-PA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PA']
      },
      'PC': {
        id: 'app.countrySubdivision.IT-PC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PC']
      },
      'PD': {
        id: 'app.countrySubdivision.IT-PD',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PD']
      },
      'PE': {
        id: 'app.countrySubdivision.IT-PE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PE']
      },
      'PG': {
        id: 'app.countrySubdivision.IT-PG',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PG']
      },
      'PI': {
        id: 'app.countrySubdivision.IT-PI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PI']
      },
      'PN': {
        id: 'app.countrySubdivision.IT-PN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PN']
      },
      'PO': {
        id: 'app.countrySubdivision.IT-PO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PO']
      },
      'PR': {
        id: 'app.countrySubdivision.IT-PR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PR']
      },
      'PT': {
        id: 'app.countrySubdivision.IT-PT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PT']
      },
      'PU': {
        id: 'app.countrySubdivision.IT-PU',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PU']
      },
      'PV': {
        id: 'app.countrySubdivision.IT-PV',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PV']
      },
      'PZ': {
        id: 'app.countrySubdivision.IT-PZ',
        defaultMessage: enDefaults['app.countrySubdivision.IT-PZ']
      },
      'RA': {
        id: 'app.countrySubdivision.IT-RA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RA']
      },
      'RC': {
        id: 'app.countrySubdivision.IT-RC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RC']
      },
      'RE': {
        id: 'app.countrySubdivision.IT-RE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RE']
      },
      'RG': {
        id: 'app.countrySubdivision.IT-RG',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RG']
      },
      'RI': {
        id: 'app.countrySubdivision.IT-RI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RI']
      },
      'RM': {
        id: 'app.countrySubdivision.IT-RM',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RM']
      },
      'RN': {
        id: 'app.countrySubdivision.IT-RN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RN']
      },
      'RO': {
        id: 'app.countrySubdivision.IT-RO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-RO']
      },
      'SA': {
        id: 'app.countrySubdivision.IT-SA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SA']
      },
      'SI': {
        id: 'app.countrySubdivision.IT-SI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SI']
      },
      'SO': {
        id: 'app.countrySubdivision.IT-SO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SO']
      },
      'SP': {
        id: 'app.countrySubdivision.IT-SP',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SP']
      },
      'SR': {
        id: 'app.countrySubdivision.IT-SR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SR']
      },
      'SS': {
        id: 'app.countrySubdivision.IT-SS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SS']
      },
      'SU': {
        id: 'app.countrySubdivision.IT-SU',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SU']
      },
      'SV': {
        id: 'app.countrySubdivision.IT-SV',
        defaultMessage: enDefaults['app.countrySubdivision.IT-SV']
      },
      'TA': {
        id: 'app.countrySubdivision.IT-TA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TA']
      },
      'TE': {
        id: 'app.countrySubdivision.IT-TE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TE']
      },
      'TN': {
        id: 'app.countrySubdivision.IT-TN',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TN']
      },
      'TO': {
        id: 'app.countrySubdivision.IT-TO',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TO']
      },
      'TP': {
        id: 'app.countrySubdivision.IT-TP',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TP']
      },
      'TR': {
        id: 'app.countrySubdivision.IT-TR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TR']
      },
      'TS': {
        id: 'app.countrySubdivision.IT-TS',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TS']
      },
      'TV': {
        id: 'app.countrySubdivision.IT-TV',
        defaultMessage: enDefaults['app.countrySubdivision.IT-TV']
      },
      'UD': {
        id: 'app.countrySubdivision.IT-UD',
        defaultMessage: enDefaults['app.countrySubdivision.IT-UD']
      },
      'VA': {
        id: 'app.countrySubdivision.IT-VA',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VA']
      },
      'VB': {
        id: 'app.countrySubdivision.IT-VB',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VB']
      },
      'VC': {
        id: 'app.countrySubdivision.IT-VC',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VC']
      },
      'VE': {
        id: 'app.countrySubdivision.IT-VE',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VE']
      },
      'VI': {
        id: 'app.countrySubdivision.IT-VI',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VI']
      },
      'VR': {
        id: 'app.countrySubdivision.IT-VR',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VR']
      },
      'VT': {
        id: 'app.countrySubdivision.IT-VT',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VT']
      },
      'VV': {
        id: 'app.countrySubdivision.IT-VV',
        defaultMessage: enDefaults['app.countrySubdivision.IT-VV']
      }
    }
  },
  countryRegions: {
    'all-regions': {
      id: 'app.countryRegions.all',
      defaultMessage: enDefaults['app.countryRegions.all']
    },
    'andalucia': {
      id: 'app.countryRegions.es.andalucia',
      defaultMessage: enDefaults['app.countryRegions.es.andalucia']
    },
    'aragon': {
      id: 'app.countryRegions.es.aragon',
      defaultMessage: enDefaults['app.countryRegions.es.aragon']
    },
    'canarias': {
      id: 'app.countryRegions.es.canarias',
      defaultMessage: enDefaults['app.countryRegions.es.canarias']
    },
    'cantabria': {
      id: 'app.countryRegions.es.cantabria',
      defaultMessage: enDefaults['app.countryRegions.es.cantabria']
    },
    'castilla-y-leon': {
      id: 'app.countryRegions.es.castilla-y-leon',
      defaultMessage: enDefaults['app.countryRegions.es.castilla-y-leon']
    },
    'castilla-la-mancha': {
      id: 'app.countryRegions.es.castilla-la-mancha',
      defaultMessage: enDefaults['app.countryRegions.es.castilla-la-mancha']
    },
    'cataluna': {
      id: 'app.countryRegions.es.cataluna',
      defaultMessage: enDefaults['app.countryRegions.es.cataluna']
    },
    'ceuta': {
      id: 'app.countryRegions.es.ceuta',
      defaultMessage: enDefaults['app.countryRegions.es.ceuta']
    },
    'comunidad-de-madrid': {
      id: 'app.countryRegions.es.comunidad-de-madrid',
      defaultMessage: enDefaults['app.countryRegions.es.comunidad-de-madrid']
    },
    'comunitat-valenciana': {
      id: 'app.countryRegions.es.comunitat-valenciana',
      defaultMessage: enDefaults['app.countryRegions.es.comunitat-valenciana']
    },
    'extremadura': {
      id: 'app.countryRegions.es.extremadura',
      defaultMessage: enDefaults['app.countryRegions.es.extremadura']
    },
    'galicia': {
      id: 'app.countryRegions.es.galicia',
      defaultMessage: enDefaults['app.countryRegions.es.galicia']
    },
    'islas-baleares': {
      id: 'app.countryRegions.es.islas-baleares',
      defaultMessage: enDefaults['app.countryRegions.es.islas-baleares']
    },
    'la-rioja': {
      id: 'app.countryRegions.es.la-rioja',
      defaultMessage: enDefaults['app.countryRegions.es.la-rioja']
    },
    'melilla': {
      id: 'app.countryRegions.es.melilla',
      defaultMessage: enDefaults['app.countryRegions.es.melilla']
    },
    'navarra': {
      id: 'app.countryRegions.es.navarra',
      defaultMessage: enDefaults['app.countryRegions.es.navarra']
    },
    'pais-vasco': {
      id: 'app.countryRegions.es.pais-vasco',
      defaultMessage: enDefaults['app.countryRegions.es.pais-vasco']
    },
    'principado-de-asturias': {
      id: 'app.countryRegions.es.principado-de-asturias',
      defaultMessage: enDefaults['app.countryRegions.es.principado-de-asturias']
    },
    'region-de-murcia': {
      id: 'app.countryRegions.es.region-de-murcia',
      defaultMessage: enDefaults['app.countryRegions.es.region-de-murcia']
    },
    'nord-manche': {
      id: 'app.countryRegions.fr.nord-manche',
      defaultMessage: enDefaults['app.countryRegions.fr.nord-manche']
    },
    'autres-regions': {
      id: 'app.countryRegions.fr.autres-regions',
      defaultMessage: enDefaults['app.countryRegions.fr.autres-regions']
    },
    'dom-tom': {
      id: 'app.countryRegions.fr.dom-tom',
      defaultMessage: enDefaults['app.countryRegions.fr.dom-tom']
    },
    'etranger': {
      id: 'app.countryRegions.fr.etranger',
      defaultMessage: enDefaults['app.countryRegions.fr.etranger']
    },
    'ile-de-france': {
      id: 'app.countryRegions.fr.ile-de-france',
      defaultMessage: enDefaults['app.countryRegions.fr.ile-de-france']
    },
    'ouest': {
      id: 'app.countryRegions.fr.ouest',
      defaultMessage: enDefaults['app.countryRegions.fr.ouest']
    },
    'sud-mediterranee': {
      id: 'app.countryRegions.fr.sud-mediterranee',
      defaultMessage: enDefaults['app.countryRegions.fr.sud-mediterranee']
    },
    'sud-ouest': {
      id: 'app.countryRegions.fr.sud-ouest',
      defaultMessage: enDefaults['app.countryRegions.fr.sud-ouest']
    },
    'auvergne-rhone-alpes': {
      id: 'app.countryRegions.fr.auvergne-rhone-alpes',
      defaultMessage: enDefaults['app.countryRegions.fr.auvergne-rhone-alpes']
    },
    'bourgogne-franche-comte': {
      id: 'app.countryRegions.fr.bourgogne-franche-comte',
      defaultMessage:
        enDefaults['app.countryRegions.fr.bourgogne-franche-comte']
    },
    'bretagne': {
      id: 'app.countryRegions.fr.bretagne',
      defaultMessage: enDefaults['app.countryRegions.fr.bretagne']
    },
    'centre-val-de-loire': {
      id: 'app.countryRegions.fr.centre-val-de-loire',
      defaultMessage: enDefaults['app.countryRegions.fr.centre-val-de-loire']
    },
    'corse': {
      id: 'app.countryRegions.fr.corse',
      defaultMessage: enDefaults['app.countryRegions.fr.corse']
    },
    'grand-est': {
      id: 'app.countryRegions.fr.grand-est',
      defaultMessage: enDefaults['app.countryRegions.fr.grand-est']
    },
    'hauts-de-france': {
      id: 'app.countryRegions.fr.hauts-de-france',
      defaultMessage: enDefaults['app.countryRegions.fr.hauts-de-france']
    },
    'normandie': {
      id: 'app.countryRegions.fr.normandie',
      defaultMessage: enDefaults['app.countryRegions.fr.normandie']
    },
    'nouvelle-aquitaine': {
      id: 'app.countryRegions.fr.nouvelle-aquitaine',
      defaultMessage: enDefaults['app.countryRegions.fr.nouvelle-aquitaine']
    },
    'occitanie': {
      id: 'app.countryRegions.fr.occitanie',
      defaultMessage: enDefaults['app.countryRegions.fr.occitanie']
    },
    'pays-de-la-loire': {
      id: 'app.countryRegions.fr.pays-de-la-loire',
      defaultMessage: enDefaults['app.countryRegions.fr.pays-de-la-loire']
    },
    'provence-alpes-cote-dazur': {
      id: 'app.countryRegions.fr.provence-alpes-cote-dazur',
      defaultMessage:
        enDefaults['app.countryRegions.fr.provence-alpes-cote-dazur']
    },
    'east-midlands': {
      id: 'app.countryRegions.gb.east-midlands',
      defaultMessage: enDefaults['app.countryRegions.gb.east-midlands']
    },
    'east-of-england': {
      id: 'app.countryRegions.gb.east-of-england',
      defaultMessage: enDefaults['app.countryRegions.gb.east-of-england']
    },
    'london': {
      id: 'app.countryRegions.gb.london',
      defaultMessage: enDefaults['app.countryRegions.gb.london']
    },
    'north-east': {
      id: 'app.countryRegions.gb.north-east',
      defaultMessage: enDefaults['app.countryRegions.gb.north-east']
    },
    'north-west': {
      id: 'app.countryRegions.gb.north-west',
      defaultMessage: enDefaults['app.countryRegions.gb.north-west']
    },
    'northern-ireland': {
      id: 'app.countryRegions.gb.northern-ireland',
      defaultMessage: enDefaults['app.countryRegions.gb.northern-ireland']
    },
    'scotland': {
      id: 'app.countryRegions.gb.scotland',
      defaultMessage: enDefaults['app.countryRegions.gb.scotland']
    },
    'south-east': {
      id: 'app.countryRegions.gb.south-east',
      defaultMessage: enDefaults['app.countryRegions.gb.south-east']
    },
    'south-west': {
      id: 'app.countryRegions.gb.south-west',
      defaultMessage: enDefaults['app.countryRegions.gb.south-west']
    },
    'wales': {
      id: 'app.countryRegions.gb.wales',
      defaultMessage: enDefaults['app.countryRegions.gb.wales']
    },
    'west-midlands': {
      id: 'app.countryRegions.gb.west-midlands',
      defaultMessage: enDefaults['app.countryRegions.gb.west-midlands']
    },
    'yorkshire-and-the-humber': {
      id: 'app.countryRegions.gb.yorkshire-and-the-humber',
      defaultMessage:
        enDefaults['app.countryRegions.gb.yorkshire-and-the-humber']
    },
    'abruzzo': {
      id: 'app.countryRegions.it.abruzzo',
      defaultMessage: enDefaults['app.countryRegions.it.abruzzo']
    },
    'basilicata': {
      id: 'app.countryRegions.it.basilicata',
      defaultMessage: enDefaults['app.countryRegions.it.basilicata']
    },
    'calabria': {
      id: 'app.countryRegions.it.calabria',
      defaultMessage: enDefaults['app.countryRegions.it.calabria']
    },
    'campania': {
      id: 'app.countryRegions.it.campania',
      defaultMessage: enDefaults['app.countryRegions.it.campania']
    },
    'emilia-romagna': {
      id: 'app.countryRegions.it.emilia-romagna',
      defaultMessage: enDefaults['app.countryRegions.it.emilia-romagna']
    },
    'friuli-venezia-giulia': {
      id: 'app.countryRegions.it.friuli-venezia-giulia',
      defaultMessage: enDefaults['app.countryRegions.it.friuli-venezia-giulia']
    },
    'lazio': {
      id: 'app.countryRegions.it.lazio',
      defaultMessage: enDefaults['app.countryRegions.it.lazio']
    },
    'liguria': {
      id: 'app.countryRegions.it.liguria',
      defaultMessage: enDefaults['app.countryRegions.it.liguria']
    },
    'lombardia': {
      id: 'app.countryRegions.it.lombardia',
      defaultMessage: enDefaults['app.countryRegions.it.lombardia']
    },
    'marche': {
      id: 'app.countryRegions.it.marche',
      defaultMessage: enDefaults['app.countryRegions.it.marche']
    },
    'molise': {
      id: 'app.countryRegions.it.molise',
      defaultMessage: enDefaults['app.countryRegions.it.molise']
    },
    'piemonte': {
      id: 'app.countryRegions.it.piemonte',
      defaultMessage: enDefaults['app.countryRegions.it.piemonte']
    },
    'puglia': {
      id: 'app.countryRegions.it.puglia',
      defaultMessage: enDefaults['app.countryRegions.it.puglia']
    },
    'sardegna': {
      id: 'app.countryRegions.it.sardegna',
      defaultMessage: enDefaults['app.countryRegions.it.sardegna']
    },
    'sicilia': {
      id: 'app.countryRegions.it.sicilia',
      defaultMessage: enDefaults['app.countryRegions.it.sicilia']
    },
    'toscana': {
      id: 'app.countryRegions.it.toscana',
      defaultMessage: enDefaults['app.countryRegions.it.toscana']
    },
    'trentino-alto-adige': {
      id: 'app.countryRegions.it.trentino-alto-adige',
      defaultMessage: enDefaults['app.countryRegions.it.trentino-alto-adige']
    },
    'umbria': {
      id: 'app.countryRegions.it.umbria',
      defaultMessage: enDefaults['app.countryRegions.it.umbria']
    },
    'valle-d-aosta': {
      id: 'app.countryRegions.it.valle-d-aosta',
      defaultMessage: enDefaults['app.countryRegions.it.valle-d-aosta']
    },
    'veneto': {
      id: 'app.countryRegions.it.veneto',
      defaultMessage: enDefaults['app.countryRegions.it.veneto']
    },
    northeast: {
      id: 'app.countryRegions.us.northeast',
      defaultMessage: enDefaults['app.countryRegions.us.northeast']
    },
    midatlantic: {
      id: 'app.countryRegions.us.midatlantic',
      defaultMessage: enDefaults['app.countryRegions.us.midatlantic']
    },
    greatlakes: {
      id: 'app.countryRegions.us.greatlakes',
      defaultMessage: enDefaults['app.countryRegions.us.greatlakes']
    },
    midwest: {
      id: 'app.countryRegions.us.midwest',
      defaultMessage: enDefaults['app.countryRegions.us.midwest']
    },
    southeast: {
      id: 'app.countryRegions.us.southeast',
      defaultMessage: enDefaults['app.countryRegions.us.southeast']
    },
    gulfcoast: {
      id: 'app.countryRegions.us.gulfcoast',
      defaultMessage: enDefaults['app.countryRegions.us.gulfcoast']
    },
    southwest: {
      id: 'app.countryRegions.us.southwest',
      defaultMessage: enDefaults['app.countryRegions.us.southwest']
    },
    west: {
      id: 'app.countryRegions.us.west',
      defaultMessage: enDefaults['app.countryRegions.us.west']
    },
    pacificnorthwest: {
      id: 'app.countryRegions.us.pacificnorthwest',
      defaultMessage: enDefaults['app.countryRegions.us.pacificnorthwest']
    },
    heartland: {
      id: 'app.countryRegions.us.heartland',
      defaultMessage: enDefaults['app.countryRegions.us.heartland']
    }
  },
  worldRegions: {
    africa: {
      id: 'app.worldRegions.africa',
      defaultMessage: enDefaults['app.worldRegions.africa']
    },
    asia: {
      id: 'app.worldRegions.asia',
      defaultMessage: enDefaults['app.worldRegions.asia']
    },
    europe: {
      id: 'app.worldRegions.europe',
      defaultMessage: enDefaults['app.worldRegions.europe']
    },
    northamerica: {
      id: 'app.worldRegions.northamerica',
      defaultMessage: enDefaults['app.worldRegions.northamerica']
    },
    oceania: {
      id: 'app.worldRegions.oceania',
      defaultMessage: enDefaults['app.worldRegions.oceania']
    },
    southamerica: {
      id: 'app.worldRegions.southamerica',
      defaultMessage: enDefaults['app.worldRegions.southamerica']
    }
  },
  countries: {
    'US': {
      id: 'app.countries.US',
      defaultMessage: enDefaults['app.countries.US']
    },
    'CA': {
      id: 'app.countries.CA',
      defaultMessage: enDefaults['app.countries.CA']
    },
    'GB': {
      id: 'app.countries.GB',
      defaultMessage: enDefaults['app.countries.GB']
    },
    'ES': {
      id: 'app.countries.ES',
      defaultMessage: enDefaults['app.countries.ES']
    },
    'FR': {
      id: 'app.countries.FR',
      defaultMessage: enDefaults['app.countries.FR']
    },
    'IT': {
      id: 'app.countries.IT',
      defaultMessage: enDefaults['app.countries.IT']
    },
    'AF': {
      id: 'app.countries.AF',
      defaultMessage: enDefaults['app.countries.AF']
    },
    'AX': {
      id: 'app.countries.AX',
      defaultMessage: enDefaults['app.countries.AX']
    },
    'AL': {
      id: 'app.countries.AL',
      defaultMessage: enDefaults['app.countries.AL']
    },
    'DZ': {
      id: 'app.countries.DZ',
      defaultMessage: enDefaults['app.countries.DZ']
    },
    'AS': {
      id: 'app.countries.AS',
      defaultMessage: enDefaults['app.countries.AS']
    },
    'AD': {
      id: 'app.countries.AD',
      defaultMessage: enDefaults['app.countries.AD']
    },
    'AO': {
      id: 'app.countries.AO',
      defaultMessage: enDefaults['app.countries.AO']
    },
    'AI': {
      id: 'app.countries.AI',
      defaultMessage: enDefaults['app.countries.AI']
    },
    'AQ': {
      id: 'app.countries.AQ',
      defaultMessage: enDefaults['app.countries.AQ']
    },
    'AG': {
      id: 'app.countries.AG',
      defaultMessage: enDefaults['app.countries.AG']
    },
    'AR': {
      id: 'app.countries.AR',
      defaultMessage: enDefaults['app.countries.AR']
    },
    'AM': {
      id: 'app.countries.AM',
      defaultMessage: enDefaults['app.countries.AM']
    },
    'AW': {
      id: 'app.countries.AW',
      defaultMessage: enDefaults['app.countries.AW']
    },
    'AU': {
      id: 'app.countries.AU',
      defaultMessage: enDefaults['app.countries.AU']
    },
    'AT': {
      id: 'app.countries.AT',
      defaultMessage: enDefaults['app.countries.AT']
    },
    'AZ': {
      id: 'app.countries.AZ',
      defaultMessage: enDefaults['app.countries.AZ']
    },
    'BS': {
      id: 'app.countries.BS',
      defaultMessage: enDefaults['app.countries.BS']
    },
    'BH': {
      id: 'app.countries.BH',
      defaultMessage: enDefaults['app.countries.BH']
    },
    'BD': {
      id: 'app.countries.BD',
      defaultMessage: enDefaults['app.countries.BD']
    },
    'BB': {
      id: 'app.countries.BB',
      defaultMessage: enDefaults['app.countries.BB']
    },
    'BY': {
      id: 'app.countries.BY',
      defaultMessage: enDefaults['app.countries.BY']
    },
    'BE': {
      id: 'app.countries.BE',
      defaultMessage: enDefaults['app.countries.BE']
    },
    'BZ': {
      id: 'app.countries.BZ',
      defaultMessage: enDefaults['app.countries.BZ']
    },
    'BJ': {
      id: 'app.countries.BJ',
      defaultMessage: enDefaults['app.countries.BJ']
    },
    'BM': {
      id: 'app.countries.BM',
      defaultMessage: enDefaults['app.countries.BM']
    },
    'BT': {
      id: 'app.countries.BT',
      defaultMessage: enDefaults['app.countries.BT']
    },
    'BO': {
      id: 'app.countries.BO',
      defaultMessage: enDefaults['app.countries.BO']
    },
    'BQ': {
      id: 'app.countries.BQ',
      defaultMessage: enDefaults['app.countries.BQ']
    },
    'BA': {
      id: 'app.countries.BA',
      defaultMessage: enDefaults['app.countries.BA']
    },
    'BW': {
      id: 'app.countries.BW',
      defaultMessage: enDefaults['app.countries.BW']
    },
    'BV': {
      id: 'app.countries.BV',
      defaultMessage: enDefaults['app.countries.BV']
    },
    'BR': {
      id: 'app.countries.BR',
      defaultMessage: enDefaults['app.countries.BR']
    },
    'IO': {
      id: 'app.countries.IO',
      defaultMessage: enDefaults['app.countries.IO']
    },
    'BN': {
      id: 'app.countries.BN',
      defaultMessage: enDefaults['app.countries.BN']
    },
    'BG': {
      id: 'app.countries.BG',
      defaultMessage: enDefaults['app.countries.BG']
    },
    'BF': {
      id: 'app.countries.BF',
      defaultMessage: enDefaults['app.countries.BF']
    },
    'BI': {
      id: 'app.countries.BI',
      defaultMessage: enDefaults['app.countries.BI']
    },
    'KH': {
      id: 'app.countries.KH',
      defaultMessage: enDefaults['app.countries.KH']
    },
    'CM': {
      id: 'app.countries.CM',
      defaultMessage: enDefaults['app.countries.CM']
    },
    'CV': {
      id: 'app.countries.CV',
      defaultMessage: enDefaults['app.countries.CV']
    },
    'KY': {
      id: 'app.countries.KY',
      defaultMessage: enDefaults['app.countries.KY']
    },
    'CF': {
      id: 'app.countries.CF',
      defaultMessage: enDefaults['app.countries.CF']
    },
    'TD': {
      id: 'app.countries.TD',
      defaultMessage: enDefaults['app.countries.TD']
    },
    'CL': {
      id: 'app.countries.CL',
      defaultMessage: enDefaults['app.countries.CL']
    },
    'CN': {
      id: 'app.countries.CN',
      defaultMessage: enDefaults['app.countries.CN']
    },
    'CX': {
      id: 'app.countries.CX',
      defaultMessage: enDefaults['app.countries.CX']
    },
    'CC': {
      id: 'app.countries.CC',
      defaultMessage: enDefaults['app.countries.CC']
    },
    'CO': {
      id: 'app.countries.CO',
      defaultMessage: enDefaults['app.countries.CO']
    },
    'KM': {
      id: 'app.countries.KM',
      defaultMessage: enDefaults['app.countries.KM']
    },
    'CG': {
      id: 'app.countries.CG',
      defaultMessage: enDefaults['app.countries.CG']
    },
    'CK': {
      id: 'app.countries.CK',
      defaultMessage: enDefaults['app.countries.CK']
    },
    'CR': {
      id: 'app.countries.CR',
      defaultMessage: enDefaults['app.countries.CR']
    },
    'CI': {
      id: 'app.countries.CI',
      defaultMessage: enDefaults['app.countries.CI']
    },
    'HR': {
      id: 'app.countries.HR',
      defaultMessage: enDefaults['app.countries.HR']
    },
    'CU': {
      id: 'app.countries.CU',
      defaultMessage: enDefaults['app.countries.CU']
    },
    'CW': {
      id: 'app.countries.CW',
      defaultMessage: enDefaults['app.countries.CW']
    },
    'CY': {
      id: 'app.countries.CY',
      defaultMessage: enDefaults['app.countries.CY']
    },
    'CZ': {
      id: 'app.countries.CZ',
      defaultMessage: enDefaults['app.countries.CZ']
    },
    'DK': {
      id: 'app.countries.DK',
      defaultMessage: enDefaults['app.countries.DK']
    },
    'DJ': {
      id: 'app.countries.DJ',
      defaultMessage: enDefaults['app.countries.DJ']
    },
    'DM': {
      id: 'app.countries.DM',
      defaultMessage: enDefaults['app.countries.DM']
    },
    'DO': {
      id: 'app.countries.DO',
      defaultMessage: enDefaults['app.countries.DO']
    },
    'EC': {
      id: 'app.countries.EC',
      defaultMessage: enDefaults['app.countries.EC']
    },
    'EG': {
      id: 'app.countries.EG',
      defaultMessage: enDefaults['app.countries.EG']
    },
    'SV': {
      id: 'app.countries.SV',
      defaultMessage: enDefaults['app.countries.SV']
    },
    'GQ': {
      id: 'app.countries.GQ',
      defaultMessage: enDefaults['app.countries.GQ']
    },
    'ER': {
      id: 'app.countries.ER',
      defaultMessage: enDefaults['app.countries.ER']
    },
    'EE': {
      id: 'app.countries.EE',
      defaultMessage: enDefaults['app.countries.EE']
    },
    'ET': {
      id: 'app.countries.ET',
      defaultMessage: enDefaults['app.countries.ET']
    },
    'FK': {
      id: 'app.countries.FK',
      defaultMessage: enDefaults['app.countries.FK']
    },
    'FO': {
      id: 'app.countries.FO',
      defaultMessage: enDefaults['app.countries.FO']
    },
    'FJ': {
      id: 'app.countries.FJ',
      defaultMessage: enDefaults['app.countries.FJ']
    },
    'FI': {
      id: 'app.countries.FI',
      defaultMessage: enDefaults['app.countries.FI']
    },
    'GF': {
      id: 'app.countries.GF',
      defaultMessage: enDefaults['app.countries.GF']
    },
    'PF': {
      id: 'app.countries.PF',
      defaultMessage: enDefaults['app.countries.PF']
    },
    'TF': {
      id: 'app.countries.TF',
      defaultMessage: enDefaults['app.countries.TF']
    },
    'GA': {
      id: 'app.countries.GA',
      defaultMessage: enDefaults['app.countries.GA']
    },
    'GM': {
      id: 'app.countries.GM',
      defaultMessage: enDefaults['app.countries.GM']
    },
    'GE': {
      id: 'app.countries.GE',
      defaultMessage: enDefaults['app.countries.GE']
    },
    'DE': {
      id: 'app.countries.DE',
      defaultMessage: enDefaults['app.countries.DE']
    },
    'GH': {
      id: 'app.countries.GH',
      defaultMessage: enDefaults['app.countries.GH']
    },
    'GI': {
      id: 'app.countries.GI',
      defaultMessage: enDefaults['app.countries.GI']
    },
    'GR': {
      id: 'app.countries.GR',
      defaultMessage: enDefaults['app.countries.GR']
    },
    'GL': {
      id: 'app.countries.GL',
      defaultMessage: enDefaults['app.countries.GL']
    },
    'GD': {
      id: 'app.countries.GD',
      defaultMessage: enDefaults['app.countries.GD']
    },
    'GP': {
      id: 'app.countries.GP',
      defaultMessage: enDefaults['app.countries.GP']
    },
    'GU': {
      id: 'app.countries.GU',
      defaultMessage: enDefaults['app.countries.GU']
    },
    'GT': {
      id: 'app.countries.GT',
      defaultMessage: enDefaults['app.countries.GT']
    },
    'GG': {
      id: 'app.countries.GG',
      defaultMessage: enDefaults['app.countries.GG']
    },
    'GN': {
      id: 'app.countries.GN',
      defaultMessage: enDefaults['app.countries.GN']
    },
    'GW': {
      id: 'app.countries.GW',
      defaultMessage: enDefaults['app.countries.GW']
    },
    'GY': {
      id: 'app.countries.GY',
      defaultMessage: enDefaults['app.countries.GY']
    },
    'HT': {
      id: 'app.countries.HT',
      defaultMessage: enDefaults['app.countries.HT']
    },
    'HM': {
      id: 'app.countries.HM',
      defaultMessage: enDefaults['app.countries.HM']
    },
    'VA': {
      id: 'app.countries.VA',
      defaultMessage: enDefaults['app.countries.VA']
    },
    'HN': {
      id: 'app.countries.HN',
      defaultMessage: enDefaults['app.countries.HN']
    },
    'HK': {
      id: 'app.countries.HK',
      defaultMessage: enDefaults['app.countries.HK']
    },
    'HU': {
      id: 'app.countries.HU',
      defaultMessage: enDefaults['app.countries.HU']
    },
    'IS': {
      id: 'app.countries.IS',
      defaultMessage: enDefaults['app.countries.IS']
    },
    'IN': {
      id: 'app.countries.IN',
      defaultMessage: enDefaults['app.countries.IN']
    },
    'ID': {
      id: 'app.countries.ID',
      defaultMessage: enDefaults['app.countries.ID']
    },
    'IR': {
      id: 'app.countries.IR',
      defaultMessage: enDefaults['app.countries.IR']
    },
    'IQ': {
      id: 'app.countries.IQ',
      defaultMessage: enDefaults['app.countries.IQ']
    },
    'IE': {
      id: 'app.countries.IE',
      defaultMessage: enDefaults['app.countries.IE']
    },
    'IM': {
      id: 'app.countries.IM',
      defaultMessage: enDefaults['app.countries.IM']
    },
    'IL': {
      id: 'app.countries.IL',
      defaultMessage: enDefaults['app.countries.IL']
    },
    'JM': {
      id: 'app.countries.JM',
      defaultMessage: enDefaults['app.countries.JM']
    },
    'JP': {
      id: 'app.countries.JP',
      defaultMessage: enDefaults['app.countries.JP']
    },
    'JE': {
      id: 'app.countries.JE',
      defaultMessage: enDefaults['app.countries.JE']
    },
    'JO': {
      id: 'app.countries.JO',
      defaultMessage: enDefaults['app.countries.JO']
    },
    'KZ': {
      id: 'app.countries.KZ',
      defaultMessage: enDefaults['app.countries.KZ']
    },
    'KE': {
      id: 'app.countries.KE',
      defaultMessage: enDefaults['app.countries.KE']
    },
    'KI': {
      id: 'app.countries.KI',
      defaultMessage: enDefaults['app.countries.KI']
    },
    'KP': {
      id: 'app.countries.KP',
      defaultMessage: enDefaults['app.countries.KP']
    },
    'KR': {
      id: 'app.countries.KR',
      defaultMessage: enDefaults['app.countries.KR']
    },
    'KW': {
      id: 'app.countries.KW',
      defaultMessage: enDefaults['app.countries.KW']
    },
    'KG': {
      id: 'app.countries.KG',
      defaultMessage: enDefaults['app.countries.KG']
    },
    'LA': {
      id: 'app.countries.LA',
      defaultMessage: enDefaults['app.countries.LA']
    },
    'LV': {
      id: 'app.countries.LV',
      defaultMessage: enDefaults['app.countries.LV']
    },
    'LB': {
      id: 'app.countries.LB',
      defaultMessage: enDefaults['app.countries.LB']
    },
    'LS': {
      id: 'app.countries.LS',
      defaultMessage: enDefaults['app.countries.LS']
    },
    'LR': {
      id: 'app.countries.LR',
      defaultMessage: enDefaults['app.countries.LR']
    },
    'LY': {
      id: 'app.countries.LY',
      defaultMessage: enDefaults['app.countries.LY']
    },
    'LI': {
      id: 'app.countries.LI',
      defaultMessage: enDefaults['app.countries.LI']
    },
    'LT': {
      id: 'app.countries.LT',
      defaultMessage: enDefaults['app.countries.LT']
    },
    'LU': {
      id: 'app.countries.LU',
      defaultMessage: enDefaults['app.countries.LU']
    },
    'MO': {
      id: 'app.countries.MO',
      defaultMessage: enDefaults['app.countries.MO']
    },
    'MK': {
      id: 'app.countries.MK',
      defaultMessage: enDefaults['app.countries.MK']
    },
    'MG': {
      id: 'app.countries.MG',
      defaultMessage: enDefaults['app.countries.MG']
    },
    'MW': {
      id: 'app.countries.MW',
      defaultMessage: enDefaults['app.countries.MW']
    },
    'MY': {
      id: 'app.countries.MY',
      defaultMessage: enDefaults['app.countries.MY']
    },
    'MV': {
      id: 'app.countries.MV',
      defaultMessage: enDefaults['app.countries.MV']
    },
    'ML': {
      id: 'app.countries.ML',
      defaultMessage: enDefaults['app.countries.ML']
    },
    'MT': {
      id: 'app.countries.MT',
      defaultMessage: enDefaults['app.countries.MT']
    },
    'MH': {
      id: 'app.countries.MH',
      defaultMessage: enDefaults['app.countries.MH']
    },
    'MQ': {
      id: 'app.countries.MQ',
      defaultMessage: enDefaults['app.countries.MQ']
    },
    'MR': {
      id: 'app.countries.MR',
      defaultMessage: enDefaults['app.countries.MR']
    },
    'MU': {
      id: 'app.countries.MU',
      defaultMessage: enDefaults['app.countries.MU']
    },
    'YT': {
      id: 'app.countries.YT',
      defaultMessage: enDefaults['app.countries.YT']
    },
    'MX': {
      id: 'app.countries.MX',
      defaultMessage: enDefaults['app.countries.MX']
    },
    'FM': {
      id: 'app.countries.FM',
      defaultMessage: enDefaults['app.countries.FM']
    },
    'MD': {
      id: 'app.countries.MD',
      defaultMessage: enDefaults['app.countries.MD']
    },
    'MC': {
      id: 'app.countries.MC',
      defaultMessage: enDefaults['app.countries.MC']
    },
    'MN': {
      id: 'app.countries.MN',
      defaultMessage: enDefaults['app.countries.MN']
    },
    'ME': {
      id: 'app.countries.ME',
      defaultMessage: enDefaults['app.countries.ME']
    },
    'MS': {
      id: 'app.countries.MS',
      defaultMessage: enDefaults['app.countries.MS']
    },
    'MA': {
      id: 'app.countries.MA',
      defaultMessage: enDefaults['app.countries.MA']
    },
    'MZ': {
      id: 'app.countries.MZ',
      defaultMessage: enDefaults['app.countries.MZ']
    },
    'MM': {
      id: 'app.countries.MM',
      defaultMessage: enDefaults['app.countries.MM']
    },
    'NA': {
      id: 'app.countries.NA',
      defaultMessage: enDefaults['app.countries.NA']
    },
    'NR': {
      id: 'app.countries.NR',
      defaultMessage: enDefaults['app.countries.NR']
    },
    'NP': {
      id: 'app.countries.NP',
      defaultMessage: enDefaults['app.countries.NP']
    },
    'NL': {
      id: 'app.countries.NL',
      defaultMessage: enDefaults['app.countries.NL']
    },
    'AN': {
      id: 'app.countries.AN',
      defaultMessage: enDefaults['app.countries.AN']
    },
    'NC': {
      id: 'app.countries.NC',
      defaultMessage: enDefaults['app.countries.NC']
    },
    'NZ': {
      id: 'app.countries.NZ',
      defaultMessage: enDefaults['app.countries.NZ']
    },
    'NI': {
      id: 'app.countries.NI',
      defaultMessage: enDefaults['app.countries.NI']
    },
    'NE': {
      id: 'app.countries.NE',
      defaultMessage: enDefaults['app.countries.NE']
    },
    'NG': {
      id: 'app.countries.NG',
      defaultMessage: enDefaults['app.countries.NG']
    },
    'NU': {
      id: 'app.countries.NU',
      defaultMessage: enDefaults['app.countries.NU']
    },
    'NF': {
      id: 'app.countries.NF',
      defaultMessage: enDefaults['app.countries.NF']
    },
    'MP': {
      id: 'app.countries.MP',
      defaultMessage: enDefaults['app.countries.MP']
    },
    'NO': {
      id: 'app.countries.NO',
      defaultMessage: enDefaults['app.countries.NO']
    },
    'OM': {
      id: 'app.countries.OM',
      defaultMessage: enDefaults['app.countries.OM']
    },
    'PK': {
      id: 'app.countries.PK',
      defaultMessage: enDefaults['app.countries.PK']
    },
    'PW': {
      id: 'app.countries.PW',
      defaultMessage: enDefaults['app.countries.PW']
    },
    'PS': {
      id: 'app.countries.PS',
      defaultMessage: enDefaults['app.countries.PS']
    },
    'PA': {
      id: 'app.countries.PA',
      defaultMessage: enDefaults['app.countries.PA']
    },
    'PG': {
      id: 'app.countries.PG',
      defaultMessage: enDefaults['app.countries.PG']
    },
    'PY': {
      id: 'app.countries.PY',
      defaultMessage: enDefaults['app.countries.PY']
    },
    'PE': {
      id: 'app.countries.PE',
      defaultMessage: enDefaults['app.countries.PE']
    },
    'PH': {
      id: 'app.countries.PH',
      defaultMessage: enDefaults['app.countries.PH']
    },
    'PN': {
      id: 'app.countries.PN',
      defaultMessage: enDefaults['app.countries.PN']
    },
    'PL': {
      id: 'app.countries.PL',
      defaultMessage: enDefaults['app.countries.PL']
    },
    'PT': {
      id: 'app.countries.PT',
      defaultMessage: enDefaults['app.countries.PT']
    },
    'PR': {
      id: 'app.countries.PR',
      defaultMessage: enDefaults['app.countries.PR']
    },
    'QA': {
      id: 'app.countries.QA',
      defaultMessage: enDefaults['app.countries.QA']
    },
    'RE': {
      id: 'app.countries.RE',
      defaultMessage: enDefaults['app.countries.RE']
    },
    'RO': {
      id: 'app.countries.RO',
      defaultMessage: enDefaults['app.countries.RO']
    },
    'RW': {
      id: 'app.countries.RW',
      defaultMessage: enDefaults['app.countries.RW']
    },
    'BL': {
      id: 'app.countries.BL',
      defaultMessage: enDefaults['app.countries.BL']
    },
    'SH': {
      id: 'app.countries.SH',
      defaultMessage: enDefaults['app.countries.SH']
    },
    'LC': {
      id: 'app.countries.LC',
      defaultMessage: enDefaults['app.countries.LC']
    },
    'MF': {
      id: 'app.countries.MF',
      defaultMessage: enDefaults['app.countries.MF']
    },
    'SM': {
      id: 'app.countries.SM',
      defaultMessage: enDefaults['app.countries.SM']
    },
    'ST': {
      id: 'app.countries.ST',
      defaultMessage: enDefaults['app.countries.ST']
    },
    'SA': {
      id: 'app.countries.SA',
      defaultMessage: enDefaults['app.countries.SA']
    },
    'SN': {
      id: 'app.countries.SN',
      defaultMessage: enDefaults['app.countries.SN']
    },
    'RS': {
      id: 'app.countries.RS',
      defaultMessage: enDefaults['app.countries.RS']
    },
    'SC': {
      id: 'app.countries.SC',
      defaultMessage: enDefaults['app.countries.SC']
    },
    'SL': {
      id: 'app.countries.SL',
      defaultMessage: enDefaults['app.countries.SL']
    },
    'SG': {
      id: 'app.countries.SG',
      defaultMessage: enDefaults['app.countries.SG']
    },
    'SX': {
      id: 'app.countries.SX',
      defaultMessage: enDefaults['app.countries.SX']
    },
    'SK': {
      id: 'app.countries.SK',
      defaultMessage: enDefaults['app.countries.SK']
    },
    'SI': {
      id: 'app.countries.SI',
      defaultMessage: enDefaults['app.countries.SI']
    },
    'SB': {
      id: 'app.countries.SB',
      defaultMessage: enDefaults['app.countries.SB']
    },
    'SO': {
      id: 'app.countries.SO',
      defaultMessage: enDefaults['app.countries.SO']
    },
    'ZA': {
      id: 'app.countries.ZA',
      defaultMessage: enDefaults['app.countries.ZA']
    },
    'GS': {
      id: 'app.countries.GS',
      defaultMessage: enDefaults['app.countries.GS']
    },
    'SS': {
      id: 'app.countries.SS',
      defaultMessage: enDefaults['app.countries.SS']
    },
    'LK': {
      id: 'app.countries.LK',
      defaultMessage: enDefaults['app.countries.LK']
    },
    'KN': {
      id: 'app.countries.KN',
      defaultMessage: enDefaults['app.countries.KN']
    },
    'PM': {
      id: 'app.countries.PM',
      defaultMessage: enDefaults['app.countries.PM']
    },
    'VC': {
      id: 'app.countries.VC',
      defaultMessage: enDefaults['app.countries.VC']
    },
    'SD': {
      id: 'app.countries.SD',
      defaultMessage: enDefaults['app.countries.SD']
    },
    'SR': {
      id: 'app.countries.SR',
      defaultMessage: enDefaults['app.countries.SR']
    },
    'SJ': {
      id: 'app.countries.SJ',
      defaultMessage: enDefaults['app.countries.SJ']
    },
    'SZ': {
      id: 'app.countries.SZ',
      defaultMessage: enDefaults['app.countries.SZ']
    },
    'SE': {
      id: 'app.countries.SE',
      defaultMessage: enDefaults['app.countries.SE']
    },
    'CH': {
      id: 'app.countries.CH',
      defaultMessage: enDefaults['app.countries.CH']
    },
    'SY': {
      id: 'app.countries.SY',
      defaultMessage: enDefaults['app.countries.SY']
    },
    'TW': {
      id: 'app.countries.TW',
      defaultMessage: enDefaults['app.countries.TW']
    },
    'TJ': {
      id: 'app.countries.TJ',
      defaultMessage: enDefaults['app.countries.TJ']
    },
    'TZ': {
      id: 'app.countries.TZ',
      defaultMessage: enDefaults['app.countries.TZ']
    },
    'TH': {
      id: 'app.countries.TH',
      defaultMessage: enDefaults['app.countries.TH']
    },
    'TL': {
      id: 'app.countries.TL',
      defaultMessage: enDefaults['app.countries.TL']
    },
    'TG': {
      id: 'app.countries.TG',
      defaultMessage: enDefaults['app.countries.TG']
    },
    'TK': {
      id: 'app.countries.TK',
      defaultMessage: enDefaults['app.countries.TK']
    },
    'TO': {
      id: 'app.countries.TO',
      defaultMessage: enDefaults['app.countries.TO']
    },
    'TT': {
      id: 'app.countries.TT',
      defaultMessage: enDefaults['app.countries.TT']
    },
    'TN': {
      id: 'app.countries.TN',
      defaultMessage: enDefaults['app.countries.TN']
    },
    'TR': {
      id: 'app.countries.TR',
      defaultMessage: enDefaults['app.countries.TR']
    },
    'TM': {
      id: 'app.countries.TM',
      defaultMessage: enDefaults['app.countries.TM']
    },
    'TC': {
      id: 'app.countries.TC',
      defaultMessage: enDefaults['app.countries.TC']
    },
    'TV': {
      id: 'app.countries.TV',
      defaultMessage: enDefaults['app.countries.TV']
    },
    'UG': {
      id: 'app.countries.UG',
      defaultMessage: enDefaults['app.countries.UG']
    },
    'UK': {
      id: 'app.countries.UK',
      defaultMessage: enDefaults['app.countries.UK']
    },
    'UA': {
      id: 'app.countries.UA',
      defaultMessage: enDefaults['app.countries.UA']
    },
    'UM': {
      id: 'app.countries.UM',
      defaultMessage: enDefaults['app.countries.UM']
    },
    'AE': {
      id: 'app.countries.AE',
      defaultMessage: enDefaults['app.countries.AE']
    },
    'UY': {
      id: 'app.countries.UY',
      defaultMessage: enDefaults['app.countries.UY']
    },
    'UZ': {
      id: 'app.countries.UZ',
      defaultMessage: enDefaults['app.countries.UZ']
    },
    'VU': {
      id: 'app.countries.VU',
      defaultMessage: enDefaults['app.countries.VU']
    },
    'VE': {
      id: 'app.countries.VE',
      defaultMessage: enDefaults['app.countries.VE']
    },
    'VN': {
      id: 'app.countries.VN',
      defaultMessage: enDefaults['app.countries.VN']
    },
    'VG': {
      id: 'app.countries.VG',
      defaultMessage: enDefaults['app.countries.VG']
    },
    'VI': {
      id: 'app.countries.VI',
      defaultMessage: enDefaults['app.countries.VI']
    },
    'WF': {
      id: 'app.countries.WF',
      defaultMessage: enDefaults['app.countries.WF']
    },
    'EH': {
      id: 'app.countries.EH',
      defaultMessage: enDefaults['app.countries.EH']
    },
    'WS': {
      id: 'app.countries.WS',
      defaultMessage: enDefaults['app.countries.WS']
    },
    'YE': {
      id: 'app.countries.YE',
      defaultMessage: enDefaults['app.countries.YE']
    },
    'CD': {
      id: 'app.countries.CD',
      defaultMessage: enDefaults['app.countries.CD']
    },
    'ZM': {
      id: 'app.countries.ZM',
      defaultMessage: enDefaults['app.countries.ZM']
    },
    'ZW': {
      id: 'app.countries.ZW',
      defaultMessage: enDefaults['app.countries.ZW']
    }
  },
  pricing: {
    request: {
      id: 'app.pricing.request',
      defaultMessage: enDefaults['app.pricing.request']
    }
  },
  boatDetails: {
    title: {
      id: 'app.boatDetails.title',
      defaultMessage: enDefaults['app.boatDetails.title']
    },
    localDelivery: {
      label: {
        id: 'app.boatDetails.localDelivery.label',
        defaultMessage: enDefaults['app.boatDetails.localDelivery.label']
      }
    },
    notForSaleInUSWaters: {
      id: 'app.boatDetails.notForSaleInUSWaters',
      defaultMessage: enDefaults['app.boatDetails.notForSaleInUSWaters']
    },
    loans: {
      id: 'app.boatDetails.loans',
      defaultMessage: enDefaults['app.boatDetails.loans']
    },
    calculator: {
      id: 'app.boatDetails.calculator',
      defaultMessage: enDefaults['app.boatDetails.calculator']
    },
    priceDrop: {
      id: 'app.boatDetails.pricedrop.label',
      defaultMessage: enDefaults['app.boatDetails.pricedrop.label']
    },
    monthlyPrice: {
      id: 'app.boatDetails.monthlyPrice.label',
      defaultMessage: enDefaults['app.boatDetails.monthlyPrice.label']
    },
    getPreQualified: {
      id: 'app.boatDetails.getPreQualified.label',
      defaultMessage: enDefaults['app.boatDetails.getPreQualified.label']
    },
    summary: {
      engineHoursText: {
        id: 'app.boatDetails.summary.engineHoursText',
        defaultMessage: enDefaults['app.boatDetails.summary.engineHoursText']
      },
      linkText: {
        id: 'app.boatDetails.summary.linkText',
        defaultMessage: enDefaults['app.boatDetails.summary.linkText']
      },
      paymentText: {
        id: 'app.boatDetails.summary.paymentText',
        defaultMessage: enDefaults['app.boatDetails.summary.paymentText']
      },
      tooltipText: {
        id: 'app.boatDetails.summary.tooltipText',
        defaultMessage: enDefaults['app.boatDetails.summary.tooltipText']
      }
    },
    friendlyFeatureName: {
      customContactInformation: {
        id: 'app.boatDetails.friendlyFeatureName.customContactInformation',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.customContactInformation'
          ]
      },
      'electrical-equipment': {
        id: 'app.boatDetails.friendlyFeatureName.electrical-equipment',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.electrical-equipment']
      },
      inverter: {
        id: 'app.boatDetails.friendlyFeatureName.inverter',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.inverter']
      },
      'shore-power-inlet': {
        id: 'app.boatDetails.friendlyFeatureName.shore-power-inlet',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.shore-power-inlet']
      },
      generator: {
        id: 'app.boatDetails.friendlyFeatureName.generator',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.generator']
      },
      electronics: {
        id: 'app.boatDetails.friendlyFeatureName.electronics',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.electronics']
      },
      'cockpit-speakers': {
        id: 'app.boatDetails.friendlyFeatureName.cockpit-speakers',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cockpit-speakers']
      },
      depthsounder: {
        id: 'app.boatDetails.friendlyFeatureName.depthsounder',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.depthsounder']
      },
      computer: {
        id: 'app.boatDetails.friendlyFeatureName.computer',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.computer']
      },
      radio: {
        id: 'app.boatDetails.friendlyFeatureName.radio',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.radio']
      },
      'log-speedometer': {
        id: 'app.boatDetails.friendlyFeatureName.log-speedometer',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.log-speedometer']
      },
      'navigation-center': {
        id: 'app.boatDetails.friendlyFeatureName.navigation-center',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.navigation-center']
      },
      vcr: {
        id: 'app.boatDetails.friendlyFeatureName.vcr',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.vcr']
      },
      vhf: {
        id: 'app.boatDetails.friendlyFeatureName.vhf',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.vhf']
      },
      autopilot: {
        id: 'app.boatDetails.friendlyFeatureName.autopilot',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.autopilot']
      },
      'wind-speed-and-direction': {
        id: 'app.boatDetails.friendlyFeatureName.wind-speed-and-direction',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.wind-speed-and-direction'
          ]
      },
      compass: {
        id: 'app.boatDetails.friendlyFeatureName.compass',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.compass']
      },
      gps: {
        id: 'app.boatDetails.friendlyFeatureName.gps',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.gps']
      },
      'radar-detector': {
        id: 'app.boatDetails.friendlyFeatureName.radar-detector',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.radar-detector']
      },
      'cd-player': {
        id: 'app.boatDetails.friendlyFeatureName.cd-player',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cd-player']
      },
      radar: {
        id: 'app.boatDetails.friendlyFeatureName.radar',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.radar']
      },
      repeater: {
        id: 'app.boatDetails.friendlyFeatureName.repeater',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.repeater']
      },
      'tv-set': {
        id: 'app.boatDetails.friendlyFeatureName.tv-set',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.tv-set']
      },
      'dvd-player': {
        id: 'app.boatDetails.friendlyFeatureName.dvd-player',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.dvd-player']
      },
      plotter: {
        id: 'app.boatDetails.friendlyFeatureName.plotter',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.plotter']
      },
      covers: {
        id: 'app.boatDetails.friendlyFeatureName.covers',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.covers']
      },
      'cockpit-cover': {
        id: 'app.boatDetails.friendlyFeatureName.cockpit-cover',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cockpit-cover']
      },
      'spray-hood': {
        id: 'app.boatDetails.friendlyFeatureName.spray-hood',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.spray-hood']
      },
      'lazy-bag': {
        id: 'app.boatDetails.friendlyFeatureName.lazy-bag',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.lazy-bag']
      },
      lazyjacks: {
        id: 'app.boatDetails.friendlyFeatureName.lazyjacks',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.lazyjacks']
      },
      'mainsail-cover': {
        id: 'app.boatDetails.friendlyFeatureName.mainsail-cover',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.mainsail-cover']
      },
      'genoa-cover': {
        id: 'app.boatDetails.friendlyFeatureName.genoa-cover',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.genoa-cover']
      },
      'bimini-top': {
        id: 'app.boatDetails.friendlyFeatureName.bimini-top',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.bimini-top']
      },
      'additional-equipment': {
        id: 'app.boatDetails.friendlyFeatureName.additional-equipment',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.additional-equipment']
      },
      'launching-trailer': {
        id: 'app.boatDetails.friendlyFeatureName.launching-trailer',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.launching-trailer']
      },
      'beaching-legs': {
        id: 'app.boatDetails.friendlyFeatureName.beaching-legs',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.beaching-legs']
      },
      'road-trailer': {
        id: 'app.boatDetails.friendlyFeatureName.road-trailer',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.road-trailer']
      },
      'outside-equipment-extras': {
        id: 'app.boatDetails.friendlyFeatureName.outside-equipment-extras',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.outside-equipment-extras'
          ]
      },
      'teak-cockpit': {
        id: 'app.boatDetails.friendlyFeatureName.teak-cockpit',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.teak-cockpit']
      },
      'cockpit-shower': {
        id: 'app.boatDetails.friendlyFeatureName.cockpit-shower',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cockpit-shower']
      },
      gangway: {
        id: 'app.boatDetails.friendlyFeatureName.gangway',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.gangway']
      },
      'cockpit-table': {
        id: 'app.boatDetails.friendlyFeatureName.cockpit-table',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cockpit-table']
      },
      'teak-sidedecks': {
        id: 'app.boatDetails.friendlyFeatureName.teak-sidedecks',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.teak-sidedecks']
      },
      tender: {
        id: 'app.boatDetails.friendlyFeatureName.tender',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.tender']
      },
      davits: {
        id: 'app.boatDetails.friendlyFeatureName.davits',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.davits']
      },
      liferaft: {
        id: 'app.boatDetails.friendlyFeatureName.liferaft',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.liferaft']
      },
      'swimming-ladder': {
        id: 'app.boatDetails.friendlyFeatureName.swimming-ladder',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.swimming-ladder']
      },
      'hydraulic-gangway': {
        id: 'app.boatDetails.friendlyFeatureName.hydraulic-gangway',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.hydraulic-gangway']
      },
      'wind-generator': {
        id: 'app.boatDetails.friendlyFeatureName.wind-generator',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.wind-generator']
      },
      'cockpit-cushions': {
        id: 'app.boatDetails.friendlyFeatureName.cockpit-cushions',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.cockpit-cushions']
      },
      'radar-reflector': {
        id: 'app.boatDetails.friendlyFeatureName.radar-reflector',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.radar-reflector']
      },
      'solar-panel': {
        id: 'app.boatDetails.friendlyFeatureName.solar-panel',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.solar-panel']
      },
      'outboard-engine-brackets': {
        id: 'app.boatDetails.friendlyFeatureName.outboard-engine-brackets',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.outboard-engine-brackets'
          ]
      },
      'inside-equipment': {
        id: 'app.boatDetails.friendlyFeatureName.inside-equipment',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.inside-equipment']
      },
      'battery-charger': {
        id: 'app.boatDetails.friendlyFeatureName.battery-charger',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.battery-charger']
      },
      'washing-machine': {
        id: 'app.boatDetails.friendlyFeatureName.washing-machine',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.washing-machine']
      },
      oven: {
        id: 'app.boatDetails.friendlyFeatureName.oven',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.oven']
      },
      'manual-bilge-pump': {
        id: 'app.boatDetails.friendlyFeatureName.manual-bilge-pump',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.manual-bilge-pump']
      },
      'electric-bilge-pump': {
        id: 'app.boatDetails.friendlyFeatureName.electric-bilge-pump',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.electric-bilge-pump']
      },
      'air-conditioning': {
        id: 'app.boatDetails.friendlyFeatureName.air-conditioning',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.air-conditioning']
      },
      'sea-water-pump': {
        id: 'app.boatDetails.friendlyFeatureName.sea-water-pump',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.sea-water-pump']
      },
      dishwasher: {
        id: 'app.boatDetails.friendlyFeatureName.dishwasher',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.dishwasher']
      },
      'air-compressor': {
        id: 'app.boatDetails.friendlyFeatureName.air-compressor',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.air-compressor']
      },
      'electric-head': {
        id: 'app.boatDetails.friendlyFeatureName.electric-head',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.electric-head']
      },
      refrigerator: {
        id: 'app.boatDetails.friendlyFeatureName.refrigerator',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.refrigerator']
      },
      'stern-thruster': {
        id: 'app.boatDetails.friendlyFeatureName.stern-thruster',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.stern-thruster']
      },
      'deep-freezer': {
        id: 'app.boatDetails.friendlyFeatureName.deep-freezer',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.deep-freezer']
      },
      'hot-water': {
        id: 'app.boatDetails.friendlyFeatureName.hot-water',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.hot-water']
      },
      'microwave-oven': {
        id: 'app.boatDetails.friendlyFeatureName.microwave-oven',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.microwave-oven']
      },
      'fresh-water-maker': {
        id: 'app.boatDetails.friendlyFeatureName.fresh-water-maker',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.fresh-water-maker']
      },
      'marine-head': {
        id: 'app.boatDetails.friendlyFeatureName.marine-head',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.marine-head']
      },
      'bow-thruster': {
        id: 'app.boatDetails.friendlyFeatureName.bow-thruster',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.bow-thruster']
      },
      heating: {
        id: 'app.boatDetails.friendlyFeatureName.heating',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.heating']
      },
      'chemical-head': {
        id: 'app.boatDetails.friendlyFeatureName.chemical-head',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.chemical-head']
      },
      rigging: {
        id: 'app.boatDetails.friendlyFeatureName.rigging',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.rigging']
      },
      'electric-winch': {
        id: 'app.boatDetails.friendlyFeatureName.electric-winch',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.electric-winch']
      },
      'hydraulic-winch': {
        id: 'app.boatDetails.friendlyFeatureName.hydraulic-winch',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.hydraulic-winch']
      },
      'spinnaker-pole': {
        id: 'app.boatDetails.friendlyFeatureName.spinnaker-pole',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.spinnaker-pole']
      },
      'steering-wheel': {
        id: 'app.boatDetails.friendlyFeatureName.steering-wheel',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.steering-wheel']
      },
      tiller: {
        id: 'app.boatDetails.friendlyFeatureName.tiller',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.tiller']
      },
      sails: {
        id: 'app.boatDetails.friendlyFeatureName.sails',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.sails']
      },
      'asymmetric-spinnaker': {
        id: 'app.boatDetails.friendlyFeatureName.asymmetric-spinnaker',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.asymmetric-spinnaker']
      },
      'battened-mainsail': {
        id: 'app.boatDetails.friendlyFeatureName.battened-mainsail',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.battened-mainsail']
      },
      'fully-battened-mainsail': {
        id: 'app.boatDetails.friendlyFeatureName.fully-battened-mainsail',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.fully-battened-mainsail'
          ]
      },
      'furling-genoa': {
        id: 'app.boatDetails.friendlyFeatureName.furling-genoa',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.furling-genoa']
      },
      'furling-mainsail': {
        id: 'app.boatDetails.friendlyFeatureName.furling-mainsail',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.furling-mainsail']
      },
      'gennaker-cruising-spinnaker': {
        id: 'app.boatDetails.friendlyFeatureName.gennaker-cruising-spinnaker',
        defaultMessage:
          enDefaults[
            'app.boatDetails.friendlyFeatureName.gennaker-cruising-spinnaker'
          ]
      },
      genoa: {
        id: 'app.boatDetails.friendlyFeatureName.genoa',
        defaultMessage: enDefaults['app.boatDetails.friendlyFeatureName.genoa']
      },
      spinnaker: {
        id: 'app.boatDetails.friendlyFeatureName.spinnaker',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.spinnaker']
      },
      'storm-jib': {
        id: 'app.boatDetails.friendlyFeatureName.storm-jib',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.storm-jib']
      },
      trisail: {
        id: 'app.boatDetails.friendlyFeatureName.trisail',
        defaultMessage:
          enDefaults['app.boatDetails.friendlyFeatureName.trisail']
      }
    },
    features: {
      'electrical-equipment': {
        id: 'app.boatDetails.features.electrical-equipment',
        defaultMessage:
          enDefaults['app.boatDetails.features.electrical-equipment']
      },
      electronics: {
        id: 'app.boatDetails.features.electronics',
        defaultMessage: enDefaults['app.boatDetails.features.electronics']
      },
      'inside-equipment': {
        id: 'app.boatDetails.features.inside-equipment',
        defaultMessage: enDefaults['app.boatDetails.features.inside-equipment']
      },
      'outside-equipment': {
        id: 'app.boatDetails.features.outside-equipment',
        defaultMessage: enDefaults['app.boatDetails.features.outside-equipment']
      },
      'additional-equipment': {
        id: 'app.boatDetails.features.additional-equipment',
        defaultMessage:
          enDefaults['app.boatDetails.features.additional-equipment']
      },
      rigging: {
        id: 'app.boatDetails.features.rigging',
        defaultMessage: enDefaults['app.boatDetails.features.rigging']
      },
      sails: {
        id: 'app.boatDetails.features.sails',
        defaultMessage: enDefaults['app.boatDetails.features.sails']
      },
      conversationalCta: {
        title: {
          id: 'app.boatDetails.features.conversationalCta.title',
          defaultMessage:
            enDefaults['app.boatDetails.features.conversationalCta.title']
        },
        content: {
          id: 'app.boatDetails.features.conversationalCta.content',
          defaultMessage:
            enDefaults['app.boatDetails.features.conversationalCta.content']
        },
        prePopulatedText: {
          id: 'app.boatDetails.features.conversationalCta.prePopulatedText',
          defaultMessage:
            enDefaults[
              'app.boatDetails.features.conversationalCta.prePopulatedText'
            ]
        }
      }
    },
    warranty: {
      months: {
        id: 'app.boatDetails.warranty.months',
        defaultMessage: enDefaults['app.boatDetails.warranty.months']
      },
      oneYear: {
        id: 'app.boatDetails.warranty.oneYear',
        defaultMessage: enDefaults['app.boatDetails.warranty.oneYear']
      },
      lifetime: {
        id: 'app.boatDetails.warranty.lifetime',
        defaultMessage: enDefaults['app.boatDetails.warranty.lifetime']
      },
      years: {
        id: 'app.boatDetails.warranty.years',
        defaultMessage: enDefaults['app.boatDetails.warranty.years']
      }
    },
    details: {
      year: {
        id: 'app.boatDetails.details.year',
        defaultMessage: enDefaults['app.boatDetails.details.year']
      },
      make: {
        id: 'app.boatDetails.details.make',
        defaultMessage: enDefaults['app.boatDetails.details.make']
      },
      model: {
        id: 'app.boatDetails.details.model',
        defaultMessage: enDefaults['app.boatDetails.details.model']
      },
      class: {
        id: 'app.boatDetails.details.class',
        defaultMessage: enDefaults['app.boatDetails.details.class']
      },
      length: {
        id: 'app.boatDetails.details.length',
        defaultMessage: enDefaults['app.boatDetails.details.length']
      },
      'fuel-type': {
        id: 'app.boatDetails.details.fuel-type',
        defaultMessage: enDefaults['app.boatDetails.details.fuel-type']
      },
      location: {
        id: 'app.boatDetails.details.location',
        defaultMessage: enDefaults['app.boatDetails.details.location']
      },
      'hull-material': {
        id: 'app.boatDetails.details.hull-material',
        defaultMessage: enDefaults['app.boatDetails.details.hull-material']
      },
      'hull-shape': {
        id: 'app.boatDetails.details.hull-shape',
        defaultMessage: enDefaults['app.boatDetails.details.hull-shape']
      },
      hin: {
        id: 'app.boatDetails.details.hin',
        defaultMessage: enDefaults['app.boatDetails.details.hin']
      },
      'hull-warranty': {
        id: 'app.boatDetails.details.hull-warranty',
        defaultMessage: enDefaults['app.boatDetails.details.hull-warranty']
      },
      engine: {
        id: 'app.boatDetails.details.engine',
        defaultMessage: enDefaults['app.boatDetails.details.engine']
      },
      capacity: {
        id: 'app.boatDetails.details.capacity',
        defaultMessage: enDefaults['app.boatDetails.details.capacity']
      }
    },
    moreDetails: {
      conversationalCta: {
        title: {
          id: 'app.boatDetails.moreDetails.conversationalCta.title',
          defaultMessage:
            enDefaults['app.boatDetails.moreDetails.conversationalCta.title']
        },
        content: {
          id: 'app.boatDetails.moreDetails.conversationalCta.content',
          defaultMessage:
            enDefaults['app.boatDetails.moreDetails.conversationalCta.content']
        }
      }
    },
    description: {
      conversationalCta: {
        title: {
          id: 'app.boatDetails.description.conversationalCta.title',
          defaultMessage:
            enDefaults['app.boatDetails.description.conversationalCta.title']
        },
        content: {
          id: 'app.boatDetails.description.conversationalCta.content',
          defaultMessage:
            enDefaults['app.boatDetails.description.conversationalCta.content']
        }
      }
    },
    propulsion: {
      configuration: {
        id: 'app.boatDetails.propulsion.configuration',
        defaultMessage: enDefaults['app.boatDetails.propulsion.configuration']
      },
      engine: {
        id: 'app.boatDetails.propulsion.engine',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine']
      },
      'engine-make': {
        id: 'app.boatDetails.propulsion.engine-make',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine-make']
      },
      'engine-model': {
        id: 'app.boatDetails.propulsion.engine-model',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine-model']
      },
      'engine-year': {
        id: 'app.boatDetails.propulsion.engine-year',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine-year']
      },
      'total-power': {
        id: 'app.boatDetails.propulsion.total-power',
        defaultMessage: enDefaults['app.boatDetails.propulsion.total-power']
      },
      'engine-hours': {
        id: 'app.boatDetails.propulsion.engine-hours',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine-hours']
      },
      'engine-type': {
        id: 'app.boatDetails.propulsion.engine-type',
        defaultMessage: enDefaults['app.boatDetails.propulsion.engine-type']
      },
      'drive-type': {
        id: 'app.boatDetails.propulsion.drive-type',
        defaultMessage: enDefaults['app.boatDetails.propulsion.drive-type']
      },
      location: {
        id: 'app.boatDetails.propulsion.location',
        defaultMessage: enDefaults['app.boatDetails.propulsion.location']
      },
      'fuel-type': {
        id: 'app.boatDetails.propulsion.fuel-type',
        defaultMessage: enDefaults['app.boatDetails.propulsion.fuel-type']
      },
      'rope-cutter': {
        id: 'app.boatDetails.propulsion.rope-cutter',
        defaultMessage: enDefaults['app.boatDetails.propulsion.rope-cutter']
      },
      'propeller-type': {
        id: 'app.boatDetails.propulsion.propeller-type',
        defaultMessage: enDefaults['app.boatDetails.propulsion.propeller-type']
      },
      'propeller-material': {
        id: 'app.boatDetails.propulsion.propeller-material',
        defaultMessage:
          enDefaults['app.boatDetails.propulsion.propeller-material']
      },
      'folding-propeller': {
        id: 'app.boatDetails.propulsion.folding-propeller',
        defaultMessage:
          enDefaults['app.boatDetails.propulsion.folding-propeller']
      },
      'numberCylinders': {
        id: 'app.boatDetails.propulsion.numberCylinders',
        defaultMessage: 'app.boatDetails.propulsion.numberCylinders'
      },
      'stockNumber': {
        id: 'app.boatDetails.propulsion.stockNumber',
        defaultMessage: 'app.boatDetails.propulsion.stockNumber'
      },
      'serialNumber': {
        id: 'app.boatDetails.propulsion.serialNumber',
        defaultMessage: 'app.boatDetails.propulsion.serialNumber'
      },
      'rpmMax': {
        id: 'app.boatDetails.propulsion.rpmMax',
        defaultMessage: 'app.boatDetails.propulsion.rpmMax'
      },
      'fuelInductionSystem': {
        id: 'app.boatDetails.propulsion.fuelInductionSystem',
        defaultMessage: 'app.boatDetails.propulsion.fuelInductionSystem'
      },
      'startingSystem': {
        id: 'app.boatDetails.propulsion.startingSystem',
        defaultMessage: 'app.boatDetails.propulsion.startingSystem'
      },
      'ignitionSystem': {
        id: 'app.boatDetails.propulsion.ignitionSystem',
        defaultMessage: 'app.boatDetails.propulsion.ignitionSystem'
      },
      'lubricationSystem': {
        id: 'app.boatDetails.propulsion.lubricationSystem',
        defaultMessage: 'app.boatDetails.propulsion.lubricationSystem'
      },
      'steeringSystem': {
        id: 'app.boatDetails.propulsion.steeringSystem',
        defaultMessage: 'app.boatDetails.propulsion.steeringSystem'
      },
      'coolingSystem': {
        id: 'app.boatDetails.propulsion.coolingSystem',
        defaultMessage: 'app.boatDetails.propulsion.coolingSystem'
      },
      'emissions': {
        id: 'app.boatDetails.propulsion.emissions',
        defaultMessage: 'app.boatDetails.propulsion.emissions'
      },
      power: {
        hp: {
          id: 'app.boatDetails.propulsion.power.hp',
          defaultMessage: enDefaults['app.boatDetails.propulsion.power.hp']
        },
        kW: {
          id: 'app.boatDetails.propulsion.power.kW',
          defaultMessage: enDefaults['app.boatDetails.propulsion.power.kW']
        }
      },
      use: {
        id: 'app.boatDetails.propulsion.use',
        defaultMessage: 'app.boatDetails.propulsion.use'
      }
    },
    measurements: {
      'speed-distance': {
        id: 'app.boatDetails.measurements.speed-distance',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.speed-distance']
      },
      dimensions: {
        id: 'app.boatDetails.measurements.dimensions',
        defaultMessage: enDefaults['app.boatDetails.measurements.dimensions']
      },
      weights: {
        id: 'app.boatDetails.measurements.weights',
        defaultMessage: enDefaults['app.boatDetails.measurements.weights']
      },
      miscellaneous: {
        id: 'app.boatDetails.measurements.miscellaneous',
        defaultMessage: enDefaults['app.boatDetails.measurements.miscellaneous']
      },
      tanks: {
        id: 'app.boatDetails.measurements.tanks',
        defaultMessage: enDefaults['app.boatDetails.measurements.tanks']
      },
      accommodations: {
        id: 'app.boatDetails.measurements.accommodations',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.accommodations']
      },
      'cruising-speed': {
        id: 'app.boatDetails.measurements.cruising-speed',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.cruising-speed']
      },
      'max-speed': {
        id: 'app.boatDetails.measurements.max-speed',
        defaultMessage: enDefaults['app.boatDetails.measurements.max-speed']
      },
      range: {
        id: 'app.boatDetails.measurements.range',
        defaultMessage: enDefaults['app.boatDetails.measurements.range']
      },
      'length-overall': {
        id: 'app.boatDetails.measurements.length-overall',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.length-overall']
      },
      'length-on-deck': {
        id: 'app.boatDetails.measurements.length-on-deck',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.length-on-deck']
      },
      'max-bridge-clearance': {
        id: 'app.boatDetails.measurements.max-bridge-clearance',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.max-bridge-clearance']
      },
      'max-draft': {
        id: 'app.boatDetails.measurements.max-draft',
        defaultMessage: enDefaults['app.boatDetails.measurements.max-draft']
      },
      freeboard: {
        id: 'app.boatDetails.measurements.freeboard',
        defaultMessage: enDefaults['app.boatDetails.measurements.freeboard']
      },
      beam: {
        id: 'app.boatDetails.measurements.beam',
        defaultMessage: enDefaults['app.boatDetails.measurements.beam']
      },
      'cabin-headroom': {
        id: 'app.boatDetails.measurements.cabin-headroom',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.cabin-headroom']
      },
      'length-at-waterline': {
        id: 'app.boatDetails.measurements.length-at-waterline',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.length-at-waterline']
      },
      'dry-weight': {
        id: 'app.boatDetails.measurements.dry-weight',
        defaultMessage: enDefaults['app.boatDetails.measurements.dry-weight']
      },
      'seating-capacity': {
        id: 'app.boatDetails.measurements.seating-capacity',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.seating-capacity']
      },
      windlass: {
        id: 'app.boatDetails.measurements.windlass',
        defaultMessage: enDefaults['app.boatDetails.measurements.windlass']
      },
      'liferaft-capacity': {
        id: 'app.boatDetails.measurements.liferaft-capacity',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.liferaft-capacity']
      },
      'deadrise-at-transom': {
        id: 'app.boatDetails.measurements.deadrise-at-transom',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.deadrise-at-transom']
      },
      'electrical-circuit': {
        id: 'app.boatDetails.measurements.electrical-circuit',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.electrical-circuit']
      },
      'fresh-water-tank': {
        id: 'app.boatDetails.measurements.fresh-water-tank',
        defaultMessage:
          enDefaults['app.boatDetails.measurements.fresh-water-tank']
      },
      'fuel-tank': {
        id: 'app.boatDetails.measurements.fuel-tank',
        defaultMessage: enDefaults['app.boatDetails.measurements.fuel-tank']
      },
      'holding-tank': {
        id: 'app.boatDetails.measurements.holding-tank',
        defaultMessage: enDefaults['app.boatDetails.measurements.holding-tank']
      },
      'single-berths': {
        id: 'app.boatDetails.measurements.single-berths',
        defaultMessage: enDefaults['app.boatDetails.measurements.single-berths']
      },
      'double-berths': {
        id: 'app.boatDetails.measurements.double-berths',
        defaultMessage: enDefaults['app.boatDetails.measurements.double-berths']
      },
      'twin-berths': {
        id: 'app.boatDetails.measurements.twin-berths',
        defaultMessage: enDefaults['app.boatDetails.measurements.twin-berths']
      },
      cabins: {
        id: 'app.boatDetails.measurements.cabins',
        defaultMessage: enDefaults['app.boatDetails.measurements.cabins']
      },
      heads: {
        id: 'app.boatDetails.measurements.heads',
        defaultMessage: enDefaults['app.boatDetails.measurements.heads']
      },
      voltage: {
        id: 'app.boatDetails.measurements.voltage',
        defaultMessage: 'app.boatDetails.measurements.voltage'
      },
      alternatorOutput: {
        id: 'app.boatDetails.measurements.alternatorOutput',
        defaultMessage: 'app.boatDetails.measurements.alternatorOutput'
      },
      gearRatio: {
        id: 'app.boatDetails.measurements.gearRatio',
        defaultMessage: 'app.boatDetails.measurements.gearRatio'
      },
      displacement: {
        id: 'app.boatDetails.measurements.displacement',
        defaultMessage: 'app.boatDetails.measurements.displacement'
      },
      bore: {
        id: 'app.boatDetails.measurements.bore',
        defaultMessage: 'app.boatDetails.measurements.bore'
      },
      stroke: {
        id: 'app.boatDetails.measurements.stroke',
        defaultMessage: 'app.boatDetails.measurements.stroke'
      },
      shaftLength: {
        id: 'app.boatDetails.measurements.shaftLength',
        defaultMessage: 'app.boatDetails.measurements.shaftLength'
      },
      conversationalCta: {
        title: {
          id: 'app.boatDetails.measurements.conversationalCta.title',
          defaultMessage:
            enDefaults['app.boatDetails.measurements.conversationalCta.title']
        },
        content: {
          id: 'app.boatDetails.measurements.conversationalCta.content',
          defaultMessage:
            enDefaults['app.boatDetails.measurements.conversationalCta.content']
        },
        prePopulatedText: {
          id: 'app.boatDetails.measurements.conversationalCta.prePopulatedText',
          defaultMessage:
            enDefaults[
              'app.boatDetails.measurements.conversationalCta.prePopulatedText'
            ]
        }
      }
    },
    value: {
      configuration: {
        'inline': {
          id: 'app.boatDetails.value.configuration.inline',
          defaultMessage:
            enDefaults['app.boatDetails.value.configuration.inline']
        },
        'rotary': {
          id: 'app.boatDetails.value.configuration.rotary',
          defaultMessage:
            enDefaults['app.boatDetails.value.configuration.rotary']
        }
      },
      driveType: {
        'air-propeller': {
          id: 'app.boatDetails.value.drive-type.air-propeller',
          defaultMessage:
            enDefaults['app.boatDetails.value.drive-type.air-propeller']
        },
        direct: {
          id: 'app.boatDetails.value.drive-type.direct',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.direct']
        },
        jet: {
          id: 'app.boatDetails.value.drive-type.jet',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.jet']
        },
        other: {
          id: 'app.boatDetails.value.drive-type.other',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.other']
        },
        outboard: {
          id: 'app.boatDetails.value.drive-type.outboard',
          defaultMessage:
            enDefaults['app.boatDetails.value.drive-type.outboard']
        },
        pod: {
          id: 'app.boatDetails.value.drive-type.pod',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.pod']
        },
        sail: {
          id: 'app.boatDetails.value.drive-type.sail',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.sail']
        },
        stern: {
          id: 'app.boatDetails.value.drive-type.stern',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.stern']
        },
        surface: {
          id: 'app.boatDetails.value.drive-type.surface',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.surface']
        },
        v: {
          id: 'app.boatDetails.value.drive-type.v',
          defaultMessage: enDefaults['app.boatDetails.value.drive-type.v']
        }
      },
      electricalCircuit: {
        '110v': {
          id: 'app.boatDetails.value.electrical-circuit.110v',
          defaultMessage:
            enDefaults['app.boatDetails.value.electrical-circuit.110v']
        },
        '12v': {
          id: 'app.boatDetails.value.electrical-circuit.12v',
          defaultMessage:
            enDefaults['app.boatDetails.value.electrical-circuit.12v']
        },
        '220v': {
          id: 'app.boatDetails.value.electrical-circuit.220v',
          defaultMessage:
            enDefaults['app.boatDetails.value.electrical-circuit.220v']
        },
        '240v': {
          id: 'app.boatDetails.value.electrical-circuit.240v',
          defaultMessage:
            enDefaults['app.boatDetails.value.electrical-circuit.240v']
        },
        '24v': {
          id: 'app.boatDetails.value.electrical-circuit.24v',
          defaultMessage:
            enDefaults['app.boatDetails.value.electrical-circuit.24v']
        }
      },
      engineType: {
        electric: {
          id: 'app.boatDetails.value.engine-type.electric',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.electric']
        },
        inboard: {
          id: 'app.boatDetails.value.engine-type.inboard',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.inboard']
        },
        'inboard-outboard': {
          id: 'app.boatDetails.value.engine-type.inboard-outboard',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.inboard-outboard']
        },
        other: {
          id: 'app.boatDetails.value.engine-type.other',
          defaultMessage: enDefaults['app.boatDetails.value.engine-type.other']
        },
        outboard: {
          id: 'app.boatDetails.value.engine-type.outboard',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.outboard']
        },
        'outboard-2s': {
          id: 'app.boatDetails.value.engine-type.outboard-2s',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.outboard-2s']
        },
        'outboard-4s': {
          id: 'app.boatDetails.value.engine-type.outboard-4s',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.outboard-4s']
        },
        'v-drive': {
          id: 'app.boatDetails.value.engine-type.v-drive',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-type.v-drive']
        }
      },
      engineLocation: {
        port: {
          id: 'app.boatDetails.value.engine-location.port',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-location.port']
        },
        starboard: {
          id: 'app.boatDetails.value.engine-location.starboard',
          defaultMessage:
            enDefaults['app.boatDetails.value.engine-location.starboard']
        }
      },
      fuelType: {
        diesel: {
          id: 'app.boatDetails.value.fuel-type.diesel',
          defaultMessage: enDefaults['app.boatDetails.value.fuel-type.diesel']
        },
        electric: {
          id: 'app.boatDetails.value.fuel-type.electric',
          defaultMessage: enDefaults['app.boatDetails.value.fuel-type.electric']
        },
        gasoline: {
          id: 'app.boatDetails.value.fuel-type.gasoline',
          defaultMessage: enDefaults['app.boatDetails.value.fuel-type.gasoline']
        },
        lpg: {
          id: 'app.boatDetails.value.fuel-type.lpg',
          defaultMessage: enDefaults['app.boatDetails.value.fuel-type.lpg']
        },
        other: {
          id: 'app.boatDetails.value.fuel-type.other',
          defaultMessage: enDefaults['app.boatDetails.value.fuel-type.other']
        }
      },
      hullMaterial: {
        aluminum: {
          id: 'app.boatDetails.value.hull-material.aluminum',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.aluminum']
        },
        composite: {
          id: 'app.boatDetails.value.hull-material.composite',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.composite']
        },
        'ferro-cement': {
          id: 'app.boatDetails.value.hull-material.ferro-cement',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.ferro-cement']
        },
        fiberglass: {
          id: 'app.boatDetails.value.hull-material.fiberglass',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.fiberglass']
        },
        hypalon: {
          id: 'app.boatDetails.value.hull-material.hypalon',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.hypalon']
        },
        other: {
          id: 'app.boatDetails.value.hull-material.other',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.other']
        },
        pvc: {
          id: 'app.boatDetails.value.hull-material.pvc',
          defaultMessage: enDefaults['app.boatDetails.value.hull-material.pvc']
        },
        roplene: {
          id: 'app.boatDetails.value.hull-material.roplene',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.roplene']
        },
        steel: {
          id: 'app.boatDetails.value.hull-material.steel',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-material.steel']
        },
        wood: {
          id: 'app.boatDetails.value.hull-material.wood',
          defaultMessage: enDefaults['app.boatDetails.value.hull-material.wood']
        }
      },
      hullShape: {
        catamaran: {
          id: 'app.boatDetails.value.hull-shape.catamaran',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.catamaran']
        },
        'deep-vee': {
          id: 'app.boatDetails.value.hull-shape.deep-vee',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.deep-vee']
        },
        displacement: {
          id: 'app.boatDetails.value.hull-shape.displacement',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.displacement']
        },
        flat: {
          id: 'app.boatDetails.value.hull-shape.flat',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.flat']
        },
        foldable: {
          id: 'app.boatDetails.value.hull-shape.foldable',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.foldable']
        },
        'modified-vee': {
          id: 'app.boatDetails.value.hull-shape.modified-vee',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.modified-vee']
        },
        monohull: {
          id: 'app.boatDetails.value.hull-shape.monohull',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.monohull']
        },
        other: {
          id: 'app.boatDetails.value.hull-shape.other',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.other']
        },
        planing: {
          id: 'app.boatDetails.value.hull-shape.planing',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.planing']
        },
        pontoon: {
          id: 'app.boatDetails.value.hull-shape.pontoon',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.pontoon']
        },
        rib: {
          id: 'app.boatDetails.value.hull-shape.rib',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.rib']
        },
        'roll-up': {
          id: 'app.boatDetails.value.hull-shape.roll-up',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.roll-up']
        },
        'sea-v2': {
          id: 'app.boatDetails.value.hull-shape.sea-v2',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.sea-v2']
        },
        'semi-displacement': {
          id: 'app.boatDetails.value.hull-shape.semi-displacement',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.semi-displacement']
        },
        trimaran: {
          id: 'app.boatDetails.value.hull-shape.trimaran',
          defaultMessage:
            enDefaults['app.boatDetails.value.hull-shape.trimaran']
        },
        tunnel: {
          id: 'app.boatDetails.value.hull-shape.tunnel',
          defaultMessage: enDefaults['app.boatDetails.value.hull-shape.tunnel']
        }
      },
      activities: {
        'overnight-cruising': {
          id: 'app.boatDetails.value.activities.overnight-cruising',
          defaultMessage:
            enDefaults['app.boatDetails.value.activities.overnight-cruising']
        },
        sailing: {
          id: 'app.boatDetails.value.activities.sailing',
          defaultMessage: enDefaults['app.boatDetails.value.activities.sailing']
        },
        'day-cruising': {
          id: 'app.boatDetails.value.activities.day-cruising',
          defaultMessage:
            enDefaults['app.boatDetails.value.activities.day-cruising']
        },
        watersports: {
          id: 'app.boatDetails.value.activities.watersports',
          defaultMessage:
            enDefaults['app.boatDetails.value.activities.watersports']
        },
        'saltwater-fishing': {
          id: 'app.boatDetails.value.activities.saltwater-fishing',
          defaultMessage:
            enDefaults['app.boatDetails.value.activities.saltwater-fishing']
        },
        'freshwater-fishing': {
          id: 'app.boatDetails.value.activities.freshwater-fishing',
          defaultMessage:
            enDefaults['app.boatDetails.value.activities.freshwater-fishing']
        },
        pwc: {
          id: 'app.boatDetails.value.activities.pwc',
          defaultMessage: enDefaults['app.boatDetails.value.activities.pwc']
        },
        other: {
          id: 'app.boatDetails.value.activities.other',
          defaultMessage: enDefaults['app.boatDetails.value.activities.other']
        }
      },
      moreDetailsSection: {
        dimensions: {
          id: 'app.boatDetails.value.more-details-section.dimensions',
          defaultMessage:
            enDefaults['app.boatDetails.value.more-details-section.dimensions']
        },
        engines: {
          id: 'app.boatDetails.value.more-details-section.engines',
          defaultMessage:
            enDefaults['app.boatDetails.value.more-details-section.engines']
        },
        tankage: {
          id: 'app.boatDetails.value.more-details-section.tankage',
          defaultMessage:
            enDefaults['app.boatDetails.value.more-details-section.tankage']
        },
        additionalInformation: {
          id: 'app.boatDetails.value.more-details-section.additional-information',
          defaultMessage:
            enDefaults[
              'app.boatDetails.value.more-details-section.additional-information'
            ]
        },
        accommodations: {
          id: 'app.boatDetails.value.more-details-section.accommodations',
          defaultMessage:
            enDefaults[
              'app.boatDetails.value.more-details-section.accommodations'
            ]
        },
        galley: {
          id: 'app.boatDetails.value.more-details-section.galley',
          defaultMessage:
            enDefaults['app.boatDetails.value.more-details-section.galley']
        },
        disclaimer: {
          id: 'app.boatDetails.value.more-details-section.disclaimer',
          defaultMessage:
            enDefaults['app.boatDetails.value.more-details-section.disclaimer']
        }
      },
      propellerMaterial: {
        allow: {
          id: 'app.boatDetails.value.propeller-material.allow',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-material.allow']
        },
        alloy: {
          id: 'app.boatDetails.value.propeller-material.alloy',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-material.alloy']
        },
        aluminum: {
          id: 'app.boatDetails.value.propeller-material.aluminum',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-material.aluminum']
        },
        bronze: {
          id: 'app.boatDetails.value.propeller-material.bronze',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-material.bronze']
        },
        other: {
          id: 'app.boatDetails.value.propeller-material.other',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-material.other']
        },
        'stainless-steel': {
          id: 'app.boatDetails.value.propeller-material.stainless-steel',
          defaultMessage:
            enDefaults[
              'app.boatDetails.value.propeller-material.stainless-steel'
            ]
        }
      },
      propellerType: {
        '2-blade': {
          id: 'app.boatDetails.value.propeller-type.2-blade',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-type.2-blade']
        },
        '3-blade': {
          id: 'app.boatDetails.value.propeller-type.3-blade',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-type.3-blade']
        },
        '4-blade': {
          id: 'app.boatDetails.value.propeller-type.4-blade',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-type.4-blade']
        },
        '5-blade': {
          id: 'app.boatDetails.value.propeller-type.5-blade',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-type.5-blade']
        },
        '6-blade': {
          id: 'app.boatDetails.value.propeller-type.6-blade',
          defaultMessage:
            enDefaults['app.boatDetails.value.propeller-type.6-blade']
        }
      },
      tankMaterial: {
        aluminium: {
          id: 'app.boatDetails.value.tank-material.aluminium',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.aluminium']
        },
        aluminum: {
          id: 'app.boatDetails.value.tank-material.aluminum',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.aluminum']
        },
        grp: {
          id: 'app.boatDetails.value.tank-material.grp',
          defaultMessage: enDefaults['app.boatDetails.value.tank-material.grp']
        },
        other: {
          id: 'app.boatDetails.value.tank-material.other',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.other']
        },
        plastic: {
          id: 'app.boatDetails.value.tank-material.plastic',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.plastic']
        },
        'stainless-steel': {
          id: 'app.boatDetails.value.tank-material.stainless-steel',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.stainless-steel']
        },
        steel: {
          id: 'app.boatDetails.value.tank-material.steel',
          defaultMessage:
            enDefaults['app.boatDetails.value.tank-material.steel']
        }
      },
      use: {
        'both': {
          id: 'app.boatDetails.value.use.both',
          defaultMessage: enDefaults['app.boatDetails.value.use.both']
        },
        'fresh-water': {
          id: 'app.boatDetails.value.use.fresh-water',
          defaultMessage: enDefaults['app.boatDetails.value.use.fresh-water']
        },
        'salt-water': {
          id: 'app.boatDetails.value.use.salt-water',
          defaultMessage: enDefaults['app.boatDetails.value.use.salt-water']
        }
      },
      windlass: {
        'electric-windlass': {
          id: 'app.boatDetails.value.windlass.electric-windlass',
          defaultMessage:
            enDefaults['app.boatDetails.value.windlass.electric-windlass']
        },
        'hydraulic-windlass': {
          id: 'app.boatDetails.value.windlass.hydraulic-windlass',
          defaultMessage:
            enDefaults['app.boatDetails.value.windlass.hydraulic-windlass']
        },
        'manual-windlass': {
          id: 'app.boatDetails.value.windlass.manual-windlass',
          defaultMessage:
            enDefaults['app.boatDetails.value.windlass.manual-windlass']
        }
      }
    },
    SEO: {
      metaElements: {
        description: {
          id: 'app.boatDetails.SEO.metaElements.description',
          defaultMessage:
            enDefaults['app.boatDetails.SEO.metaElements.description']
        },
        descriptionSmallYacht: {
          id: 'app.boatDetails.SEO.metaElements.description.smallYacht',
          defaultMessage:
            enDefaults[
              'app.boatDetails.SEO.metaElements.description.smallYacht'
            ]
        },
        descriptionLargeYacht: {
          id: 'app.boatDetails.SEO.metaElements.description.largeYacht',
          defaultMessage:
            enDefaults[
              'app.boatDetails.SEO.metaElements.description.largeYacht'
            ]
        },
        descriptionSmallYachtNoName: {
          id: 'app.boatDetails.SEO.metaElements.description.smallYachtNoName',
          defaultMessage:
            enDefaults[
              'app.boatDetails.SEO.metaElements.description.smallYachtNoName'
            ]
        },
        descriptionLargeYachtNoName: {
          id: 'app.boatDetails.SEO.metaElements.description.largeYachtNoName',
          defaultMessage:
            enDefaults[
              'app.boatDetails.SEO.metaElements.description.largeYachtNoName'
            ]
        },
        title: {
          length24m: {
            boatName: {
              id: 'app.boatDetails.SEO.metaElements.title.length24m.boatName',
              defaultMessage:
                enDefaults[
                  'app.boatDetails.SEO.metaElements.title.length24m.boatName'
                ]
            },
            true: {
              id: 'app.boatDetails.SEO.metaElements.title.length24m.true',
              defaultMessage:
                enDefaults[
                  'app.boatDetails.SEO.metaElements.title.length24m.true'
                ]
            },
            false: {
              id: 'app.boatDetails.SEO.metaElements.title.length24m.false',
              defaultMessage:
                enDefaults[
                  'app.boatDetails.SEO.metaElements.title.length24m.false'
                ]
            }
          },
          portalName: {
            id: 'app.boatDetails.SEO.metaElements.title.portalName',
            defaultMessage:
              enDefaults['app.boatDetails.SEO.metaElements.title.portalName']
          },
          power: {
            id: 'app.boatDetails.SEO.metaElements.title.power',
            defaultMessage:
              enDefaults['app.boatDetails.SEO.metaElements.title.power']
          },
          sail: {
            id: 'app.boatDetails.SEO.metaElements.title.sail',
            defaultMessage:
              enDefaults['app.boatDetails.SEO.metaElements.title.sail']
          },
          subdivision: {
            id: 'app.boatDetails.SEO.metaElements.title.subdivision',
            defaultMessage:
              enDefaults['app.boatDetails.SEO.metaElements.title.subdivision']
          },
          unpowered: {
            id: 'app.boatDetails.SEO.metaElements.title.unpowered',
            defaultMessage:
              enDefaults['app.boatDetails.SEO.metaElements.title.unpowered']
          }
        }
      }
    },
    moreQuestions: {
      conversationalCta: {
        title: {
          id: 'app.boatDetails.moreQuestions.conversationalCta.title',
          defaultMessage:
            enDefaults['app.boatDetails.moreQuestions.conversationalCta.title']
        },
        body: {
          firstRow: {
            id: 'app.boatDetails.moreQuestions.conversationalCta.body.firstRow',
            defaultMessage:
              enDefaults[
                'app.boatDetails.moreQuestions.conversationalCta.body.firstRow'
              ]
          },
          secondRow: {
            id: 'app.boatDetails.moreQuestions.conversationalCta.body.secondRow',
            defaultMessage:
              enDefaults[
                'app.boatDetails.moreQuestions.conversationalCta.body.secondRow'
              ]
          }
        },
        linkText: {
          id: 'app.boatDetails.moreQuestions.conversationalCta.linkText',
          defaultMessage:
            enDefaults[
              'app.boatDetails.moreQuestions.conversationalCta.linkText'
            ]
        },
        prePopulatedText: {
          id: 'app.boatDetails.moreQuestions.conversationalCta.prePopulatedText',
          defaultMessage:
            enDefaults[
              'app.boatDetails.moreQuestions.conversationalCta.prePopulatedText'
            ]
        }
      }
    }
  },
  engineDetails: {
    SEO: {
      metaElements: {
        title: {
          id: 'app.engineDetails.SEO.metaElements.title',
          defaultMessage: enDefaults['app.engineDetails.SEO.metaElements.title']
        },
        description: {
          id: 'app.engineDetails.SEO.metaElements.description',
          defaultMessage:
            enDefaults['app.engineDetails.SEO.metaElements.description']
        }
      }
    }
  },
  blog: {
    home: {
      id: 'app.blog.home',
      defaultMessage: enDefaults['app.blog.home']
    },
    page: {
      id: 'app.blog.page',
      defaultMessage: enDefaults['app.blog.page']
    },
    writtenBy: {
      id: 'app.blog.writtenBy',
      defaultMessage: enDefaults['app.blog.writtenBy']
    },
    publishedOn: {
      id: 'app.blog.publishedOn',
      defaultMessage: enDefaults['app.blog.publishedOn']
    },
    month01: {
      id: 'app.blog.month01',
      defaultMessage: enDefaults['app.blog.month01']
    },
    month02: {
      id: 'app.blog.month02',
      defaultMessage: enDefaults['app.blog.month02']
    },
    month03: {
      id: 'app.blog.month03',
      defaultMessage: enDefaults['app.blog.month03']
    },
    month04: {
      id: 'app.blog.month04',
      defaultMessage: enDefaults['app.blog.month04']
    },
    month05: {
      id: 'app.blog.month05',
      defaultMessage: enDefaults['app.blog.month05']
    },
    month06: {
      id: 'app.blog.month06',
      defaultMessage: enDefaults['app.blog.month06']
    },
    month07: {
      id: 'app.blog.month07',
      defaultMessage: enDefaults['app.blog.month07']
    },
    month08: {
      id: 'app.blog.month08',
      defaultMessage: enDefaults['app.blog.month08']
    },
    month09: {
      id: 'app.blog.month09',
      defaultMessage: enDefaults['app.blog.month09']
    },
    month10: {
      id: 'app.blog.month10',
      defaultMessage: enDefaults['app.blog.month10']
    },
    month11: {
      id: 'app.blog.month11',
      defaultMessage: enDefaults['app.blog.month11']
    },
    month12: {
      id: 'app.blog.month12',
      defaultMessage: enDefaults['app.blog.month12']
    },
    relatedArticles: {
      id: 'app.blog.relatedArticles',
      defaultMessage: enDefaults['app.blog.relatedArticles']
    },
    category: {
      id: 'app.blog.category',
      defaultMessage: enDefaults['app.blog.category']
    },
    categories: {
      buying: {
        id: 'app.blog.categories.buying',
        defaultMessage: enDefaults['app.blog.categories.buying']
      },
      selling: {
        id: 'app.blog.categories.selling',
        defaultMessage: enDefaults['app.blog.categories.selling']
      },
      boating: {
        id: 'app.blog.categories.boating',
        defaultMessage: enDefaults['app.blog.categories.boating']
      },
      reviews: {
        id: 'app.blog.categories.reviews',
        defaultMessage: enDefaults['app.blog.categories.reviews']
      },
      lifestyle: {
        id: 'app.blog.categories.lifestyle',
        defaultMessage: enDefaults['app.blog.categories.lifestyle']
      },
      power: {
        id: 'app.blog.categories.power',
        defaultMessage: enDefaults['app.blog.categories.power']
      },
      sail: {
        id: 'app.blog.categories.sail',
        defaultMessage: enDefaults['app.blog.categories.sail']
      }
    },
    categoriesDescription: {
      buying: {
        id: 'app.blog.categoriesDescription.buying',
        defaultMessage: enDefaults['app.blog.categoriesDescription.buying']
      },
      selling: {
        id: 'app.blog.categoriesDescription.selling',
        defaultMessage: enDefaults['app.blog.categoriesDescription.selling']
      },
      boating: {
        id: 'app.blog.categoriesDescription.boating',
        defaultMessage: enDefaults['app.blog.categoriesDescription.boating']
      },
      reviews: {
        id: 'app.blog.categoriesDescription.reviews',
        defaultMessage: enDefaults['app.blog.categoriesDescription.reviews']
      }
    },
    homePageSEO: {
      h1: {
        id: 'app.blog.homePageSEO.h1',
        defaultMessage: enDefaults['app.blog.homePageSEO.h1']
      },
      metaElements: {
        title: {
          id: 'app.blog.homePageSEO.metaElements.title',
          defaultMessage: enDefaults['app.blog.homePageSEO.metaElements.title']
        },
        description: {
          id: 'app.blog.homePageSEO.metaElements.description',
          defaultMessage:
            enDefaults['app.blog.homePageSEO.metaElements.description']
        }
      }
    },
    categoryPageSEO: {
      buying: {
        h1: {
          id: 'app.blog.categoryPageSEO.buying.h1',
          defaultMessage: enDefaults['app.blog.categoryPageSEO.buying.h1']
        },
        metaElements: {
          title: {
            id: 'app.blog.categoryPageSEO.buying.metaElements.title',
            defaultMessage:
              enDefaults['app.blog.categoryPageSEO.buying.metaElements.title']
          },
          description: {
            id: 'app.blog.categoryPageSEO.buying.metaElements.description',
            defaultMessage:
              enDefaults[
                'app.blog.categoryPageSEO.buying.metaElements.description'
              ]
          }
        }
      },
      selling: {
        h1: {
          id: 'app.blog.categoryPageSEO.selling.h1',
          defaultMessage: enDefaults['app.blog.categoryPageSEO.selling.h1']
        },
        metaElements: {
          title: {
            id: 'app.blog.categoryPageSEO.selling.metaElements.title',
            defaultMessage:
              enDefaults['app.blog.categoryPageSEO.selling.metaElements.title']
          },
          description: {
            id: 'app.blog.categoryPageSEO.selling.metaElements.description',
            defaultMessage:
              enDefaults[
                'app.blog.categoryPageSEO.selling.metaElements.description'
              ]
          }
        }
      },
      boating: {
        h1: {
          id: 'app.blog.categoryPageSEO.boating.h1',
          defaultMessage: enDefaults['app.blog.categoryPageSEO.boating.h1']
        },
        metaElements: {
          title: {
            id: 'app.blog.categoryPageSEO.boating.metaElements.title',
            defaultMessage:
              enDefaults['app.blog.categoryPageSEO.boating.metaElements.title']
          },
          description: {
            id: 'app.blog.categoryPageSEO.boating.metaElements.description',
            defaultMessage:
              enDefaults[
                'app.blog.categoryPageSEO.boating.metaElements.description'
              ]
          }
        }
      },
      reviews: {
        h1: {
          id: 'app.blog.categoryPageSEO.reviews.h1',
          defaultMessage: enDefaults['app.blog.categoryPageSEO.reviews.h1']
        },
        metaElements: {
          title: {
            id: 'app.blog.categoryPageSEO.reviews.metaElements.title',
            defaultMessage:
              enDefaults['app.blog.categoryPageSEO.reviews.metaElements.title']
          },
          description: {
            id: 'app.blog.categoryPageSEO.reviews.metaElements.description',
            defaultMessage:
              enDefaults[
                'app.blog.categoryPageSEO.reviews.metaElements.description'
              ]
          }
        }
      }
    },
    articlePageSEO: {
      metaElements: {
        title: {
          id: 'app.blog.articlePageSEO.metaElements.title',
          defaultMessage:
            enDefaults['app.blog.articlePageSEO.metaElements.title']
        }
      }
    }
  },
  powerhp: {
    id: 'app.general.powerhp',
    defaultMessage: enDefaults['app.general.powerhp']
  },
  searchAlerts: {
    id: 'app.general.searchAlerts',
    defaultMessage: enDefaults['app.general.searchAlerts'],
    subscribe: {
      id: 'app.searchAlerts.subscribe',
      defaultMessage: enDefaults['app.searchAlerts.subscribe']
    },
    email: {
      id: 'app.searchAlerts.email',
      defaultMessage: enDefaults['app.searchAlerts.email']
    },
    yourEmail: {
      id: 'app.searchAlerts.yourEmail',
      defaultMessage: enDefaults['app.searchAlerts.yourEmail']
    },
    description: {
      id: 'app.searchAlerts.description',
      defaultMessage: enDefaults['app.searchAlerts.description']
    },
    textWarning: {
      id: 'app.searchAlerts.textWarning',
      defaultMessage: enDefaults['app.searchAlerts.textWarning']
    },
    confirmation: {
      id: 'app.searchAlerts.confirmation',
      defaultMessage: enDefaults['app.searchAlerts.confirmation']
    },
    termsAndConditions: {
      disclaimer: {
        id: 'app.searchAlerts.termsAndConditions.disclaimer',
        defaultMessage:
          enDefaults['app.searchAlerts.termsAndConditions.disclaimer']
      },
      name: {
        id: 'app.searchAlerts.termsAndConditions.name',
        defaultMessage: enDefaults['app.searchAlerts.termsAndConditions.name']
      },
      url: {
        id: 'app.searchAlerts.termsAndConditions.url',
        defaultMessage: enDefaults['app.searchAlerts.termsAndConditions.url']
      }
    },
    detailsTitle: {
      id: 'app.searchAlerts.detailsTitle',
      defaultMessage: enDefaults['app.searchAlerts.detailsTitle']
    }
  },
  relatedArticles: {
    id: 'app.general.relatedArticles',
    defaultMessage: enDefaults['app.general.relatedArticles']
  },
  searchResults: {
    listing: {
      requestInfo: {
        id: 'app.searchResults.listing.requestInfo',
        defaultMessage: enDefaults['app.searchResults.listing.requestInfo']
      }
    }
  },
  cookiesDisclaimer: {
    disclaimer: {
      p1: {
        id: 'app.cookiesDisclaimer.disclaimer.p1',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p1']
      },
      p2: {
        id: 'app.cookiesDisclaimer.disclaimer.p2',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p2']
      },
      p3: {
        id: 'app.cookiesDisclaimer.disclaimer.p3',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p3']
      },
      p4: {
        id: 'app.cookiesDisclaimer.disclaimer.p4',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p4']
      },
      policy: {
        id: 'app.cookiesDisclaimer.disclaimer.policy',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.policy']
      },
      p5: {
        id: 'app.cookiesDisclaimer.disclaimer.p5',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p5']
      },
      p6: {
        id: 'app.cookiesDisclaimer.disclaimer.p6',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p6']
      },
      p7: {
        id: 'app.cookiesDisclaimer.disclaimer.p7',
        defaultMessage: enDefaults['app.cookiesDisclaimer.disclaimer.p7']
      }
    },
    accept: {
      id: 'app.cookiesDisclaimer.accept',
      defaultMessage: enDefaults['app.cookiesDisclaimer.accept']
    },
    deny: {
      id: 'app.cookiesDisclaimer.deny',
      defaultMessage: enDefaults['app.cookiesDisclaimer.deny']
    }
  },
  linkList: {
    title: {
      id: 'app.linkList.title',
      defaultMessage: enDefaults['app.linkList.title']
    }
  },
  'canal-boats': {
    id: 'app.search.filter.group.canal',
    defaultMessage: enDefaults['app.search.filter.group.canal']
  },
  'fishing-boats': {
    id: 'app.search.filter.group.fishing',
    defaultMessage: enDefaults['app.search.filter.group.fishing']
  },
  yachts: {
    id: 'app.search.filter.group.yachts',
    defaultMessage: enDefaults['app.search.filter.group.yachts']
  },
  boatLoansContent: {
    applyNow: {
      id: 'app.boatLoans.applyNowButton',
      defaultMessage: enDefaults['app.boatLoans.applyNowButton']
    },
    SEO: {
      title: {
        id: 'app.boatLoans.SEO.metaElements.title',
        defaultMessage: enDefaults['app.boatLoans.SEO.metaElements.title']
      },
      description: {
        id: 'app.boatLoans.SEO.metaElements.description',
        defaultMessage: enDefaults['app.boatLoans.SEO.metaElements.description']
      }
    },
    banner: {
      title1: {
        id: 'app.boatLoans.banner.title1',
        defaultMessage: enDefaults['app.boatLoans.banner.title1']
      },
      title2: {
        id: 'app.boatLoans.banner.title2',
        defaultMessage: enDefaults['app.boatLoans.banner.title2']
      },
      perk1: {
        id: 'app.boatLoans.banner.perk1',
        defaultMessage: enDefaults['app.boatLoans.banner.perk1']
      },
      perk2: {
        id: 'app.boatLoans.banner.perk2',
        defaultMessage: enDefaults['app.boatLoans.banner.perk2']
      },
      perk3: {
        id: 'app.boatLoans.banner.perk3',
        defaultMessage: enDefaults['app.boatLoans.banner.perk3']
      },
      perk4: {
        id: 'app.boatLoans.banner.perk4',
        defaultMessage: enDefaults['app.boatLoans.banner.perk4']
      },
      perk5: {
        id: 'app.boatLoans.banner.perk5',
        defaultMessage: enDefaults['app.boatLoans.banner.perk5']
      },
      rates: {
        title: {
          id: 'app.boatLoans.banner.rates.title',
          defaultMessage: enDefaults['app.boatLoans.banner.rates.title']
        },
        disclaimer: {
          id: 'app.boatLoans.banner.rates.disclaimer',
          defaultMessage: enDefaults['app.boatLoans.banner.rates.disclaimer']
        }
      }
    },
    calculator: {
      title: {
        id: 'app.boatLoans.calculator.title',
        defaultMessage: enDefaults['app.boatLoans.calculator.title']
      },
      form: {
        loanAmountLabel: {
          id: 'app.boatLoans.calculator.form.loanAmount.label',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanAmount.label']
        },
        loanAmountPlaceholder: {
          id: 'app.boatLoans.calculator.form.loanAmount.placeholder',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanAmount.placeholder']
        },
        loanAmountError: {
          id: 'app.boatLoans.calculator.form.loanAmount.error',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanAmount.error']
        },
        loanTypeLabel: {
          id: 'app.boatLoans.calculator.form.loanType.label',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanType.label']
        },
        loanTypePlaceholder: {
          id: 'app.boatLoans.calculator.form.loanType.placeholder',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanType.placeholder']
        },
        loanTypeNew: {
          id: 'app.boatLoans.calculator.form.loanType.new',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanType.new']
        },
        loanTypeUsed: {
          id: 'app.boatLoans.calculator.form.loanType.used',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanType.used']
        },
        loanTypeRefinance: {
          id: 'app.boatLoans.calculator.form.loanType.refinance',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.loanType.refinance']
        },
        boatYearLabel: {
          id: 'app.boatLoans.calculator.form.boatYear.label',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.boatYear.label']
        },
        boatYearPlaceholder: {
          id: 'app.boatLoans.calculator.form.boatYear.placeholder',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.boatYear.placeholder']
        },
        ficoScoreLabel: {
          id: 'app.boatLoans.calculator.form.ficoScore.label',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.ficoScore.label']
        },
        ficoScorePlaceholder: {
          id: 'app.boatLoans.calculator.form.ficoScore.placeholder',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.form.ficoScore.placeholder']
        }
      },
      results: {
        summary: {
          id: 'app.boatLoans.calculator.results.summary',
          defaultMessage: enDefaults['app.boatLoans.calculator.results.summary']
        },
        loanAmount: {
          id: 'app.boatLoans.calculator.results.loanAmount',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.loanAmount']
        },
        interestRate: {
          id: 'app.boatLoans.calculator.results.interestRate',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.interestRate']
        },
        termLength: {
          id: 'app.boatLoans.calculator.results.termLength',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.termLength']
        },
        years: {
          id: 'app.boatLoans.calculator.results.years',
          defaultMessage: enDefaults['app.boatLoans.calculator.results.years']
        },
        estimatedMonthlyPayment: {
          id: 'app.boatLoans.calculator.results.estimatedMonthlyPayment',
          defaultMessage:
            enDefaults[
              'app.boatLoans.calculator.results.estimatedMonthlyPayment'
            ]
        },
        moreInfo: {
          id: 'app.boatLoans.calculator.results.moreInfo',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.moreInfo']
        },
        contactUs: {
          id: 'app.boatLoans.calculator.results.contactUs',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.contactUs']
        },
        disclaimer: {
          id: 'app.boatLoans.calculator.results.disclaimer',
          defaultMessage:
            enDefaults['app.boatLoans.calculator.results.disclaimer']
        }
      }
    },
    whyTrident: {
      logo: {
        altText: {
          id: 'app.boatLoans.whyTrident.logo.altText',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.logo.altText']
        }
      },
      title: {
        id: 'app.boatLoans.whyTrident.title',
        defaultMessage: enDefaults['app.boatLoans.whyTrident.title']
      },
      info1: {
        title: {
          id: 'app.boatLoans.whyTrident.info1.title',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info1.title']
        },
        content: {
          id: 'app.boatLoans.whyTrident.info1.content',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info1.content']
        }
      },
      info2: {
        title: {
          id: 'app.boatLoans.whyTrident.info2.title',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info2.title']
        },
        content: {
          id: 'app.boatLoans.whyTrident.info2.content',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info2.content']
        }
      },
      info3: {
        title: {
          id: 'app.boatLoans.whyTrident.info3.title',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info3.title']
        },
        content: {
          id: 'app.boatLoans.whyTrident.info3.content',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info3.content']
        }
      },
      info4: {
        title: {
          id: 'app.boatLoans.whyTrident.info4.title',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info4.title']
        },
        content: {
          id: 'app.boatLoans.whyTrident.info4.content',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info4.content']
        },
        linkText: {
          id: 'app.boatLoans.whyTrident.info4.link',
          defaultMessage: enDefaults['app.boatLoans.whyTrident.info4.link']
        }
      }
    },
    infoAccordion: {
      question1: {
        title: {
          id: 'app.boatLoans.infoAccordion.question1.title',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question1.title']
        },
        content: {
          id: 'app.boatLoans.infoAccordion.question1.content',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question1.content']
        },
        link1: {
          id: 'app.boatLoans.infoAccordion.question1.link1',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question1.link1']
        },
        link2: {
          id: 'app.boatLoans.infoAccordion.question1.link2',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question1.link2']
        }
      },
      question2: {
        title: {
          id: 'app.boatLoans.infoAccordion.question2.title',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question2.title']
        },
        content: {
          id: 'app.boatLoans.infoAccordion.question2.content',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question2.content']
        },
        link: {
          id: 'app.boatLoans.infoAccordion.question2.link',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question2.link']
        }
      },
      question3: {
        title: {
          id: 'app.boatLoans.infoAccordion.question3.title',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question3.title']
        },
        content: {
          id: 'app.boatLoans.infoAccordion.question3.content',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question3.content']
        }
      },
      question4: {
        title: {
          id: 'app.boatLoans.infoAccordion.question4.title',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.title']
        },
        content: {
          id: 'app.boatLoans.infoAccordion.question4.content',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.content']
        },
        item1: {
          id: 'app.boatLoans.infoAccordion.question4.item1',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item1']
        },
        item2: {
          id: 'app.boatLoans.infoAccordion.question4.item2',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item2']
        },
        item3: {
          id: 'app.boatLoans.infoAccordion.question4.item3',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item3']
        },
        item4: {
          id: 'app.boatLoans.infoAccordion.question4.item4',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item4']
        },
        item5: {
          id: 'app.boatLoans.infoAccordion.question4.item5',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item5']
        },
        item6: {
          id: 'app.boatLoans.infoAccordion.question4.item6',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question4.item6']
        }
      },
      question5: {
        title: {
          id: 'app.boatLoans.infoAccordion.question5.title',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question5.title']
        },
        content: {
          id: 'app.boatLoans.infoAccordion.question5.content',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question5.content']
        },
        link: {
          id: 'app.boatLoans.infoAccordion.question5.link',
          defaultMessage:
            enDefaults['app.boatLoans.infoAccordion.question5.link']
        }
      }
    },
    bdpBoatLoansSection: {
      title: {
        id: 'app.boatLoans.bdpBoatLoansSection.title',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.title']
      },
      applyNow: {
        id: 'app.boatLoans.bdpBoatLoansSection.applyNow',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.applyNow']
      },
      callUs: {
        id: 'app.boatLoans.bdpBoatLoansSection.callUs',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.callUs']
      },
      reviews: {
        id: 'app.boatLoans.bdpBoatLoansSection.reviews',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.reviews']
      },
      rates: {
        id: 'app.boatLoans.bdpBoatLoansSection.rates',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.rates']
      },
      faqs: {
        id: 'app.boatLoans.bdpBoatLoansSection.faqs',
        defaultMessage: enDefaults['app.boatLoans.bdpBoatLoansSection.faqs']
      },
      poweredBy: {
        id: 'app.boatLoans.bdpBoatLoansSection.poweredBy',
        defaultMessage:
          enDefaults['app.boatLoans.bdpBoatLoansSection.poweredBy']
      }
    },
    monthlyPaymentTooltip: {
      monthAbbreviation: {
        id: 'app.boatLoans.monthlyPaymentTooltip.monthAbbreviation',
        defaultMessage:
          enDefaults['app.boatLoans.monthlyPaymentTooltip.monthAbbreviation']
      },
      currencyCode: {
        id: 'app.boatLoans.monthlyPaymentTooltip.currencyCode',
        defaultMessage:
          enDefaults['app.boatLoans.monthlyPaymentTooltip.currencyCode']
      },
      month: {
        id: 'app.boatLoans.monthlyPaymentTooltip.month',
        defaultMessage: enDefaults['app.boatLoans.monthlyPaymentTooltip.month']
      },
      text: {
        id: 'app.boatLoans.monthlyPaymentTooltip.text',
        defaultMessage: enDefaults['app.boatLoans.monthlyPaymentTooltip.text']
      }
    }
  },
  boatLoansCalculator: {
    meta: {
      title: {
        id: 'app.boatLoansCalculator.meta.title',
        defaultMessage: enDefaults['app.boatLoansCalculator.meta.title']
      },
      description: {
        id: 'app.boatLoansCalculator.meta.description',
        defaultMessage: enDefaults['app.boatLoansCalculator.meta.description']
      }
    },
    hero: {
      title: {
        id: 'app.boatLoansCalculator.hero.title',
        defaultMessage: enDefaults['app.boatLoansCalculator.hero.title']
      },
      description: {
        id: 'app.boatLoansCalculator.hero.description',
        defaultMessage: enDefaults['app.boatLoansCalculator.hero.description']
      }
    },
    howAndWhat: {
      item1: {
        title: {
          id: 'app.boatLoansCalculator.howAndWhat.item1.title',
          defaultMessage:
            enDefaults['app.boatLoansCalculator.howAndWhat.item1.title']
        },
        text: {
          id: 'app.boatLoansCalculator.howAndWhat.item1.text',
          defaultMessage:
            enDefaults['app.boatLoansCalculator.howAndWhat.item1.text']
        }
      },
      item2: {
        title: {
          id: 'app.boatLoansCalculator.howAndWhat.item2.title',
          defaultMessage:
            enDefaults['app.boatLoansCalculator.howAndWhat.item2.title']
        },
        text: {
          id: 'app.boatLoansCalculator.howAndWhat.item2.text',
          defaultMessage:
            enDefaults['app.boatLoansCalculator.howAndWhat.item2.text']
        }
      }
    },
    process: {
      title: {
        id: 'app.boatLoansCalculator.process.title',
        defaultMessage: enDefaults['app.boatLoansCalculator.process.title']
      },
      description: {
        id: 'app.boatLoansCalculator.process.description',
        defaultMessage:
          enDefaults['app.boatLoansCalculator.process.description']
      },
      logoAltText: {
        id: 'app.boatLoansCalculator.process.logoAltText',
        defaultMessage:
          enDefaults['app.boatLoansCalculator.process.logoAltText']
      },
      bullets: {
        item1: {
          title: {
            id: 'app.boatLoansCalculator.process.bullets.item1.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item1.title']
          },
          text: {
            id: 'app.boatLoansCalculator.process.bullets.item1.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item1.text']
          }
        },
        item2: {
          title: {
            id: 'app.boatLoansCalculator.process.bullets.item2.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item2.title']
          },
          text: {
            id: 'app.boatLoansCalculator.process.bullets.item2.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item2.text']
          },
          link: {
            id: 'app.boatLoansCalculator.process.bullets.item2.link',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item2.link']
          }
        },
        item3: {
          title: {
            id: 'app.boatLoansCalculator.process.bullets.item3.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item3.title']
          },
          text: {
            id: 'app.boatLoansCalculator.process.bullets.item3.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.process.bullets.item3.text']
          }
        }
      }
    },
    faq: {
      title: {
        id: 'app.boatLoansCalculator.faq.title',
        defaultMessage: enDefaults['app.boatLoansCalculator.faq.title']
      },
      items: {
        item1: {
          title: {
            id: 'app.boatLoansCalculator.faq.items.item1.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item1.title']
          },
          text: {
            id: 'app.boatLoansCalculator.faq.items.item1.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item1.text']
          }
        },
        item2: {
          title: {
            id: 'app.boatLoansCalculator.faq.items.item2.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.title']
          },
          text: {
            id: 'app.boatLoansCalculator.faq.items.item2.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.text']
          },
          subTitle: {
            id: 'app.boatLoansCalculator.faq.items.item2.subTitle',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.subTitle']
          },
          bullet1: {
            id: 'app.boatLoansCalculator.faq.items.item2.bullet1',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.bullet1']
          },
          bullet2: {
            id: 'app.boatLoansCalculator.faq.items.item2.bullet2',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.bullet2']
          },
          bullet3: {
            id: 'app.boatLoansCalculator.faq.items.item2.bullet3',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.bullet3']
          },
          bullet4: {
            id: 'app.boatLoansCalculator.faq.items.item2.bullet4',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item2.bullet4']
          }
        },
        item3: {
          title: {
            id: 'app.boatLoansCalculator.faq.items.item3.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item3.title']
          },
          text: {
            id: 'app.boatLoansCalculator.faq.items.item3.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item3.text']
          }
        },
        item4: {
          title: {
            id: 'app.boatLoansCalculator.faq.items.item4.title',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item4.title']
          },
          text: {
            id: 'app.boatLoansCalculator.faq.items.item4.text',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item4.text']
          },
          link: {
            id: 'app.boatLoansCalculator.faq.items.item4.link',
            defaultMessage:
              enDefaults['app.boatLoansCalculator.faq.items.item4.link']
          }
        }
      }
    }
  },
  boatLoansLeads: {
    getPreQualified: {
      form: {
        instruction: {
          id: 'app.boatLoansLeads.getPreQualified.form.instruction',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.instruction']
        },
        loanAmount: {
          id: 'app.boatLoansLeads.getPreQualified.form.loanAmount',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.loanAmount']
        },
        loanAmountError: {
          id: 'app.boatLoansLeads.getPreQualified.form.loanAmountError',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.loanAmountError'
            ]
        },
        ficoScore: {
          id: 'app.boatLoansLeads.getPreQualified.form.ficoScore',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.ficoScore']
        },
        ficoScoreError: {
          id: 'app.boatLoansLeads.getPreQualified.form.ficoScoreError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.ficoScoreError']
        },
        belowScore: {
          id: 'app.boatLoansLeads.getPreQualified.form.belowScore',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.belowScore']
        },
        name: {
          id: 'app.boatLoansLeads.getPreQualified.form.name',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.name']
        },
        nameError: {
          id: 'app.boatLoansLeads.getPreQualified.form.nameError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.nameError']
        },
        state: {
          id: 'app.boatLoansLeads.getPreQualified.form.state',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.state']
        },
        stateError: {
          id: 'app.boatLoansLeads.getPreQualified.form.stateError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.stateError']
        },
        email: {
          id: 'app.boatLoansLeads.getPreQualified.form.email',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.email']
        },
        emailError: {
          id: 'app.boatLoansLeads.getPreQualified.form.emailError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.emailError']
        },
        phone: {
          id: 'app.boatLoansLeads.getPreQualified.form.phone',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.phone']
        },
        phoneError: {
          id: 'app.boatLoansLeads.getPreQualified.form.phoneError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.phoneError']
        },
        purchaseTimeframe: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeframe',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeframe'
            ]
        },
        purchaseTimeframeError: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeframeError',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeframeError'
            ]
        },
        purchaseTimeFrameRightAway: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameRightAway',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameRightAway'
            ]
        },
        purchaseTimeFrame3Months: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrame3Months',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrame3Months'
            ]
        },
        purchaseTimeFrameWithin3Months: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameWithin3Months',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameWithin3Months'
            ]
        },
        purchaseTimeFrameGreater6Months: {
          id: 'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameGreater6Months',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.form.purchaseTimeFrameGreater6Months'
            ]
        },
        formError: {
          id: 'app.boatLoansLeads.getPreQualified.form.formError',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.formError']
        },
        buttonText: {
          id: 'app.boatLoansLeads.getPreQualified.form.buttonText',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.buttonText']
        },
        marketingOptIn: {
          id: 'app.boatLoansLeads.getPreQualified.form.marketingOptIn',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.form.marketingOptIn']
        }
      },
      modal: {
        financing: {
          id: 'app.boatLoansLeads.getPreQualified.modal.financing',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.modal.financing']
        },
        poweredBy: {
          id: 'app.boatLoansLeads.getPreQualified.modal.poweredBy',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.modal.poweredBy']
        },
        privacy: {
          id: 'app.boatLoansLeads.getPreQualified.modal.privacy',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.modal.privacy']
        },
        success: {
          id: 'app.boatLoansLeads.getPreQualified.modal.success',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.modal.success']
        },
        close: {
          id: 'app.boatLoansLeads.getPreQualified.modal.close',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.modal.close']
        }
      },
      card: {
        month: {
          id: 'app.boatLoansLeads.getPreQualified.card.month',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.card.month']
        },
        text1: {
          id: 'app.boatLoansLeads.getPreQualified.card.text1',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.card.text1']
        },
        text2: {
          id: 'app.boatLoansLeads.getPreQualified.card.text2',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.card.text2']
        },
        buttonText: {
          id: 'app.boatLoansLeads.getPreQualified.card.buttonText',
          defaultMessage:
            enDefaults['app.boatLoansLeads.getPreQualified.card.buttonText']
        }
      },
      calculator: {
        main: {
          monthlyPayment: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.main.monthlyPayment',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.main.monthlyPayment'
              ]
          },
          totalLoanAmount: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.main.totalLoanAmount',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.main.totalLoanAmount'
              ]
          }
        },
        form: {
          purchasePrice: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.purchasePrice',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.purchasePrice'
              ]
          },
          purchasePricePlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.purchasePricePlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.purchasePricePlaceholder'
              ]
          },
          downPayment: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.downPayment',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.downPayment'
              ]
          },
          downPaymentPlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.downPaymentPlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.downPaymentPlaceholder'
              ]
          },
          loanAmount: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.loanAmount',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.loanAmount'
              ]
          },
          desiredMonthlyPayment: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.desiredMonthlyPayment',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.desiredMonthlyPayment'
              ]
          },
          desiredMonthlyPaymentPlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.desiredMonthlyPaymentPlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.desiredMonthlyPaymentPlaceholder'
              ]
          },
          loanTermYears: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.loanTermYears',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.loanTermYears'
              ]
          },
          loanTermYearsPlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.loanTermYearsPlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.loanTermYearsPlaceholder'
              ]
          },
          loanTermMonths: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.loanTermMonths',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.loanTermMonths'
              ]
          },
          loanTermMonthsPlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.loanTermMonthsPlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.loanTermMonthsPlaceholder'
              ]
          },
          interestRate: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.interestRate',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.interestRate'
              ]
          },
          interestRatePlaceholder: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.interestRatePlaceholder',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.interestRatePlaceholder'
              ]
          },
          missingRequiredField: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.missingRequiredField',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.missingRequiredField'
              ]
          },
          calculateButton: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.form.calculateButton',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.form.calculateButton'
              ]
          }
        },
        result: {
          monthlyPayment: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.monthlyPayment',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.monthlyPayment'
              ]
          },
          totalLoanAmount: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.totalLoanAmount',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.totalLoanAmount'
              ]
          },
          readyNextStep: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.readyNextStep',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.readyNextStep'
              ]
          },
          or: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.or',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.or'
              ]
          },
          applyNowButton: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.applyNowButton',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.applyNowButton'
              ]
          },
          getPreQualButton: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.getPreQualButton',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.getPreQualButton'
              ]
          },
          disclaimerBDP: {
            id: 'app.boatLoansLeads.getPreQualified.calculator.result.disclaimerBDP',
            defaultMessage:
              enDefaults[
                'app.boatLoansLeads.getPreQualified.calculator.result.disclaimerBDP'
              ]
          }
        }
      },
      paymentCalculator: {
        title: {
          id: 'app.boatLoansLeads.getPreQualified.paymentCalculator.title',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.paymentCalculator.title'
            ]
        },
        srpTitle: {
          id: 'app.boatLoansLeads.getPreQualified.paymentCalculator.srpTitle',
          defaultMessage:
            enDefaults[
              'app.boatLoansLeads.getPreQualified.paymentCalculator.srpTitle'
            ]
        }
      }
    }
  }
});
